/**
 * @class 	statCompilerDashboard
 * @brief 	The grid statCompilerDashboard library is responsible for parsing and displaying data for STATcompiler.
 * @details
 * @version 	0.1
 * @date 	07/20/2014
 */
var statCompilerDashboard = (function () {
  //////////////////////////////////////////////////
  //	Variables used to store raw and sorted data
  //  for manipulation.
  //////////////////////////////////////////////////
  var count = 0;
  /**
   * @brief	A string containing the Region name. Used for comparing Char Cats.
   */
  var _strRegionCharCat = Config.getUniversalString('region');

  /**
   * @brief	A string containing the "Total" name. Used for getting data when creating map info.
   */
  var _strTotalConstant = 'Total';

  /**
   * @brief	A string containing the "Total" name. Used for getting data when creating map info.
   */
  var _strTotalTotalConstant = 'Total:Total';

  /**
   *	CONFIDENCE_INTERVAL: Type for the Confidence Interval Object.
   */
  var CONFIDENCE_INTERVAL = {
    Low: 'Low',
    High: 'High',
  };

  /**
   * @brief	A string used as the placeholder label for conflicting subregions in Indicators jstree selection.
   */
  const _strSubnationalConst = 'Subnational';

  /**
   * @brief	A string used as the placeholder label for undefined subregions in Indicators jstree selection.
   */
  const _strOtherConst = 'Other';

  /**
   * @brief	An integer containing the maximum width of a bar in column charts.
   */
  var _maxBarWidth = 350;

  /**
   * @brief	This contains the raw data obtained by the API.
   */
  var _arrRawData = [];

  /**
   * @brief	This name/value array contains data sorted by countries (ascending) and surveys (ascending).
   */
  var _arrSortedCountriesSurveys = [];

  /**
   * @brief	This name/value array contains data sorted by Indicators, Char Cats and Char Labels.
   */
  var _arrSortedIndicators = [];

  /**
   * @brief	This name/value array contains data sorted by Char Cats and Char Labels
   */
  var _arrSortedCharLabels = [];

  /**
   * @brief	This name/value array contains data sorted by Indicators and ByVariable Labels.
   */

  Object.defineProperty(window, '_arrSortedByVariableLabels', {
    configurable: false,
    enumerable: false,
    writable: false, // The value MAY NOT be changed by assignment, eg. _arrSortedByVariableLabels = []. The values must be morphed in place
    value: [],
  });

  // Below we are overloading the push method on the array. This functions the same as native, except also updates the byVariableState object.
  // As a note, this now effectively becomes the only way to change the values in the array.
  Object.defineProperty(window._arrSortedByVariableLabels, 'push', {
    configurable: false,
    enumerable: false, // don't allow value to appear when iterating over object
    writable: false,
    value: function () {
      for (var i = 0, n = this.length, l = arguments.length; i < l; i++, n++) {
        this[n] = arguments[i];
        new byVariableState(this);
      }
      return n;
    },
  });

  /**
   * @brief	This name/value array contains the Confidnce Intervals sorted by
   *			Countries, Surveys, Indicators, Char Cats and Char Labels.
   *			NOTE: Each Confidence Interval is an object containing a low and a high value.
   */
  var _arrSortedConfidenceIntervals = [];

  /**
   * @brief	This name/value array contains the Denominators weighted and unweighted sorted by
   *			Countries, Surveys, Indicators, Char Cats and Char Labels.
   *			NOTE: Each Denominator is an object containing a weigthed and a unweighted value.
   */
  var _arrSortedDenominators = [];

  /**
   * @brief	This name/value array contains data sorted by Countries, Surveys and Regions.
   */
  var _arrSortedRegions = [];

  /**
   * @brief	This name/value array contains data Indicators / Name of Total Char Cat.
   */
  var _arrSortedTotals = [];

  /**
   * @brief	This name/value array contains data sorted by Countries, Surveys and Regions.
   */
  var _arrTotals = [];

  /**
   * @brief	This name/value array contains all indicators attributed with a total.
   */
  var _objTotalsRegistry = {};

  /**
   * @brief	This name/value array contains all indicators attributed with a Denominators.
   */
  var _objDenominatorRegistry = {};

  /**

	/**
	 * @brief	This name/value array contains all indicators attributed with a Special.
	 */
  var _objSpecialRegistry = {};

  /**
   * @brief	This name/value array contains data "values" sorted by Countries/Surveys/Indicators/Char Cats/Char Labels
   */
  var _arrValues = [];

  /**
   * @brief	This name/value array contains precision "values" sorted by Indicator.
   */
  var _arrPrecision = [];

  /**
   * @brief	This name/value array contains meta data sorted by Indicators.
   */
  var _arrMetaData = [];

  /**
   * @brief	This object specifies the year range of all the surveys in data.
   */
  var _objSurveyRange = {};

  /**
   * @brief	This array keeps the name of all countries that are loaded yet unselected.
   */
  var _arrUnSelectedCountries = [];

  var _currArrSelectedCountries = [];

  //////////////////////////////////////////////////
  //	Variables used to store data for various
  //	display formats.
  //////////////////////////////////////////////////

  /**
   * @brief This specifies the HTML table element that JQGRID is in.
   */
  var _gridElement;

  /**
   * @brief This contains the data reflecting the current grid structure.
   */
  var _arrGridData = [];

  /**
   * @brief This contains the column names required for jqgrid.
   */
  var _arrColNames = [];

  /**
   * @brief This contains the column model required for jqgrid.
   */
  var _arrColModel = [];

  /**
   * @brief This contains the column names required for jqgrid model.
   */
  var _arrColModelNames = [];

  /**
   * @brief This contains the IDs of the indicators and denominators that are currently in jqgrid
   */
  var _arrColModelIDs = [];

  /**
   * @brief This contains the definitions for grouping headers for jqgrid. NOTE: We have three levels.
   */
  var _arrGroupHeadersLevel1 = [];

  /**
   * @brief This contains the definitions for grouping headers for jqgrid. NOTE: We have three levels.
   */
  var _arrGroupHeadersLevel2 = [];

  /**
   * @brief This contains the definitions for grouping headers for jqgrid. NOTE: We have three levels.
   */
  var _arrGroupHeadersLevel3 = [];

  /**
   * @brief This specifies the div element that HighCharts uses to create the graphs in.
   */
  var _highChartsElement;

  /**
   * @brief This contains the Category Names for the Column High Charts.
   */
  var _arrHighChartsColumnCategories = [];

  /**
   * @brief This contains the Series Names for a Column High Charts display.
   */
  var _arrHighChartsColumnSeriesNames = [];

  /**
   * @brief An object of arrays, with each array specifying the values for that particular series.
   */
  var _arrHighChartsColumnSeriesValues = {};

  /**
   * @brief This contains the Category Names for the Line High Charts.
   */
  var _arrHighChartsLineCategories = [];

  /**
   * @brief This contains the Series Names for a Line High Charts display.
   */
  var _arrHighChartsLineSeriesNames = [];

  /**
   * @brief An object of arrays, with each array specifying the values for that particular series.
   */
  var _arrHighChartsLineSeriesValues = {};

  /**
   * @brief This contains the Series Names for the Confidence Intervals Line High Charts display.
   */
  var _arrHighChartsLineCISeriesNames = [];

  /**
   * @brief An object of arrays, with each array specifying the values for that particular Confidence Interval series (Line).
   */
  var _arrHighChartsLineCISeriesValues = {};

  /**
   * @brief This contains the Series Names for the Confidence Intervals Column High Charts display.
   */
  var _arrHighChartsColumnCISeriesNames = [];

  /**
   * @brief An object of arrays, with each array specifying the values for that particular Confidence Interval series (Column).
   */
  var _arrHighChartsColumnCISeriesValues = {};

  /**
   * @brief This specifies whether the data actually has confidence intervals or not.
   */
  var _bHighChartsHasConfidenceIntervals = false;

  /**
   * @brief This specifies whether the confidence interval series data is visible or not.
   */
  var _bHighChartsConfidenceIntervalsVisible = true;

  /**
   * @brief This specifies whether the grid lines are enabled or not.
   */
  var _bHighChartsGridEnabled = false;

  /**
   * @brief This specifies whether the data points are enabled or not.
   */
  var _bHighChartsDataPointsEnabled = true;

  /**
   * @brief This specifies whether the labels on the Y-Axis are enabled or not.
   */
  var _bHighChartsYAxisLabelEnabled = false;

  /**
   * @brief This specifies whether the legend is enabled or not.
   */
  var _bHighChartsLegendEnabled = true;

  /**
   * @brief This specifies whether the Y-Axis is enabled to be set to 100% if the indicator is a percent.
   */
  var _bHighChartsYAxisToMaxEnabled = true;

  /**
   * @brief This specifies whether the Weighted Denominators is enabled and to be show in the data table.
   */
  var _bDisplayWeightedDenominators = false;

  /**
   * @brief This specifies whether the Unweighted Denominators is enabled and to be show in the data table.
   */
  var _bDisplayUnweightedDenominators = false;
  /**
   * @brief This specifies whether the Totals are enabled and to be show in the data table.
   */
  var _bDisplayTotals = false;
  /**
   * @brief This specifies whether the Specails Indicators are enabled and to be show in the data table.
   */
  var _bDisplaySpecialIndicators = false;

  /**
   * @brief This specifies whether the Specails Indicators are enabled and to be show in the data table.
   */
  var _bDisplaySpecialIndicatorsClicked = false;

  /**
   * @brief This specifies the precision with which the values are displayed.
   */
  var _nHighChartsPrecision = 0;

  /**
   * @brief This specifies the minimum Y Axis Value.
   */
  var _nHighChartsMinYValue = 0;

  /**
   * @brief This specifies the maximum Y Axis Value.
   */
  var _nHighChartsMaxYValue = 0;

  /**
   * @brief A PIVOT_TYPE specifying what the current pivot type is.
   */
  var _curPivotType = '';

  /**
   * @brief A string specifying what the current display type is.
   */
  // 	var _curDisplayType = "";
  window._curDisplayType = '';

  /**
   * @brief This specifies the select element that the list of indicators is in.
   */
  var _lstIndicators;

  /**
   * @brief This specifies the div element that jstree uses to create the tree of char cats / char labels in.
   */
  var _lstCharLabels;

  /**
   * @brief This specifies the div element that jstree uses to create the countries list in.
   */
  var _lstCountries;

  /**
   * @brief This specifies the select element that is used to choose the pivot option.
   */
  var _pivotDropDownElement;

  /**
   * @brief A string specifying the currently selected indicator in the drop down.
   */
  var _strSelectedIndicator = '';

  /**
   * @brief A string specifying the currently selected indicator code in the drop down.
   */
  var _strSelectedIndicatorCode = '';

  /**
   * @brief A string specifying the currently selected indicator for the info window.
   */
  var _strInfoIndicator = '';

  /**
   * @brief A string specifying the currently selected indicator for the info window by ID.
   */
  var _strInfoIndicatorId = '';

  /**
   * @brief A string specifying the currently selected geoography type for the map/bookmark.
   */

  var _nCurMapLevelRank = 0;

  /**
   * @brief A string specifying the currently selected break type for the map/bookmark.
   */

  let _strCurBreakType = 'Natural';

  /**
   * @brief A string specifying the currently selected break type for the map/bookmark.
   */

  let _arrCustomBreaks = [
    [
      { breakLevel: 1, value: '' },
      { breakLevel: 2, value: '' },
    ],
    [
      { breakLevel: 1, value: '' },
      { breakLevel: 2, value: '' },
      { breakLevel: 3, value: '' },
    ],
    [
      { breakLevel: 1, value: '' },
      { breakLevel: 2, value: '' },
      { breakLevel: 3, value: '' },
      { breakLevel: 4, value: '' },
    ],
    [
      { breakLevel: 1, value: '' },
      { breakLevel: 2, value: '' },
      { breakLevel: 3, value: '' },
      { breakLevel: 4, value: '' },
      { breakLevel: 5, value: '' },
    ],
  ];

  /**
   * @brief A variable specifying the div where the map will be displayed.
   */
  var _mapElement;

  /**
   * @brief A variable containing the esri map.
   */
  var _mapObject;

  /**
   * @brief An array of data required for displaying all national data on the map.
   *		  The data contains a nameValueLib array of Countries/Surveys/Values.
   *		  The data is for all the surveys.
   */
  var _arrNationalAllMapData = [];

  /**
   * @brief An array of data required for displaying all confidence intervals for
   *		  national data on the map. The data contains a nameValueLib array
   *		  of Countries/Surveys/Values/low-high. The data is for all the surveys.
   */
  var _arrNationalAllMapCIData = [];

  /**
   * @brief An array of data required for displaying selected national data on the map.
   *		  The data contains a nameValueLib array of Countries/Survey/Values.
   *		  The data is only for the survey displayed.
   */
  var _arrNationalMapData = [];

  /**
   * @brief An array of data required for displaying selected confidence intervals for
   *		  national data on the map. The data contains a nameValueLib array
   *		  of Countries/Surveys/Values/low-high. The data is for all the surveys.
   */
  var _arrNationalMapCIData = [];

  /**
   * @brief An array containing all the national values for the particular label. Used for creating legend.
   */
  var _arrNationalMapValues = [];

  /**
   * @brief An array of data required for displaying subnational data on the map.
   *		  The data contains a nameValueLib array of Countries/Surveys/Regions/Values.
   */
  var _arrSubnationalMapData = [];

  /**
   * @brief An array of data required for displaying subnational Confidence Interval data on the map.
   *		  The data contains a nameValueLib array of Countries/Surveys/Regions/Values/low-high.
   */
  var _arrSubnationalMapCIData = [];

  /**
   * @brief An array containing all the subnational values for the particular label. Used for creating legend.
   */
  var _arrSubnationalMapValues = [];

  /**
   * @brief An array containing all the custom values for the particular country.
   */

  var _customObjCountryValues = [];
  /**
   * @brief An array containing all the subnational values for the particular label for every survey. Used for creating legend.
   */

  var _arrSubnationalAllMapData = [];
  /**
   * @brief An array containing all the subnational ci values for the particular label for every survey. Used for creating legend.
   */
  var _arrSubnationalAllMapCIData = [];

  /**
   * @brief A string specifying the current Char Cat used for mapping.
   */
  var _strCurMapCharCat;

  /**
   * @brief A string specifying the current char label used for mapping.
   */
  var _strCurMapCharLabel;

  /**
   * @brief A string specifying to export to PDF or PNG
   */

  var _strExportType = 'PNG';
  /**
   * @brief A string specifying the current survey year range being used.
   */
  var _strCurYearRange = {};

  /**
   * @brief An array specifying the current survey selected for Custom Survey
   * 		  Selections for all views except the map.
   */
  var _arrCustomSurveySelections = [];

  /**
   * @brief An array specifying the current survey selected for the Map.
   */
  var _arrCustomSurveySelectionsMap = [];

  /**
   * @brief A boolean representing whether a map has already been created or not.
   */
  var _bMapInitialized = false;

  /**
   * @brief This specified a div used to keep Mapping Controls.
   */
  var _mapControlsDiv;

  /**
   * @brief A boolean representing whether the entire dashboard has been initialized or not.
   */
  var _bDashboardInitialized = false;

  /**
   * @brief A boolean representing whether the data has been updated or not. Used in the UpdatedDashboard function.
   */
  var _bDataUpdated = false;

  /**
   * @brief A boolean determining whether regional data is selected as well.
   */
  var _bRegionalDataSelected = false;

  /**
   * @brief A boolean determining whether total data is selected as well.
   */
  var _bTotalDataSelected = false;

  /**
   * @brief A SURVEY_SELECTION type specifying the type of surveys selection made.
   */
  var _curSurveySelection = '';

  /**
   * @brief A SURVEY_SELECTION type specifying the type of surveys selection made for the grid
   *		 and the column chart.
   */
  var _curDefaultSurveySelection = '';

  /**
   * @brief A SURVEY_SELECTION type specifying the type of surveys selection made for the line chart.
   */
  var _curLineChartSurveySelection = '';

  /**
   * @brief A SURVEY_SELECTION type specifying the type of surveys selection made for the Map View.
   */
  var _curMapSurveySelection = '';

  /**
   * @brief Set date for chart citation.
   */
  var _date = new Date();

  /**
   * @brief Months for the year.
   */

  var _arrMonthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  var _arrHighChartsColors = [
    '#7cb5ec',
    '#f7a35c',
    '#90ed7d',
    '#d9d9d9',
    '#8085e9',
    '#f15c80',
    '#e4d354',
    '#2b908f',
    '#f45b5b',
    '#91e8e1',
  ];

  var gridIntroInit = false;

  /**
   * @brief Keeps a record of which indicators are currently selected. Ordered by selection.
   */
  var _selectedIndicatorDropdown = [];

  /**
   * @fn 		_getValidColorForChart
   * @brief 	Function to obtain a valid hex color for high charts.
   * @detail 	Function automatically determines a valid color for the index.
   * @param 	index: An index for which the color is needed.
   * @return 	A string containing the hex value of the color.
   */

  var _getValidColorForChart = function (index) {
    return _arrHighChartsColors[index % _arrHighChartsColors.length];
  };

  /**
   * @fn 		_existsInGroupHeader
   * @brief 	Function to check whether an item aleady exists in the group header.
   * @detail 	function compares the startColumnName and titleText attributes to find a match.
   * @param 	objGroup: An array of group header objects.
   * @param 	startcolumnName: The starting column name to look for.
   * @return 	A boolean set to true if found, otherwise false.
   */

  var _existsInGroupHeader = function (arrGroupHeaders, objGroup) {
    //Try and find an object with the correct attribute value.
    for (var i = 0, len = arrGroupHeaders.length; i < len; i++) {
      if (
        arrGroupHeaders[i].titleText === objGroup.titleText &&
        arrGroupHeaders[i].startColumnName === objGroup.startColumnName
      )
        return true; // Return true as soon as the object is found
    }

    // The object was not found.
    return false;
  };

  /**
   * @fn 		_getVerifiedColumnName
   * @brief 	Function to obtain the correct column name from the array.
   * @detail 	If a column already exists, a suffix is added to the new column name.
   * @param 	objSuffix: An object containing all the column names and the last suffix used.
   * @param 	columnName: The original column name.
   * @return 	A string representing the correct column name.
   */
  //??//  Below objSuffix is an argument! It cannot add values to itself and maintain on iterations.
  //??//  The string value of the column name should not be used to determine existince in a map
  //??//
  //??//
  //??//
  //??//  SB - 2017-12-21
  // 	window._getVerifiedColumnName__objSuffix = {};
  var _getVerifiedColumnName = function (objSuffix, columnName) {
    //If the column name does not exist.
    if (typeof objSuffix[columnName] == 'undefined') {
      //Create an entry for the column name with suffix as 1.
      objSuffix[columnName] = 0;
      return columnName;
    } else {
      //Obtain the current suffix, increment and return it.
      var newSuffix = objSuffix[columnName];
      newSuffix++;
      objSuffix[columnName] = newSuffix;
      return columnName + '_' + newSuffix.toString();
    }
  };

  /**
   * @fn 		_columnExistsInModel
   * @brief 	Function to check whether any model in the array already contains the particular column name.
   * @param 	colModel: The array of Column Models.
   * @param 	colName: The value to look for in the column model array
   * @param 	colId: The value to look for in the column model array
   * @return 	A boolean specifying true if it exists, false otherwise.
   */
  var _columnExistsInModel = function (colModelArray, colName, colId = '') {
    var uniqueNameAlias = `${colName.replace(/\s/g, '')}${
      colId ? `_${colId}` : ''
    }`;
    if (_arrColModelNames.indexOf(uniqueNameAlias) == -1) {
      _arrColModelNames.push(uniqueNameAlias);
      return false;
    } else {
      return true;
    }
  };

  /**
	 * @fn 		_addColumn
	 * @brief 	Adds a column for JQGrid.
	 * @param 	columnName: The column name to add.

	 * @return 	void.
	 */
  var _addColumn = function (
    columnName,
    isHidden,
    bLeftAligned,
    dataType,
    isIndicator,
    columnId,
    denomsAvailable
  ) {
    if (!_columnExistsInModel(_arrColModel, columnName, columnId)) {
      //Set current Data Type.
      var text = '';
      var curDataType = dataType;
      if (isIndicator) {
        if (denomsAvailable) {
          text =
            '<span class="iconInfoLabel"><i>' +
            columnName +
            '</i></span>' +
            '<span class="iconInfo" style="background-color:#808080" onclick="showIndicatorMetaDataInfo(\'' +
            columnName.replace(/'/g, "\\'") +
            "','" +
            columnId +
            '\', event)"></span>';
        } else {
          text =
            '<span class="iconInfoLabel">' +
            columnName +
            '</span>' +
            '<span class="iconInfo" style="background-color:#808080" onclick="showIndicatorMetaDataInfo(\'' +
            columnName.replace(/'/g, "\\'") +
            "','" +
            columnId +
            '\', event)"></span>';
        }
      } else {
        text = columnName;
      }

      //If dataType is undefined, set it to text.
      if (typeof curDataType === 'undefined') {
        curDataType = 'text';
      }

      //Add column to the Column Names Array.
      var strDisplayName = text.replace(/_[0-9]+/g, '');
      _arrColNames.push(strDisplayName);
      //Add column to the Column Model Array.
      var objColModel = {};
      objColModel['name'] = `${columnName.replace(/\s/g, '')}${
        columnId ? `_${columnId}` : ''
      }`;
      objColModel['alias'] = columnId;
      //objColModel["index"] = columnName;
      objColModel['width'] = 155;
      objColModel['editable'] = false;
      objColModel['hidden'] = isHidden;
      if (typeof bLeftAligned != 'boolean') {
        objColModel['align'] = 'center';
      } else {
        if (bLeftAligned) {
          objColModel['align'] = 'left';
        } else {
          objColModel['align'] = 'center';
        }
      }
      objColModel['sorttype'] = curDataType; //Set Data Type to provide the correct sorting method.
      _arrColModel.push(objColModel);
    }
  };

  /**
   * @fn 		_addGroupHeader
   * @brief 	Adds a group header for certain columns for JQGRID.
   * @param 	groupName: 			The group name to add.
   * @param 	startColumnName: 	Column name specifying the start sub column for the group.
   * @param 	numberOfColumns: 	A number specifying how many columns to group under this group name.
   * @param 	level: 				Specifies whether this is a first level or second level grouping.
   * @param 	strIndicatorName:  Indicator name for metadata popup
   * @return 	void.
   */
  var _addGroupHeader = function (
    groupName,
    startColumnName,
    numberOfColumns,
    level,
    pivot,
    indicatorID,
    denomsAvailable
  ) {
    //Add column to the Column Model Array.
    var objGroupHeader = {};
    objGroupHeader['startColumnName'] = startColumnName.replace(/\s/g, '');
    objGroupHeader['numberOfColumns'] = numberOfColumns;
    objGroupHeader['titleText'] = groupName;

    if (level === 1) {
      if (pivot !== 'indChar') {
        if (denomsAvailable) {
          objGroupHeader['titleText'] =
            '<span class="iconInfoLabel"><i>' +
            groupName +
            '</i></span>' +
            '<span class="iconInfo" style="background-color:#808080" onclick="showIndicatorMetaDataInfo(\'' +
            groupName.replace(/'/g, "\\'") +
            "','" +
            indicatorID +
            '\', event)"></span>';
        } else {
          objGroupHeader['titleText'] =
            '<span class="iconInfoLabel">' +
            groupName +
            '</span>' +
            '<span class="iconInfo" style="background-color:#808080" onclick="showIndicatorMetaDataInfo(\'' +
            groupName.replace(/'/g, "\\'") +
            "','" +
            indicatorID +
            '\', event)"></span>';
        }
      } else {
        objGroupHeader['titleText'] =
          '<span class="iconInfoLabel">' + groupName + '</span>';
      }
      //Make sure you are not adding a duplicate header.
      if (!_existsInGroupHeader(_arrGroupHeadersLevel1, objGroupHeader)) {
        _arrGroupHeadersLevel1.push(objGroupHeader);
      }
      //} else if((level == 2) && (objGroupHeader.titleText.length > 0)) {
    } else if (level == 2) {
      //Make sure you are not adding a duplicate header.
      if (!_existsInGroupHeader(_arrGroupHeadersLevel2, objGroupHeader)) {
        _arrGroupHeadersLevel2.push(objGroupHeader);
      }
    } else if (level == 3) {
      //Make sure you are not adding a duplicate header.
      if (!_existsInGroupHeader(_arrGroupHeadersLevel3, objGroupHeader)) {
        _arrGroupHeadersLevel3.push(objGroupHeader);
      }
    }
  };

  /**
   * @fn 		_resetGridDisplayData
   * @brief 	Resets all the data arrays related to the grid. Call when loading/reloading grid.
   * @return 	void.
   */
  var _resetGridDisplayData = function () {
    //Reset all the private variables.
    _arrGridData = [];
    _arrColNames = [];
    _arrColModel = [];
    _arrColModelNames = [];
    _arrColModelIDs = [];
    _arrGroupHeadersLevel1 = [];
    _arrGroupHeadersLevel2 = [];
    _arrGroupHeadersLevel3 = [];
  };

  /**
   * @fn 		_resetColumnGraphDisplayData
   * @brief 	Resets all the data arrays. Call when loading/reloading charts.
   * @return 	void.
   */
  var _resetColumnGraphDisplayData = function () {
    //Reset all the private variables.
    _arrHighChartsColumnSeriesNames = [];
    _arrHighChartsColumnCategories = [];
    _arrHighChartsColumnSeriesValues = {};
    _arrHighChartsColumnCISeriesNames = [];
    _arrHighChartsColumnCISeriesValues = {};
    _nHighChartsMinYValue = 0;
    _nHighChartsMaxYValue = 0;
    _bHighChartsHasConfidenceIntervals = false;
  };

  /**
   * @fn 		_resetLineGraphDisplayData
   * @brief 	Resets all the data arrays. Call when loading/reloading charts.
   * @return 	void.
   */
  var _resetLineGraphDisplayData = function () {
    //Reset all the private variables.
    _arrHighChartsLineSeriesNames = [];
    _arrHighChartsLineCategories = [];
    _arrHighChartsLineSeriesValues = {};
    _arrHighChartsLineCISeriesNames = [];
    _arrHighChartsLineCISeriesValues = {};
    _nHighChartsMinYValue = 0;
    _nHighChartsMaxYValue = 0;
    _bHighChartsHasConfidenceIntervals = false;
  };

  /**
   * @fn 		_resetControlPanelData
   * @brief 	Resets all the data arrays for the control panel.
   * @return 	void.
   */
  var _resetControlPanelData = function () {
    //Reset all the private variables.
    _arr;
  };

  /**
   * @fn 		_resetDisplay
   * @brief 	Resets the display div. Use before updating/changing the display.
   * @return 	void.
   */
  var _resetDisplay = function () {
    //alert(_curDisplayType)
    //If display is of type chart, then unload the chart if it exists.
    if (
      _curDisplayType == statCompilerDashboard.DISPLAY_TYPE.Column ||
      _curDisplayType == statCompilerDashboard.DISPLAY_TYPE.Line
    ) {
      if (typeof $(_highChartsElement).highcharts() != 'undefined')
        $(_highChartsElement).highcharts().destroy();
    }
    //If display is a grid, unload the grid.
    else if (_curDisplayType == statCompilerDashboard.DISPLAY_TYPE.Grid) {
      $(_gridElement).jqGrid('GridUnload');
    } else if (_curDisplayType == statCompilerDashboard.DISPLAY_TYPE.Map) {
      document.getElementById('mapDiv').classList.add('hidden');

      //Hide the Map Controls and enable Char label Controls.
      $(_mapControlsDiv).hide();
      $(_lstCharLabels).show();
    }
  };

  /**
   * @fn 		_resetButtons
   * @brief 	Resets the active button. Use before updating/changing the display.
   * @return 	void.
   */
  var _resetButtons = function () {
    $('.topToolbar .tile').removeClass('active');
  };

  /**
   * @fn _toTitleCase
   * @brief 	Convert upper case to title case.
   * @return 	string converted to title case.
   */
  var _toTitleCase = function (str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };

  /**
   * @fn _getSelectedCharLabelIDs
   * @brief 	Function to go through all the arrays, obtain all the char cat ids selected and place them in one array.
   * @return 	returns an array containg the label IDs of all the selected labels. Empty array if none are selected.
   */
  var _getSelectedCharLabelIDs = function () {
    //Declare Array.
    var arrSelectedCharLabelIDs = [];

    //Go through the CharLabels array to find the selected labels.
    $.each(_arrSortedCharLabels, function (nCharCatIndex, objCharCat) {
      $.each(objCharCat.value, function (nCharLabelIndex, objCharLabel) {
        // If the value is selected.
        if (objCharLabel.value) {
          arrSelectedCharLabelIDs.push(objCharLabel.alias);
        }
      });
    });
    //Return Array.
    return arrSelectedCharLabelIDs;
  };

  /**
   * @fn _getSelectedCountryCodes
   * @brief 	Function to obtain all the selected country codes when reloading data.
   * @return 	returns an array containg the country codes of all the selected countries. Empty array if none are selected.
   */
  var _getSelectedCountryCodes = function () {
    //Declare Array.
    var arrSelectedCountryCodes = [];

    //Go through the Surveys array to find the selected countries.
    $.each(_arrSortedCountriesSurveys, function (nCountryIndex, objCountry) {
      $.each(objCountry.value, function (nSurveyIndex, objSurvey) {
        //If a survey is selected, add the country into the list of selected countries.
        if (objSurvey.value) {
          var objNewCountry = nameValueLib.createObject(
            objCountry.alias,
            '',
            true,
            false
          );
          arrSelectedCountryCodes.push(objNewCountry);

          //Exit out of the survey loop and move to the next country.
          return false;
        }
      });

      //Check if the country was added as a selected country. If not, add it as an unselected country.
      if (
        nameValueLib.objectExists(arrSelectedCountryCodes, [
          objCountry.alias,
        ]) == -1
      ) {
        var objNewCountry = nameValueLib.createObject(
          objCountry.alias,
          '',
          false,
          false
        );
        arrSelectedCountryCodes.push(objNewCountry);
      }
    });

    //Return Array.
    return arrSelectedCountryCodes;
  };

  /**
   * @fn _setupSortedData
   * @brief 	Parses the data to create all the various sorted arrays.
   * @param 	selectedLabelIDs: Provide an array of Label ID(s) to select once the data has been setup and sorted.
   *							  Pass an empty array if no labels are selected.
   * @return 	void
   */
  var _setupSortedData = function (selectedLabelIDs, selectedCountryCodes) {
    //Declare Important Variables.
    var strPrevCountry = '';
    var strCurCountry = '';
    var strPrevSurvey = '';
    var strCurCountryCode = '';
    var strCurSurvey = '';
    var strPrevIndicator = '';
    var strPrevIndicatorCode = '';
    var strCurIndicator = '';
    var strPrevCharCat = '';
    var strCurIndicatorCode = '';
    var strCurIndicatorOrder = '';
    var strCurCharCat = '';
    var strPrevCharLabel = '';
    var strCurCharLabel = '';
    var strCurCharLabelID = '';
    var strCurByVariableLabel = '';
    var strSurveyYear = '';
    var strRegionalID = '';
    var strValue = '';
    var strCILow = '';
    var strCIHigh = '';
    var strRegId = '';
    var nPrecision = 0;
    var nMinYear = 3000;
    var nMaxYear = 1900;
    var nIsTotal = 0;
    var strOldSelectedIndicator = _strSelectedIndicator; //Save the old indicator in case there is one.
    var strOldSelectedIndicatorCode = _strSelectedIndicatorCode; //Save the old indicator code in case there is one.
    var arrIndicatorOrder = []; //Used for making sure the Indicators are added according to their order.
    var arrCharLabelID = []; //Used for making sure the Char Categories are added according to their order.
    var arrSurveyOrder = [];
    var arrSurveysWithData = []; //Used to check which surveys have actual data and not just denominator data.
    //Local array used for making sure the surveys are in descending order.
    $('#TotalOption1 button').attr('disabled', false);
    $('#TotalOption1 button').addClass('checked');
    $('#TotalOption1 button').removeClass('unchecked');
    // _bDisplayTotals = true;
    // _bDisplaySpecialIndicators = true;
    //Reset Data Arrays.
    _arrSortedIndicators = [];
    _arrSortedCountriesSurveys = [];
    _arrSortedCharLabels = [];
    _arrSortedRegions = [];
    _arrValues = [];
    _arrNationalMapValues = [];
    _arrSubnationalMapValues = [];
    _strSelectedIndicator = '';
    _strSelectedIndicatorCode = '';
    // empty but don't reassign the variable
    _.remove(_arrSortedByVariableLabels, true);
    // _arrSortedByVariableLabels = []; <-- Don't do this! Property is not writable, so it would have no effect. Would throw error if in strict mode
    _arrSortedConfidenceIntervals = [];

    if (_arrRawData.length === 0) {
      addParametersPopup(
        '#parameterPopup2',
        'dataError',
        false,
        'Data Unavailable'
      );
    }
    //Initially parse raw data to populate the various storage arrays.
    for (var nIndex = 0; nIndex < _arrRawData.length; nIndex++) {
      //Get current row.
      var objRow = _arrRawData[nIndex];
      //Assign data to current variables.
      strCurCountry = objRow.CountryName;
      strCurCountryCode = objRow.DHS_CountryCode;
      strCurSurvey = objRow.SurveyYearLabel + ' ' + objRow.SurveyType;
      strSurveyYear = objRow.SurveyYear;
      strCurIndicator = objRow.Indicator;
      strCurIndicatorType = objRow.IndicatorType;
      strCurIndicatorCode = objRow.IndicatorId;
      strCurIndicatorOrder = objRow.IndicatorOrder;
      strCurCharCat = objRow.CharacteristicCategory;
      arrCurCountryUnselectedSurveys =
        nameValueLib.getValue(_arrCustomSurveySelections, [strCurCountry]) ||
        [];
      if (objRow.CharacteristicLabel.includes('..')) {
        strCurCharLabel = objRow.CharacteristicLabel.replace('..', '');
      } else if (objRow.CharacteristicLabel.includes('.')) {
        strCurCharLabel = objRow.CharacteristicLabel.replace('.', '');
      } else {
        strCurCharLabel = objRow.CharacteristicLabel;
      }
      // Use subregions specific to each nation if available, otherwise use as is
      if (
        objRow.CharacteristicCategory === Config.getUniversalString('region')
      ) {
        strCurCharLabel = objRow.LevelNa
          ? objRow.LevelNa + ' : ' + strCurCharLabel
          : strCurCharLabel;
      }

      // strCurCharLabelID = objRow.CharacteristicOrder; <---- This isn't unique!! So it can't be the id.
      strCurCharLabelID = objRow.CharacteristicId;

      // strCurByVariableLabel existence is tested against a length property, so ensure it is a string!!
      strCurByVariableLabel = objRow.ByVariableLabel.toString();
      strRegId = objRow.RegionId;
      strRegionalID = objRow.RegionId;

      nPrecision = objRow.Precision;
      nIsTotal = objRow.IsTotal;

      IsPreferred = objRow.IsPreferred;

      if (!byVariableState.indicator_id_map[strCurIndicatorCode]) {
        byVariableState.indicator_id_map[strCurIndicatorCode] = strCurIndicator;
      }

      if (!byVariableState.preferred_values[strCurIndicatorCode]) {
        if (IsPreferred && nIsTotal) {
          byVariableState.preferred_values[strCurIndicatorCode] =
            strCurByVariableLabel;
        }
      }

      //Set Value with the correct precision.
      var nTempValue = objRow.Value;
      strValue = nTempValue.toFixed(nPrecision);

      //Set Minimum Year.
      nMinYear = Math.min(nMinYear, strSurveyYear);

      //Set Maximum Year.
      nMaxYear = Math.max(nMaxYear, strSurveyYear);

      //Set CI Low.
      nTempValue = objRow.CILow;
      /*if(typeof nTempValue === 'undefined') {
				strCILow = "";
			}*/
      if (!isNaN(parseFloat(nTempValue)) && isFinite(nTempValue)) {
        //CI has a value
        //Set CI Value with the correct precision.
        strCILow = nTempValue.toFixed(nPrecision);
      } else {
        strCILow = '';
      }

      //Set CI High.
      nTempValue = objRow.CIHigh;
      /*if(typeof nTempValue === 'undefined') {
				strCIHigh = "";
			}*/
      if (!isNaN(parseFloat(nTempValue)) && isFinite(nTempValue)) {
        //CI has a value
        //Set CI Value with the correct precision.
        strCIHigh = nTempValue.toFixed(nPrecision);
      } else {
        strCIHigh = '';
      }

      /*
       *		Country - Survey - Indicator - Characteristics Categories - Char Label - By variable - Value
       */

      //Add Country to various arrays if it is a new country.
      if (!strPrevCountry.length || strPrevCountry != strCurCountry) {
        //Add Country to Countries/Surveys Array if it does not exist.
        if (
          nameValueLib.objectExists(_arrSortedCountriesSurveys, [
            strCurCountry,
          ]) == -1
        ) {
          var objTemp = nameValueLib.createObject(
            strCurCountry,
            strCurCountryCode,
            [],
            false
          );
          _arrSortedCountriesSurveys.push(objTemp);
        }

        //Add Country to Survey Orders Array if it does not exist.
        if (nameValueLib.objectExists(arrSurveyOrder, [strCurCountry]) == -1) {
          var objTemp = nameValueLib.createObject(
            strCurCountry,
            strCurCountryCode,
            [],
            false
          );
          arrSurveyOrder.push(objTemp);
        }

        //Add Country to Values Array if it does not exist.
        if (nameValueLib.objectExists(_arrValues, [strCurCountry]) == -1) {
          var objTemp = nameValueLib.createObject(strCurCountry, '', [], false);
          _arrValues.push(objTemp);
        }

        //Add Country to Regions Array if it does not exist.
        if (
          nameValueLib.objectExists(_arrSortedRegions, [strCurCountry]) == -1
        ) {
          var objTemp = nameValueLib.createObject(strCurCountry, '', [], false);
          _arrSortedRegions.push(objTemp);
        }

        //Add Country to Confidence Interval Array if it does not exist.
        if (
          nameValueLib.objectExists(_arrSortedConfidenceIntervals, [
            strCurCountry,
          ]) == -1
        ) {
          var objTemp = nameValueLib.createObject(strCurCountry, '', [], false);
          _arrSortedConfidenceIntervals.push(objTemp);
        }

        //Add Country to temporary Array that keeps track of whether a survey has valid data.
        if (
          nameValueLib.objectExists(arrSurveysWithData, [strCurCountry]) == -1
        ) {
          var objTemp = nameValueLib.createObject(strCurCountry, '', [], false);
          arrSurveysWithData.push(objTemp);
        }

        //Reset Survey if the country changes.
        strPrevSurvey = '';
      }
      strPrevCountry = strCurCountry;
      //Add Surveys to various arrays if it is a new survey.
      if (!strPrevSurvey.length || strPrevSurvey != strCurSurvey) {
        //Add Survey to Countries/Surveys Array if it does not exist.
        if (
          nameValueLib.objectExists(_arrSortedCountriesSurveys, [
            strCurCountry,
            strCurSurvey,
          ]) == -1
        ) {
          var arrSurveys = nameValueLib.getValue(_arrSortedCountriesSurveys, [
            strCurCountry,
          ]);

          //Check if country is selected or not in the list, enable the survey.
          var bCountrySelected = nameValueLib.getValue(selectedCountryCodes, [
            strCurCountryCode,
          ]);
          if (
            nameValueLib.objectExists(selectedCountryCodes, [
              strCurCountryCode,
            ]) == -1 ||
            bCountrySelected
          ) {
            let isSurveySelected = !arrCurCountryUnselectedSurveys.includes(
              parseInt(strSurveyYear)
            );

            var objTemp = nameValueLib.createObject(
              strCurSurvey,
              strSurveyYear,
              isSurveySelected,
              false
            );
          } else {
            var objTemp = nameValueLib.createObject(
              strCurSurvey,
              strSurveyYear,
              false,
              false
            );
            //Add country to the unselected array as well.
            if (_arrUnSelectedCountries.indexOf(strCurCountry) == -1) {
              _arrUnSelectedCountries.push(strCurCountry);
            }
          }

          arrSurveys.push(objTemp);
          arrSurveys.sort(compare);
        }

        //Add Survey to Values Array if it does not exist.
        if (
          nameValueLib.objectExists(_arrValues, [
            strCurCountry,
            strCurSurvey,
          ]) == -1
        ) {
          var arrSurveys = nameValueLib.getValue(_arrValues, [strCurCountry]);
          var objTemp = nameValueLib.createObject(strCurSurvey, '', [], false);
          arrSurveys.push(objTemp);
        }

        //Add Survey to Regions Array if it does not exist.
        if (
          nameValueLib.objectExists(_arrSortedRegions, [
            strCurCountry,
            strCurSurvey,
          ]) == -1
        ) {
          var arrSurveys = nameValueLib.getValue(_arrSortedRegions, [
            strCurCountry,
          ]);
          var objTemp = nameValueLib.createObject(strCurSurvey, '', [], false);
          arrSurveys.push(objTemp);
        }

        //Add Survey to Confidence Interval Array if it does not exist.
        if (
          nameValueLib.objectExists(_arrSortedConfidenceIntervals, [
            strCurCountry,
            strCurSurvey,
          ]) == -1
        ) {
          var arrSurveys = nameValueLib.getValue(
            _arrSortedConfidenceIntervals,
            [strCurCountry]
          );
          var objTemp = nameValueLib.createObject(strCurSurvey, '', [], false);
          arrSurveys.push(objTemp);
        }

        //Add Survey to local array to keep track of surveys with valid indicator data.
        if (
          nameValueLib.objectExists(arrSurveysWithData, [
            strCurCountry,
            strCurSurvey,
          ]) == -1
        ) {
          var arrSurveys = nameValueLib.getValue(arrSurveysWithData, [
            strCurCountry,
          ]);
          var objTemp = nameValueLib.createObject(
            strCurSurvey,
            '',
            false,
            false
          );
          arrSurveys.push(objTemp);
        }

        //Reset Indicator if the Survey changes.
        strPrevIndicatorCode = '';
      }

      strPrevSurvey = strCurSurvey;
      //Add Indicator to various arrays if it is a new indicator.

      if (
        !strPrevIndicatorCode.length ||
        strPrevIndicatorCode != strCurIndicatorCode
      ) {
        //If it is the first indicator, select it as the selected indicator for the drop down.
        // ACTUALLY!! Let's first check for this in the hash.
        if (getQueryVariable('si') == strCurIndicatorCode) {
          _strSelectedIndicator = strCurIndicator;
          _strSelectedIndicatorCode = strCurIndicatorCode;
          _strInfoIndicatorId = strCurIndicatorCode;
        } else if (
          !_strSelectedIndicator.length &&
          strCurIndicatorType === 'I'
        ) {
          _strSelectedIndicator = strCurIndicator;
          _strSelectedIndicatorCode = strCurIndicatorCode;
          _strInfoIndicatorId = strCurIndicatorCode;
        }

        //Add Indicator to Indicator Array.
        if (
          nameValueLib.objectExistsEX(_arrSortedIndicators, [
            strCurIndicatorCode,
          ]) == -1
        ) {
          var objTemp = nameValueLib.createIndicatorObject(
            strCurIndicator,
            strCurIndicatorCode,
            [],
            false,
            strCurIndicatorType
          );

          //Get the correct position to add the indicator in.
          var nCorrectPos = getSortedArrayIndex(
            arrIndicatorOrder,
            strCurIndicatorOrder
          );
          //If found the correct location, add it there.
          var metaData = nameValueLib.getValueEX(arrIndicatorMetaData, [
            strCurIndicatorCode,
          ]);

          if (nCorrectPos != -1) {
            _arrSortedIndicators.splice(nCorrectPos, 0, objTemp);
            arrIndicatorOrder.splice(nCorrectPos, 0, strCurIndicatorOrder);

            //Check if this is being inserted in the first position, if so
            //select this as the selected indicator.
            if (nCorrectPos == 0 && strCurIndicatorType === 'I') {
              _strSelectedIndicator = strCurIndicator;
              _strSelectedIndicatorCode = strCurIndicatorCode;
              _strInfoIndicatorId = strCurIndicatorCode;
            }
          } else {
            //Add to end.
            _arrSortedIndicators.push(objTemp);
            arrIndicatorOrder.push(strCurIndicatorOrder);
          }
        }

        // If indicator type is valid, mark the survey as having data
        if (objRow.IndicatorType === 'I') {
          //Mark the data as valid
          var objSurvey = nameValueLib.getObject(arrSurveysWithData, [
            strCurCountry,
            strCurSurvey,
          ]);
          objSurvey.value = true;
        }

        //Add Indicator to Precision Array.
        if (
          nameValueLib.objectExistsEX(_arrPrecision, [strCurIndicatorCode]) ==
          -1
        ) {
          var objTemp = nameValueLib.createIndicatorObject(
            strCurIndicator,
            strCurIndicatorCode,
            nPrecision,
            false,
            strCurIndicatorType
          );
          _arrPrecision.push(objTemp);
        }

        //Add Indicator to ByVariable Array.
        if (
          nameValueLib.objectExists(_arrSortedByVariableLabels, [
            strCurIndicatorCode,
          ]) == -1
        ) {
          var objTemp = nameValueLib.createIndicatorObject(
            strCurIndicatorCode,
            [],
            [],
            false,
            strCurIndicatorType
          );
          if (strCurByVariableLabel.length > 0)
            _arrSortedByVariableLabels.push(objTemp);
        }

        //Add Indicator to the value array.
        if (
          nameValueLib.objectExistsMixed(
            _arrValues,
            [strCurCountry, strCurSurvey, strCurIndicatorCode],
            [g_nameProp, g_nameProp, g_aliasProp]
          ) == -1
        ) {
          var arrIndicators = nameValueLib.getValue(_arrValues, [
            strCurCountry,
            strCurSurvey,
          ]);
          var objTemp = nameValueLib.createIndicatorObject(
            strCurIndicator,
            strCurIndicatorCode,
            [],
            false,
            strCurIndicatorType
          );
          arrIndicators.push(objTemp);
        }

        //Add Indicator to the Confidence Interval array.
        if (
          nameValueLib.objectExistsMixed(
            _arrSortedConfidenceIntervals,
            [strCurCountry, strCurSurvey, strCurIndicatorCode],
            [g_nameProp, g_nameProp, g_aliasProp]
          ) == -1
        ) {
          var arrIndicators = nameValueLib.getValue(
            _arrSortedConfidenceIntervals,
            [strCurCountry, strCurSurvey]
          );
          var objTemp = nameValueLib.createIndicatorObject(
            strCurIndicator,
            strCurIndicatorCode,
            [],
            false,
            strCurIndicatorType
          );
          arrIndicators.push(objTemp);
        }

        //Reset Char Cat if the Indicator changes.
        strPrevCharCat = '';
      }
      strPrevIndicatorCode = strCurIndicatorCode;

      //Add Characteristic Category to various arrays if it is a new Char Cat.
      if (!strPrevCharCat.length || strPrevCharCat != strCurCharCat) {
        //Add Char Cat to the value array.
        if (
          nameValueLib.objectExistsMixed(
            _arrValues,
            [strCurCountry, strCurSurvey, strCurIndicatorCode, strCurCharCat],
            [g_nameProp, g_nameProp, g_aliasProp, g_nameProp]
          ) == -1
        ) {
          var arrCharCats = nameValueLib.getValueMixed(
            _arrValues,
            [strCurCountry, strCurSurvey, strCurIndicatorCode],
            [g_nameProp, g_nameProp, g_aliasProp]
          );
          if (arrCharCats !== null) {
            var objTemp = nameValueLib.createObject(
              strCurCharCat,
              '',
              [],
              false
            );
            arrCharCats.push(objTemp);
          }
        }

        //Add Char Cat to Indicator Array.
        if (
          nameValueLib.objectExistsMixed(
            _arrSortedIndicators,
            [strCurIndicatorCode, strCurCharCat],
            [g_aliasProp, g_nameProp]
          ) == -1
        ) {
          var arrCharCats = nameValueLib.getValueEX(_arrSortedIndicators, [
            strCurIndicatorCode,
          ]);
          if (arrCharCats !== null) {
            var objTemp = nameValueLib.createObject(
              strCurCharCat,
              '',
              [],
              false
            );

            //Get the correct position to add the Char Cat to.
            var nCorrectPos = getSortedArrayIndex(
              arrCharLabelID,
              strCurCharLabelID
            );
            //If found the correct location, add it there.
            if (nCorrectPos != -1) {
              arrCharCats.splice(nCorrectPos, 0, objTemp);
              arrCharLabelID.splice(nCorrectPos, 0, strCurCharLabelID);
            } else {
              //Add to end.
              arrCharCats.push(objTemp);
              arrCharLabelID.push(strCurCharLabelID);
            }
          }
        }

        //Add Char Cat to the Labels Array.
        if (
          nameValueLib.objectExists(_arrSortedCharLabels, [strCurCharCat]) ===
          -1
        ) {
          var objTemp = nameValueLib.createObject(strCurCharCat, '', [], false);
          _arrSortedCharLabels.push(objTemp);
        }
        //Add Char Cat to the Confidence Interval Array.
        if (
          nameValueLib.objectExists(_arrSortedConfidenceIntervals, [
            strCurCharCat,
          ]) === -1
        ) {
          var arrCharCats = nameValueLib.getValueMixed(
            _arrSortedConfidenceIntervals,
            [strCurCountry, strCurSurvey, strCurIndicatorCode],
            [g_nameProp, g_nameProp, g_aliasProp]
          );
          var objTemp = nameValueLib.createObject(strCurCharCat, '', [], false);
          arrCharCats.push(objTemp);
        }

        //Reset Char Label if the Char Cat changes.
        strPrevCharLabel = '';
      }
      strPrevCharCat = strCurCharCat;
      //Add Characteristic Label to various arrays if it is a new Char Label.
      if (!strPrevCharLabel.length || strPrevCharLabel != strCurCharLabel) {
        //Add Char Label to the value.
        if (
          nameValueLib.objectExistsMixed(
            _arrValues,
            [
              strCurCountry,
              strCurSurvey,
              strCurIndicatorCode,
              strCurCharCat,
              strCurCharLabel,
            ],
            [g_nameProp, g_nameProp, g_aliasProp, g_nameProp, g_nameProp]
          ) == -1
        ) {
          var arrCharLabels = nameValueLib.getValueMixed(
            _arrValues,
            [strCurCountry, strCurSurvey, strCurIndicatorCode, strCurCharCat],
            [g_nameProp, g_nameProp, g_aliasProp, g_nameProp]
          );
          var objTemp = nameValueLib.createObject(
            strCurCharLabel,
            '',
            [],
            false
          );
          arrCharLabels.push(objTemp);
        }

        //Add Char Label to Indicator Array.
        if (
          nameValueLib.objectExistsMixed(
            _arrSortedIndicators,
            [strCurIndicatorCode, strCurCharCat, strCurCharLabel],
            [g_aliasProp, g_nameProp, g_nameProp]
          ) == -1
        ) {
          var arrCharLabels = nameValueLib.getValueMixed(
            _arrSortedIndicators,
            [strCurIndicatorCode, strCurCharCat],
            [g_aliasProp, g_nameProp]
          );
          var objTemp = nameValueLib.createObject(
            strCurCharLabel,
            strCurCharLabelID,
            '',
            false
          );
          //Determine where to add the char label (order)
          var insertIndex = getSortedObjectArrayIndex(
            arrCharLabels,
            g_aliasProp,
            strCurCharLabelID
          );

          arrCharLabels.splice(insertIndex, 0, objTemp);
        }

        //Add Char Label to the Confidence Interval Array.
        if (
          nameValueLib.objectExistsMixed(
            _arrSortedConfidenceIntervals,
            [
              strCurCountry,
              strCurSurvey,
              strCurIndicatorCode,
              strCurCharCat,
              strCurCharLabel,
            ],
            [g_nameProp, g_nameProp, g_aliasProp, g_nameProp, g_nameProp]
          ) == -1
        ) {
          var arrCharLabels = nameValueLib.getValueMixed(
            _arrSortedConfidenceIntervals,
            [strCurCountry, strCurSurvey, strCurIndicatorCode, strCurCharCat],
            [g_nameProp, g_nameProp, g_aliasProp, g_nameProp]
          );
          var objTemp = nameValueLib.createObject(
            strCurCharLabel,
            '',
            [],
            false
          );
          //Determine where to add the char label (order)
          var insertIndex = getSortedObjectArrayIndex(
            arrCharLabels,
            g_aliasProp,
            strCurCharLabelID
          );

          arrCharLabels.splice(insertIndex, 0, objTemp);
        }

        //Add Char Label to the CharLabels Array.
        if (
          nameValueLib.objectExists(_arrSortedCharLabels, [
            strCurCharCat,
            strCurCharLabel,
          ]) == -1
        ) {
          var arrCharLabels = nameValueLib.getValue(_arrSortedCharLabels, [
            strCurCharCat,
          ]);

          var objTemp;
          //If there are selected ID's check for those.
          if (selectedLabelIDs.length > 0) {
            if (selectedLabelIDs.indexOf(strCurCharLabelID) != -1) {
              objTemp = nameValueLib.createObject(
                strCurCharLabel,
                strCurCharLabelID,
                true,
                false
              );
              //In case this character Label ID is from the Total Category, enable Total.
              // SB we should change these to _isTotalCategoryExact instead of _isTotalCategory. Can't figure out why the latter would ever work considering something like: 'Total number of ...'
              if (_isTotalCategory(strCurCharCat)) {
                _bTotalDataSelected = true;
              } else if (_isRegionCategory(strCurCharCat)) {
                _bRegionalDataSelected = true;
              }
            } else if (
              _isRegionCategory(strCurCharCat) &&
              _bRegionalDataSelected
            ) {
              objTemp = nameValueLib.createObject(
                strCurCharLabel,
                strCurCharLabelID,
                true,
                false
              );
            } else if (_isTotalCategory(strCurCharCat) && _bTotalDataSelected) {
              objTemp = nameValueLib.createObject(
                strCurCharLabel,
                strCurCharLabelID,
                true,
                false
              );
            } else {
              objTemp = nameValueLib.createObject(
                strCurCharLabel,
                strCurCharLabelID,
                false,
                false
              );
            }
          }
          //Else if this particular label has the isTotal flag set, enable it.
          else if (nIsTotal) {
            objTemp = nameValueLib.createObject(
              strCurCharLabel,
              strCurCharLabelID,
              true,
              false
            );
            _bTotalDataSelected = true;
          } else {
            objTemp = nameValueLib.createObject(
              strCurCharLabel,
              strCurCharLabelID,
              false,
              false
            );
          }
          //Determine where to add the char label (order)
          var insertIndex = getSortedObjectArrayIndex(
            arrCharLabels,
            g_aliasProp,
            strCurCharLabelID
          );

          arrCharLabels.splice(insertIndex, 0, objTemp);
        }
        //! HERE is Twitter thing
        else if (
          nameValueLib.objectExists(_arrSortedCharLabels, [
            strCurCharCat,
            strCurCharLabel,
          ]) > -1 &&
          nameValueLib.getValue(_arrSortedCharLabels, [
            strCurCharCat,
            strCurCharLabel,
          ]) === false &&
          _isTotalCategory(strCurCharCat) &&
          _.isEmpty(getQueryVariable('scl'))
        ) {
          //! Trouble area!!
          var twitter = nameValueLib.getObject(_arrSortedCharLabels, [
            strCurCharCat,
            strCurCharLabel,
          ]);

          twitter.value = true;
        } else {
        }

        //If this is a total Char Label, add it to the Totals Array.
        if (nIsTotal) {
          if (
            nameValueLib.objectExistsEX(_arrSortedTotals, [
              strCurIndicatorCode,
            ]) == -1
          ) {
            objTemp = nameValueLib.createObject(
              strCurCharCat,
              strCurIndicatorCode,
              strCurCharLabel,
              false
            );
            _arrSortedTotals.push(objTemp);
          }
        }
      }
      strPrevCharLabel = strCurCharLabel;

      //! If ByVariable is present, add Indicator to ByVariableArray.

      if (strCurByVariableLabel.length > 0) {
        var objByValIndicator = nameValueLib.getObject(
          _arrSortedByVariableLabels,
          [strCurIndicatorCode]
        );
        var arrByVarIndicators = objByValIndicator.value;
        //If first one, select it by default.
        if (arrByVarIndicators.length == 0) {
          //Set the selection.
          objByValIndicator.alias.push(strCurByVariableLabel);
        }
        //If it does not exist, add it to the array.
        if (arrByVarIndicators.indexOf(strCurByVariableLabel) == -1) {
          arrByVarIndicators.push(strCurByVariableLabel);
        }
      }

      //Add ByVariable Label to the Value Array.
      if (
        nameValueLib.objectExistsMixed(
          _arrValues,
          [
            strCurCountry,
            strCurSurvey,
            strCurIndicatorCode,
            strCurCharCat,
            strCurCharLabel,
            strCurByVariableLabel,
          ],
          [
            g_nameProp,
            g_nameProp,
            g_aliasProp,
            g_nameProp,
            g_nameProp,
            g_nameProp,
          ]
        ) == -1
      ) {
        var arrByVarLabels = nameValueLib.getValueMixed(
          _arrValues,
          [
            strCurCountry,
            strCurSurvey,
            strCurIndicatorCode,
            strCurCharCat,
            strCurCharLabel,
          ],
          [g_nameProp, g_nameProp, g_aliasProp, g_nameProp, g_nameProp]
        );
        var objTemp = nameValueLib.createObject(
          strCurByVariableLabel,
          '',
          strValue,
          false
        );
        arrByVarLabels.push(objTemp);
      }

      //Add ByVariable Label to the Confidence Value Array.
      if (
        nameValueLib.objectExistsMixed(
          _arrSortedConfidenceIntervals,
          [
            strCurCountry,
            strCurSurvey,
            strCurIndicatorCode,
            strCurCharCat,
            strCurCharLabel,
            strCurByVariableLabel,
          ],
          [
            g_nameProp,
            g_nameProp,
            g_aliasProp,
            g_nameProp,
            g_nameProp,
            g_nameProp,
          ]
        ) == -1
      ) {
        //Get Array of By Variables.
        var arrByVarLabels = nameValueLib.getValueMixed(
          _arrSortedConfidenceIntervals,
          [
            strCurCountry,
            strCurSurvey,
            strCurIndicatorCode,
            strCurCharCat,
            strCurCharLabel,
          ],
          [g_nameProp, g_nameProp, g_aliasProp, g_nameProp, g_nameProp]
        );

        //Create New Confidence Interval Object.
        var objNewCI = {};
        objNewCI[CONFIDENCE_INTERVAL.Low] = strCILow;
        objNewCI[CONFIDENCE_INTERVAL.High] = strCIHigh;

        //Set New Confidence Interval.
        var objTemp = nameValueLib.createObject(
          strCurByVariableLabel,
          '',
          objNewCI,
          false
        );
        arrByVarLabels.push(objTemp);
      }

      //Add all the Regional data to the Regions array.
      if (_isRegionCategory(strCurCharCat)) {
        //Create the entire set of Char Label/Indicator/ByVariable Label as the Characteristic Variable does not exist.
        if (
          nameValueLib.objectExists(_arrSortedRegions, [
            strCurCountry,
            strCurSurvey,
            strCurCharLabel,
          ]) == -1
        ) {
          var arrRegions = nameValueLib.getValue(_arrSortedRegions, [
            strCurCountry,
            strCurSurvey,
          ]);
          var objTemp = nameValueLib.createObject(
            strCurCharLabel,
            strRegionalID,
            nameValueLib.createObject(
              strCurIndicator,
              strCurIndicatorCode,
              nameValueLib.createObject(
                strCurByVariableLabel,
                '',
                strValue,
                true
              ),
              true
            ),
            false
          );
          arrRegions.push(objTemp);
        }
        //Create the set of Indicator/ByVariable Label as the Characteristic Variable already exists.
        else if (
          nameValueLib.objectExistsMixed(
            _arrSortedRegions,
            [strCurCountry, strCurSurvey, strCurCharLabel, strCurIndicatorCode],
            [g_nameProp, g_nameProp, g_nameProp, g_aliasProp]
          ) == -1
        ) {
          var arrRegionIndicators = nameValueLib.getValue(_arrSortedRegions, [
            strCurCountry,
            strCurSurvey,
            strCurCharLabel,
          ]);
          var objTemp = nameValueLib.createObject(
            strCurIndicator,
            strCurIndicatorCode,
            nameValueLib.createObject(
              strCurByVariableLabel,
              '',
              strValue,
              true
            ),
            false
          );
          arrRegionIndicators.push(objTemp);
        }
        //Create the set of ByVariable Label as the Characteristic Variable /Indicator already exists.
        else {
          var arrRegionByLabels = nameValueLib.getValueMixed(
            _arrSortedRegions,
            [strCurCountry, strCurSurvey, strCurCharLabel, strCurIndicatorCode],
            [g_nameProp, g_nameProp, g_nameProp, g_aliasProp]
          );
          var objTemp = nameValueLib.createObject(
            strCurByVariableLabel,
            '',
            strValue,
            false
          );
          arrRegionByLabels.push(objTemp);
        }
      }
    }

    // TODO: bugfix - assertion below breaks when there is no initial data for country + indicator combination (example: Bangladesh,Bolivia,Botswana, + Infant Mortality Rate, Under Five Mortality Rate + API version 2)
    //If there was a previously selected indicator, and if it is still there, please select it.
    if (
      strOldSelectedIndicator.length &&
      _strSelectedIndicator != strOldSelectedIndicator
    ) {
      //Make sure the old indicator exists.
      var objTemp = nameValueLib.getValue(_arrSortedIndicators, [
        strOldSelectedIndicator,
      ]);
      if (objTemp != null) {
        _strSelectedIndicator = strOldSelectedIndicator;
        _strInfoIndicatorId = strCurIndicatorCode;
      }
    }

    var _currCount = 0;
    //Check to find surveys that do not have valid data, and delete from main arrays.
    for (
      var nCurCountryIndex = 0;
      nCurCountryIndex < arrSurveysWithData.length;
      nCurCountryIndex++
    ) {
      _currCount = 0;
      var strCountry = arrSurveysWithData[nCurCountryIndex].name;
      var arrSurveys = arrSurveysWithData[nCurCountryIndex].value;
      for (
        var nCurSurveyIndex = 0;
        nCurSurveyIndex < arrSurveys.length;
        nCurSurveyIndex++
      ) {
        var objSurvey = arrSurveys[nCurSurveyIndex];
        if (objSurvey.value == false) {
          //REMOVE IT FROM THE ARRAYS AND GO TO SLEEP
          _arrValues[nCurCountryIndex].value.splice(_currCount, 1);
          _arrSortedRegions[nCurCountryIndex].value.splice(_currCount, 1);
          _arrSortedConfidenceIntervals[nCurCountryIndex].value.splice(
            _currCount,
            1
          );
          _arrSortedCountriesSurveys[nCurCountryIndex].value.splice(
            _currCount,
            1
          );
        } else {
          _currCount++;
        }
      }
    }

    //Setup the Survey Year Range object.
    _objSurveyRange['min'] = nMinYear;
    _objSurveyRange['max'] = nMaxYear;

    //Setup the Current Selected Year Range object.
    _strCurYearRange['min'] = nMinYear;
    _strCurYearRange['max'] = nMaxYear;
  };

  /**
   **	Returns an order object
   **/
  var compare = function (a, b) {
    if (a.alias < b.alias) return -1;
    if (a.alias > b.alias) return 1;
    return 0;
  };

  var _createTotalRegistry = function () {
    arrIndicatorMetaData.map(function (indicator) {
      if (_objTotalsRegistry[indicator.value.IndicatorTotalId]) {
        _objTotalsRegistry[indicator.value.IndicatorTotalId].push(
          indicator.name
        );
      } else {
        _objTotalsRegistry[indicator.value.IndicatorTotalId] = [indicator.name];
      }
      //have to do a type check or all indicators will be put into registry
      if (
        indicator.value.Type === 'Indicator' ||
        indicator.value.Type === 'Indicateur'
      ) {
        if (_objDenominatorRegistry[indicator.alias]) {
          _objDenominatorRegistry[indicator.alias].push(
            indicator.value.DenominatorUnweightedId
          );
          _objDenominatorRegistry[indicator.alias].push(
            indicator.value.DenominatorWeightedId
          );
        } else {
          _objDenominatorRegistry[indicator.alias] = [
            indicator.value.DenominatorUnweightedId,
            indicator.value.DenominatorWeightedId,
          ];
        }

        if (
          _objSpecialRegistry[indicator.alias] &&
          (indicator.value.IndicatorSpecial1Id !== '' ||
            indicator.value.IndicatorSpecial2Id !== '')
        ) {
          if (indicator.value.IndicatorSpecial1Id !== '') {
            _objSpecialRegistry[indicator.alias].push(
              indicator.value.IndicatorSpecial1Id
            );
          }
          if (indicator.value.IndicatorSpecial2Id !== '') {
            _objSpecialRegistry[indicator.alias].push(
              indicator.value.IndicatorSpecial2Id
            );
          }
        } else {
          _objSpecialRegistry[indicator.alias] = [
            indicator.value.IndicatorSpecial1Id,
          ];
          if (indicator.value.IndicatorSpecial2Id !== '') {
            _objSpecialRegistry[indicator.alias].push(
              indicator.value.IndicatorSpecial2Id
            );
          }
        }
      }
    });
  };
  /**
   * @fn 		_getDenominatorListValue
   * @brief 	Checks denominator and appends to list.
   * @return 	type.
   */

  var _getDenominatorListValue = function (indicator) {
    var type = '';
    switch (indicator.type) {
      case 'I':
        type = 'indicators';
        break;
      case 'D':
        type = 'denominators';
        break;
      case 'U':
        type = 'unweightedDenominators';
        break;
      case 'S':
        type = 'specialValues';
        break;
      case 'T':
        type = 'totals';
        break;
    }
    return type;
  };

  /*!*
   * @fn 		_setGetGridOptionsState
   * @brief 	Set State of grid options based on available indicator types
   * @return 	totals
   */

  var _setGetGridOptionsState = function () {
    var totals = [];
    var specials = [];
    var unweightedDenominators = [];
    var weightedDenominators = [];
    var incompleteTotals = [];
    var curAllTotals = [];
    //use selected indicatos are unique set to account for no data being returned
    var uniqueSet = arrSelectedIndicatorNames;

    //Go through each loaded Indicator, and if there is a valid denominator, enable the denominators UI.
    for (var nIndex = 0; nIndex < _arrSortedIndicators.length; nIndex++) {
      var curIndicator = _arrSortedIndicators[nIndex];
      if (curIndicator.type === 'I') {
        var objIndicatorInfo = nameValueLib.getValueEX(arrIndicatorMetaData, [
          curIndicator.alias,
        ]);
        //if a weighted denominator is present, add it to the check array.
        if (objIndicatorInfo.DenominatorWeightedId.length > 0) {
          weightedDenominators.push(objIndicatorInfo.DenominatorWeightedId);
        }

        //if an unweighted denominator is present, add it to the check array.
        if (objIndicatorInfo.DenominatorUnweightedId.length > 0) {
          unweightedDenominators.push(objIndicatorInfo.DenominatorUnweightedId);
        }

        //if a special #1 denominator is present, add it to the check array.
        if (objIndicatorInfo.IndicatorSpecial1Id.length > 0) {
          specials.push(objIndicatorInfo.IndicatorSpecial1Id);
        }

        //if a special #2 denominator is present, add it to the check array.
        if (objIndicatorInfo.IndicatorSpecial2Id.length > 0) {
          specials.push(objIndicatorInfo.IndicatorSpecial2Id);
        }

        //if an total denominator is present, add it to the check array.
        if (objIndicatorInfo.IndicatorTotalId.length > 0) {
          curAllTotals.push(objIndicatorInfo.IndicatorTotalId);
        }
      }
    }

    $('#DenominatorOption2 button').attr(
      'disabled',
      unweightedDenominators.length > 0 ? false : true
    );
    $('#DenominatorOption1 button').attr(
      'disabled',
      weightedDenominators.length > 0 ? false : true
    );

    //compare totals in the registry to get count
    if (curAllTotals.length > 0) {
      curAllTotals.map(function (total) {
        //get a filter from unique set to compare against
        var selectedIndicatorTotal = uniqueSet.filter(function (indicator) {
          if (_objTotalsRegistry[total]) {
            return _objTotalsRegistry[total].indexOf(indicator) > -1;
          }
        });
        if (_objTotalsRegistry[total]) {
          if (
            selectedIndicatorTotal.length ===
              _objTotalsRegistry[total].length &&
            _objTotalsRegistry[total].length > 0
          ) {
            totals.push(total);
            //_bDisplayTotals = true;
          }

          if (
            selectedIndicatorTotal.length !==
              _objTotalsRegistry[total].length &&
            _objTotalsRegistry[total].length > 0
          ) {
            incompleteTotals.push(total);
          }
        }
      });
    } else {
      $('#TotalOption1 button').attr('disabled', true);
      $('#TotalOption1 button').removeClass('checked');
      $('#TotalOption1 button').addClass('unchecked');

      _bDisplayTotals = false;
    }
    if (incompleteTotals.length > 0 && totals.length === 0) {
      $('#totalMessage').removeClass('hidden');
    } else {
      $('#totalMessage').addClass('hidden');
    }

    if (totals.length > 0 && _bDisplayTotals) {
      $('#TotalOption1 button').attr('disabled', false);
      _bDisplaySpecialIndicators = _bDisplaySpecialIndicatorsClicked
        ? _bDisplaySpecialIndicators
        : true;
    } else if (totals.length > 0 && !_bDisplayTotals) {
      $('#TotalOption1 button').attr('disabled', false);
      $('#TotalOption1 button').removeClass('checked');
      $('#TotalOption1 button').addClass('unchecked');
      _bDisplayTotals = false;
      //_bDisplaySpecialIndicators = _bDisplaySpecialIndicatorsClicked ? _bDisplaySpecialIndicators : false;
    } else {
      $('#TotalOption1 button').attr('disabled', true);
      $('#TotalOption1 button').removeClass('checked');
      $('#TotalOption1 button').addClass('unchecked');
      _bDisplayTotals = false;
    }
    _bDisplaySpecialIndicators = _bDisplaySpecialIndicatorsClicked
      ? _bDisplaySpecialIndicators
      : _bDisplaySpecialIndicators;

    if (_bDisplaySpecialIndicators && specials.length > 0) {
      _bDisplaySpecialIndicatorsClicked = false;
      $('#SpecialOption1 button').attr('disabled', false);
      $('#SpecialOption1 button').addClass('checked');
      $('#SpecialOption1 button').removeClass('unchecked');
    } else if (!_bDisplaySpecialIndicators && specials.length > 0) {
      $('#SpecialOption1 button').attr('disabled', false);
      $('#SpecialOption1 button').addClass('unchecked');
      $('#SpecialOption1 button').removeClass('checked');
    } else {
      $('#SpecialOption1 button').attr('disabled', true);
      $('#SpecialOption1 button').removeClass('checked');
      $('#SpecialOption1 button').addClass('unchecked');
      _bDisplaySpecialIndicators = false;
    }
    return totals;
  };

  /**
   * @fn 		_checkDenominatorValues
   * @brief 	Checks that denominators are attributed to the current indicator.
   * @return 	boolean.
   */

  var _checkDenominatorValues = function (objIndicator) {
    var denomsAvailable = { D: false, U: false };

    if (objIndicator.type === 'D' || objIndicator.type === 'U') {
      _arrSortedIndicators.some(function (indicator) {
        if (_objDenominatorRegistry[indicator.alias]) {
          denomsAvailable[objIndicator.type] =
            _objDenominatorRegistry[indicator.alias].indexOf(
              objIndicator.alias
            ) > -1;
          return denomsAvailable[objIndicator.type];
        }
      });
    }

    return denomsAvailable;
  };

  /**
   * @fn 		_checkSpecialValues
   * @brief 	Checks that denominators are attributed to the current indicator.
   * @return 	boolean.
   */

  var _checkSpecialValues = function (objIndicator) {
    var specialAvailable = { S: false };

    if (objIndicator.type === 'S') {
      _arrSortedIndicators.some(function (indicator) {
        if (_objSpecialRegistry[indicator.alias]) {
          specialAvailable[objIndicator.type] =
            _objSpecialRegistry[indicator.alias].indexOf(objIndicator.alias) >
            -1;
          return specialAvailable[objIndicator.type];
        }
      });
    }

    return specialAvailable;
  };

  /**
   * @fn 		_createGridDataForSurveysPivot
   * @brief 	Creates data required for the grid for a survey pivot.
   * @return 	void.
   */
  var _createGridDataForSurveysPivot = function () {
    // Enable/disable the denominators checkbox in the UI
    const totals = _setGetGridOptionsState();

    //Declare Important Variables.
    var strStartColNameLvl1 = '';
    var nNumberOfColLvl1 = 0;
    var strStartColNameLvl2 = '';
    var nNumberOfColLvl2 = 0;
    var strStartColNameLvl3 = '';
    var nNumberOfColLvl3 = 0;
    var arrEnabledCharCats = [];
    var arrCustomSortedCountriesSurveys = [];

    //Reset Grid Display Data.
    _resetGridDisplayData();

    //Create an array of all enabled Characteristic Categories.
    for (
      var nCharCatIndex = 0;
      nCharCatIndex < _arrSortedCharLabels.length;
      nCharCatIndex++
    ) {
      var objCharCat = _arrSortedCharLabels[nCharCatIndex];
      for (
        var nCharLabelIndex = 0;
        nCharLabelIndex < objCharCat.value.length;
        nCharLabelIndex++
      ) {
        var objCharLabel = objCharCat.value[nCharLabelIndex];
        if (objCharLabel.value) {
          //If the character label is enabled and is a potential Total Category,
          arrEnabledCharCats.push(objCharCat.name);
          break;
        }
      }
    }

    //Create a custom descending order of surveys for each country.
    for (var nIndex = 0; nIndex < _arrSortedCountriesSurveys.length; nIndex++) {
      //Obtain the country object from the original array.
      var objCountry = _arrSortedCountriesSurveys[nIndex];

      //Reset the arrays for this country.
      var arrYears = [];
      var arrCustomSurveys = [];

      //Go through the surveys, reorder descending and add to the custom array.
      for (
        var nSurveyIndex = 0;
        nSurveyIndex < objCountry.value.length;
        nSurveyIndex++
      ) {
        //Get the original survey.
        var objTempSurvey = objCountry.value[nSurveyIndex];

        //Get the correct position to add the survey in (descending order).
        strSurveyYear = objTempSurvey.alias;
        var nCorrectPos = getSortedArrayIndex(arrYears, strSurveyYear, true);

        //If the correct location is found, add it there.
        if (nCorrectPos != -1) {
          arrCustomSurveys.splice(nCorrectPos, 0, objTempSurvey);
          arrYears.splice(nCorrectPos, 0, strSurveyYear);
        } else {
          //Add to end.
          arrCustomSurveys.push(objTempSurvey);
          arrYears.push(strSurveyYear);
        }
      }

      //Add Country to Custom Array.
      var objTempCountry = nameValueLib.createObject(
        objCountry.name,
        objCountry.alias,
        arrCustomSurveys,
        false
      );
      arrCustomSortedCountriesSurveys.push(objTempCountry);
    } //END for(var nIndex = 0; nIndex < _arrSortedCountriesSurveys.length...

    //Go through the data to create grid data for the enabled data.
    _addColumn(
      Config.getUniversalString('country'),
      false,
      true,
      undefined,
      undefined,
      undefined
    );
    _addColumn(
      Config.getUniversalString('survey'),
      false,
      true,
      undefined,
      undefined,
      undefined
    );

    //For each country
    for (
      var nCountryIndex = 0;
      nCountryIndex < arrCustomSortedCountriesSurveys.length;
      nCountryIndex++
    ) {
      var objCountry = arrCustomSortedCountriesSurveys[nCountryIndex];

      //Process only if country is selected.
      if (_arrUnSelectedCountries.indexOf(objCountry.name) == -1) {
        //For each survey.
        for (
          var nSurveyIndex = 0;
          nSurveyIndex < objCountry.value.length;
          nSurveyIndex++
        ) {
          var objSurvey = objCountry.value[nSurveyIndex];

          //if survey is not enabled, ignore it.
          if (!objSurvey.value) {
            continue;
          }

          //Start Object to keep track of column names.
          var objColumnSuffix = {};

          //Add Country/Survey to Row.
          var objNewRow = {};
          objNewRow[Config.getUniversalString('country')] = objCountry.name;
          objNewRow[Config.getUniversalString('survey')] = objSurvey.name;

          //for each indicator.
          for (
            var nIndicatorIndex = 0;
            nIndicatorIndex < _arrSortedIndicators.length;
            nIndicatorIndex++
          ) {
            var objIndicator = _arrSortedIndicators[nIndicatorIndex];
            var denomsAvailable = _checkDenominatorValues(objIndicator);
            var specialValues = _checkSpecialValues(objIndicator);

            if (
              (_bDisplayWeightedDenominators && denomsAvailable.D) ||
              (_bDisplayUnweightedDenominators && denomsAvailable.U) ||
              (_bDisplayTotals &&
                objIndicator.type === 'T' &&
                totals.indexOf(objIndicator.alias) > -1) ||
              (_bDisplaySpecialIndicators && specialValues.S) ||
              objIndicator.type === 'I'
            ) {
              //Setup Indicator Group Header.
              strGroupNameLvl1 = objIndicator.name;
              strGroupIdLvl1 = objIndicator.alias;
              strStartColNameLvl1 = '';
              nNumberOfColLvl1 = 0;

              //Get By Variable Array.

              var arrCurByVariable = [];
              var arrAllByVariable = byVariableState.get(
                objIndicator.alias,
                []
              );
              if (arrAllByVariable.current) {
                arrCurByVariable = arrAllByVariable.current;
              }

              if (arrCurByVariable.length == 0) {
                arrCurByVariable.push('');
              }

              //For each By Variable Label.
              for (
                var nByVariableIndex = 0;
                nByVariableIndex < arrCurByVariable.length;
                nByVariableIndex++
              ) {
                var strByVariableLabel = arrCurByVariable[nByVariableIndex];

                //Setup By Variables Group Header.
                strGroupNameLvl2 = strByVariableLabel;
                strStartColNameLvl2 = '';
                nNumberOfColLvl2 = 0;

                //For each Character Category.
                for (
                  var nCharCatIndex = 0;
                  nCharCatIndex < objIndicator.value.length;
                  nCharCatIndex++
                ) {
                  var objCharCat = objIndicator.value[nCharCatIndex];

                  if (arrEnabledCharCats.indexOf(objCharCat.name) == -1) {
                    continue;
                  }

                  strGroupNameLvl3 = objCharCat.name;
                  strStartColNameLvl3 = '';
                  nNumberOfColLvl3 = 0;

                  //For each Character Label.
                  for (
                    var nCharLabelIndex = 0;
                    nCharLabelIndex < objCharCat.value.length;
                    nCharLabelIndex++
                  ) {
                    var objCharLabel = objCharCat.value[nCharLabelIndex];

                    //If Label is not enabled, ignore it.
                    if (
                      !nameValueLib.getValue(_arrSortedCharLabels, [
                        objCharCat.name,
                        objCharLabel.name.toString(),
                      ])
                    ) {
                      continue;
                    }

                    //Make sure the column name is unique for the Char Label.
                    var strVerifiedColumnName = _getVerifiedColumnName(
                      objColumnSuffix,
                      objCharLabel.name.toString()
                    );
                    var strCleansedColumnName = strVerifiedColumnName.replace(
                      /\s/g,
                      ''
                    );
                    const strNameAliasColName = `${strCleansedColumnName}${
                      objIndicator.alias ? `_${objIndicator.alias}` : ''
                    }`;

                    //Set Start Column name for group headers if not set.
                    if (!strStartColNameLvl1.length) {
                      strStartColNameLvl1 = strNameAliasColName;
                    }

                    if (!strStartColNameLvl2.length) {
                      strStartColNameLvl2 = strNameAliasColName;
                    }

                    if (!strStartColNameLvl3.length) {
                      strStartColNameLvl3 = strNameAliasColName;
                    }

                    //Obtain the value for the particular label.
                    var strValue = nameValueLib
                      .getValueEmptyMixed(
                        _arrValues,
                        [
                          objCountry.name,
                          objSurvey.name,
                          objIndicator.alias,
                          objCharCat.name,
                          objCharLabel.name.toString(),
                          strByVariableLabel,
                        ],
                        [
                          g_nameProp,
                          g_nameProp,
                          g_aliasProp,
                          g_nameProp,
                          g_nameProp,
                        ]
                      )
                      .toString();
                    var objConfidenceIntervals = nameValueLib.getValueMixed(
                      _arrSortedConfidenceIntervals,
                      [
                        objCountry.name,
                        objSurvey.name,
                        objIndicator.alias,
                        objCharCat.name,
                        objCharLabel.name.toString(),
                        strByVariableLabel,
                      ],
                      [
                        g_nameProp,
                        g_nameProp,
                        g_aliasProp,
                        g_nameProp,
                        g_nameProp,
                      ]
                    );

                    //Add name to the column list.
                    _addColumn(
                      strVerifiedColumnName,
                      false,
                      false,
                      'float',
                      undefined,
                      objIndicator.alias
                    );
                    //Add data for this column to the row.
                    if (
                      objConfidenceIntervals != null &&
                      objConfidenceIntervals[CONFIDENCE_INTERVAL.Low] != '' &&
                      objConfidenceIntervals[CONFIDENCE_INTERVAL.High] != ''
                    ) {
                      objNewRow[strNameAliasColName] =
                        Config.sanitizeNumberString(strValue) +
                        ' (CI: ' +
                        objConfidenceIntervals[CONFIDENCE_INTERVAL.Low] +
                        ' &#8211 ' +
                        objConfidenceIntervals[CONFIDENCE_INTERVAL.High] +
                        ')';
                    } else {
                      if (denomsAvailable.U || denomsAvailable.D) {
                        objNewRow[strNameAliasColName] =
                          '<i>' +
                          Config.sanitizeNumberString(strValue) +
                          '</i>';
                      } else {
                        objNewRow[strNameAliasColName] =
                          Config.sanitizeNumberString(strValue);
                      }
                    }

                    //Increment Columns for group headers.
                    nNumberOfColLvl1++;
                    nNumberOfColLvl2++;
                    nNumberOfColLvl3++;
                  } //End Char Labels

                  //Add Third Level Group if it has columns.
                  if (nNumberOfColLvl3) {
                    //If the start column name and group name are the same, then add a third level without a name.
                    //NOTE: This is assuming to deal with groups that only have one char label.
                    if (
                      strGroupNameLvl3 ==
                      strVerifiedColumnName.replace(/_[0-9]+/g, '')
                    ) {
                      _addGroupHeader(
                        '',
                        strStartColNameLvl3,
                        nNumberOfColLvl3,
                        3,
                        'surveys',
                        undefined,
                        undefined
                      );
                    } else {
                      _addGroupHeader(
                        strGroupNameLvl3,
                        strStartColNameLvl3,
                        nNumberOfColLvl3,
                        3,
                        'surveys',
                        undefined,
                        undefined
                      );
                    }
                  }
                } //End Char Cats

                //Add Second Level Group if it has columns.
                if (nNumberOfColLvl2) {
                  _addGroupHeader(
                    strGroupNameLvl2,
                    strStartColNameLvl2,
                    nNumberOfColLvl2,
                    2,
                    'surveys',
                    undefined,
                    undefined
                  );
                }
              } // End By Variable.

              //Add First Level Group if it has columns.
              if (nNumberOfColLvl1) {
                _addGroupHeader(
                  strGroupNameLvl1,
                  strStartColNameLvl1,
                  nNumberOfColLvl1,
                  1,
                  'surveys',
                  strGroupIdLvl1,
                  denomsAvailable.D || denomsAvailable.U
                );
              }
            }
          } //End Indicators.

          //Add Row to grid.
          _arrGridData.push(objNewRow);
        } //End Surveys.
      } //END if country selected.
    } //End Country.
  };

  /**
   * @fn 		_createGridDataForIndicatorsPivot
   * @brief 	Creates data required for the grid for a indicator pivot.
   * @return 	void.
   */
  var _createGridDataForIndicatorsPivot = function () {
    // var indicatorsTypeCount = {
    // 	denominators: [],
    // 	unweightedDenominators: [],
    // 	specialValues: [],
    // 	totals: [],
    // 	indicators: []
    // }
    //
    // for(var nIndicatorIndex = 0; nIndicatorIndex < _arrSortedIndicators.length; nIndicatorIndex++) {
    // 	var objIndicator = _arrSortedIndicators[nIndicatorIndex];
    // 	var indicatorType = _getDenominatorListValue(objIndicator)
    // 	var newIndicatorObj = JSON.parse(JSON.stringify(objIndicator));
    // 	newIndicatorObj.arrEnabledCharCats = arrEnabledCharCats;
    // 	indicatorsTypeCount[indicatorType].push(newIndicatorObj);
    // }

    _setGetGridOptionsState();

    //Declare Important Variables.
    var strStartColNameLvl1 = '';
    var nNumberOfColLvl1 = 0;
    var strStartColNameLvl2 = '';
    var nNumberOfColLvl2 = 0;
    var arrEnabledCharCats = [];
    var bByVarColumnAdded = false;

    var strIndicatorColName = Config.getUniversalString('Indicator');
    var strCharacteristicColName = Config.getUniversalString('characteristic');
    var strCharLabelIDColName = 'CharLabelID';
    var strByVariableLabelName = Config.getUniversalString('by');

    //Reset Grid Display Data.
    _resetGridDisplayData();

    //Create an array of all enabled Characteristic Categories.
    for (
      var nCharCatIndex = 0;
      nCharCatIndex < _arrSortedCharLabels.length;
      nCharCatIndex++
    ) {
      var objCharCat = _arrSortedCharLabels[nCharCatIndex];
      for (
        var nCharLabelIndex = 0;
        nCharLabelIndex < objCharCat.value.length;
        nCharLabelIndex++
      ) {
        var objCharLabel = objCharCat.value[nCharLabelIndex];
        if (objCharLabel.value) {
          arrEnabledCharCats.push(objCharCat.name);
          break;
        }
      }
    }

    //Add the Indicator Column.
    _addColumn(
      strIndicatorColName,
      false,
      true,
      undefined,
      undefined,
      undefined
    );

    //Add the By Variable Column if needed.
    for (
      var nIndicatorIndex = 0;
      nIndicatorIndex < _arrSortedIndicators.length;
      nIndicatorIndex++
    ) {
      //Get the Indicator Name.
      var objIndicator = _arrSortedIndicators[nIndicatorIndex];

      //Check if the Indicator has any By Variables.
      var arrCurByVariable =
        nameValueLib.getValue(_arrSortedByVariableLabels, [
          objIndicator.alias,
        ]) || [];

      if (arrCurByVariable.length != 0) {
        _addColumn(
          strByVariableLabelName,
          false,
          true,
          undefined,
          undefined,
          undefined
        );
        break;
      }
    }

    //Add Char Cat and Char Name as Columns.
    _addColumn(
      strCharLabelIDColName,
      true,
      true,
      undefined,
      undefined,
      undefined
    );
    _addColumn(
      strCharacteristicColName,
      false,
      true,
      undefined,
      undefined,
      undefined
    );

    //Loop through all indicators.
    for (
      var nIndicatorIndex = 0;
      nIndicatorIndex < _arrSortedIndicators.length;
      nIndicatorIndex++
    ) {
      //Obtain current indicator.
      var objIndicator = _arrSortedIndicators[nIndicatorIndex];
      var denomsAvailable = _checkDenominatorValues(objIndicator);
      var specialValues = _checkSpecialValues(objIndicator);
      if (
        (_bDisplayWeightedDenominators && denomsAvailable.D) ||
        (_bDisplayUnweightedDenominators && denomsAvailable.U) ||
        (_bDisplayTotals &&
          objIndicator.type === 'T' &&
          totals.indexOf(objIndicator.alias) > -1) ||
        (_bDisplaySpecialIndicators && specialValues.S) ||
        objIndicator.type === 'I'
      ) {
        var arrCurByVariable = (
          nameValueLib.getValue(_arrSortedByVariableLabels, [
            objIndicator.alias,
          ]) || []
        ).slice();
        if (arrCurByVariable.length == 0) {
          arrCurByVariable.push('');
        }

        //For each By Variable Label.
        for (
          var nByVariableIndex = 0;
          nByVariableIndex < arrCurByVariable.length;
          nByVariableIndex++
        ) {
          var strByVariableLabel = arrCurByVariable[nByVariableIndex];

          //Loop through all characteristic Categories for the particular indicator.
          for (
            var nCharCatIndex = 0;
            nCharCatIndex < objIndicator.value.length;
            nCharCatIndex++
          ) {
            //Obtain Current Char Cat.
            var objCharCat = objIndicator.value[nCharCatIndex];

            //If Characteristic Category is not enabled, ignore it.
            if (arrEnabledCharCats.indexOf(objCharCat.name) == -1) {
              continue;
            }

            //Loop through all characteristic labels for the particular Char Cat.
            for (
              var nCharLabelIndex = 0;
              nCharLabelIndex < objCharCat.value.length;
              nCharLabelIndex++
            ) {
              //Get Current Char Label.
              var objCharLabel = objCharCat.value[nCharLabelIndex];

              //If Label is not enabled, ignore it.
              if (
                !nameValueLib.getValue(_arrSortedCharLabels, [
                  objCharCat.name,
                  objCharLabel.name,
                ])
              ) {
                continue;
              }

              //Create/Reset Column Suffix Object.
              var objColumnSuffix = {};
              //Start a new row.
              var objNewRow = {};

              //Add Indicator, CharCat and CharLabel to the row with Char Label ID (used for sorting).
              objNewRow[strIndicatorColName] = objIndicator.name;
              objNewRow[strByVariableLabelName] = strByVariableLabel;
              if (
                objCharCat.name != objCharLabel.name.toString() &&
                objCharCat.name !== Config.getUniversalString('region') // Region does not match but is already formatted
              ) {
                objNewRow[strCharacteristicColName] =
                  objCharCat.name + ' : ' + objCharLabel.name.toString();
              } else if (
                objCharCat.name === Config.getUniversalString('region')
              ) {
                objNewRow[strCharacteristicColName] = objCharLabel.name;
              } else {
                objNewRow[strCharacteristicColName] = objCharCat.name;
              }
              objNewRow[strCharLabelIDColName] = nameValueLib.getAlias(
                _arrSortedCharLabels,
                [objCharCat.name, objCharLabel.name]
              );

              //Loop through all the countries.
              for (
                var nCountryIndex = 0;
                nCountryIndex < _arrSortedCountriesSurveys.length;
                nCountryIndex++
              ) {
                //Get Current Country Object.
                // var countryHasDenominators = false;
                // var nNumberOfColLvl1Denom = 0;
                var objCountry = _arrSortedCountriesSurveys[nCountryIndex];

                //Process only if country is selected.
                if (_arrUnSelectedCountries.indexOf(objCountry.name) == -1) {
                  var strGroupNameLvl1 = objCountry.name;
                  var strStartColNameLvl1 = '';
                  var nNumberOfColLvl1 = 0;

                  //Loop through all the surveys for the particular country.
                  for (
                    var nSurveyIndex = objCountry.value.length - 1;
                    nSurveyIndex >= 0;
                    nSurveyIndex--
                  ) {
                    //Get current Survey object.
                    var objSurvey = objCountry.value[nSurveyIndex];

                    //If Survey is not enabled, ignore it.
                    if (!objSurvey.value) {
                      continue;
                    }

                    //Add Column for particular Survey. Make sure the column name is unique.
                    var strVerifiedColumnName = _getVerifiedColumnName(
                      objColumnSuffix,
                      objSurvey.name
                    );
                    var strCleansedColumnName = strVerifiedColumnName.replace(
                      /\s/g,
                      ''
                    );
                    const strNameAliasColName = `${strCleansedColumnName}${
                      objIndicator.alias ? `_${objIndicator.alias}` : ''
                    }`;

                    //Set Start Column name for group headers if not set.
                    if (!strStartColNameLvl1.length) {
                      strStartColNameLvl1 = strNameAliasColName;
                    }

                    //Add name to the column list.
                    _addColumn(
                      strVerifiedColumnName,
                      false,
                      false,
                      'float',
                      undefined,
                      undefined
                    );

                    //Obtain the value for the particular survey.
                    var strValue = nameValueLib
                      .getValueEmptyMixed(
                        _arrValues,
                        [
                          objCountry.name,
                          objSurvey.name,
                          objIndicator.alias,
                          objCharCat.name,
                          objCharLabel.name.toString(),
                          strByVariableLabel,
                        ],
                        [
                          g_nameProp,
                          g_nameProp,
                          g_aliasProp,
                          g_nameProp,
                          g_nameProp,
                          g_nameProp,
                        ]
                      )
                      .toString();
                    var objConfidenceIntervals = nameValueLib.getValueMixed(
                      _arrSortedConfidenceIntervals,
                      [
                        objCountry.name,
                        objSurvey.name,
                        objIndicator.alias,
                        objCharCat.name,
                        objCharLabel.name.toString(),
                        strByVariableLabel,
                      ],
                      [
                        g_nameProp,
                        g_nameProp,
                        g_aliasProp,
                        g_nameProp,
                        g_nameProp,
                        g_nameProp,
                      ]
                    );

                    //Add data for this column to the row.
                    if (
                      objConfidenceIntervals != null &&
                      objConfidenceIntervals[CONFIDENCE_INTERVAL.High] != '' &&
                      objConfidenceIntervals[CONFIDENCE_INTERVAL.Low] != ''
                    ) {
                      objNewRow[strCleansedColumnName] =
                        Config.sanitizeNumberString(strValue) +
                        ' (CI: ' +
                        objConfidenceIntervals[CONFIDENCE_INTERVAL.Low] +
                        ' &#8211 ' +
                        objConfidenceIntervals[CONFIDENCE_INTERVAL.High] +
                        ')';
                    } else {
                      if (denomsAvailable.U || denomsAvailable.D) {
                        objNewRow[strCleansedColumnName] =
                          '<i>' +
                          Config.sanitizeNumberString(strValue) +
                          '</i>';
                      } else {
                        objNewRow[strCleansedColumnName] =
                          Config.sanitizeNumberString(strValue);
                      }
                    }

                    nNumberOfColLvl1++;
                  } //END for(var nSurveyIndex = 0...
                  //Add First Level Group if it contains columns.
                  if (nNumberOfColLvl1) {
                    _addGroupHeader(
                      strGroupNameLvl1,
                      strStartColNameLvl1,
                      nNumberOfColLvl1,
                      1,
                      'indChar',
                      undefined,
                      undefined
                    );

                    // if(!countryHasDenominators){
                    // 	_addGroupHeader(strGroupNameLvl1, strStartColNameLvl1 + 'Denominators', nNumberOfColLvl1, 1);
                    // }
                  }
                } //END if(_arrUnSelectedCountries.indexOf(objCountry.name) == -1) {...
              } //END for(var nCountryIndex = 0...

              if (objNewRow.Indicator != undefined) {
                var popupButton =
                  '</span>' +
                  '<span class="iconInfo" style="background-color:#808080" onclick="showIndicatorMetaDataInfo(\'' +
                  objNewRow.Indicator.replace(/'/g, "\\'") +
                  "','" +
                  objIndicator.alias +
                  '\', event)"></span>';

                if (denomsAvailable.D || denomsAvailable.U) {
                  objNewRow.Indicator =
                    '<i>' + objNewRow.Indicator + '</i>' + popupButton;
                } else {
                  objNewRow.Indicator = objNewRow.Indicator + popupButton;
                }
              } else {
                var popupButton =
                  '</span>' +
                  '<span class="iconInfo" style="background-color:#808080" onclick="showIndicatorMetaDataInfo(\'' +
                  objNewRow.Indicateur.replace(/'/g, "\\'") +
                  "','" +
                  objIndicator.alias +
                  '\', event)"></span>';

                if (denomsAvailable.D || denomsAvailable.U) {
                  objNewRow.Indicateur =
                    '<i>' + objNewRow.Indicateur + '</i>' + popupButton;
                } else {
                  objNewRow.Indicateur = objNewRow.Indicateur + popupButton;
                }
              }

              //Add row to grid data.
              _arrGridData.push(objNewRow);
            } //END for(var nCharLabelIndex = 0...
          } //END for(var nCharCatIndex = 0...
        } //END for(var nByVariableIndex = 0...
      } //END for(var nIndicatorIndex = 0...
    }
  };

  /**
   * @fn 		_createGridDataForSurveyCharCatPivot
   * @brief 	Creates data required for the grid for a survey/Char Cat pivot.
   * @return 	void.
   */
  var _createGridDataForSurveyCharCatPivot = function () {
    _setGetGridOptionsState();

    //TODO Add group level headers.
    //Declare Important Variables.
    var objColumnSuffix = {};
    var strStartColNameLvl1 = '';
    var nNumberOfColLvl1 = 0;
    var strStartColNameLvl2 = '';
    var nNumberOfColLvl2 = 0;
    var arrEnabledCharCats = [];
    var bByVarColumnAdded = false;
    var arrByVarLabels = [];
    var arrCustomSortedCountriesSurveys = [];
    //	var countryHasDenominators = false;

    var strCountryColName = Config.getUniversalString('country');
    var strSurveyColName = Config.getUniversalString('survey');
    var strByVariableLabelName = Config.getUniversalString('by');
    var strCharacteristicColName = Config.getUniversalString('characteristic');
    var strCharLabelIDColName = 'CharLabelID';

    //Reset Grid Display Data.
    _resetGridDisplayData();

    //Create an array of all enabled Characteristic Categories.
    for (
      var nCharCatIndex = 0;
      nCharCatIndex < _arrSortedCharLabels.length;
      nCharCatIndex++
    ) {
      var objCharCat = _arrSortedCharLabels[nCharCatIndex];
      for (
        var nCharLabelIndex = 0;
        nCharLabelIndex < objCharCat.value.length;
        nCharLabelIndex++
      ) {
        var objCharLabel = objCharCat.value[nCharLabelIndex];
        if (objCharLabel.value) {
          arrEnabledCharCats.push(objCharCat.name);
          break;
        }
      }
    }

    _addGroupHeader(
      '',
      arrEnabledCharCats[0],
      arrEnabledCharCats.length,
      1,
      'surChar',
      undefined,
      undefined
    );

    //Create a custom descending order of surveys for each country.
    for (var nIndex = 0; nIndex < _arrSortedCountriesSurveys.length; nIndex++) {
      //Obtain the country object from the original array.
      var objCountry = _arrSortedCountriesSurveys[nIndex];

      //Reset the arrays for this country.
      var arrYears = [];
      var arrCustomSurveys = [];

      //Go through the surveys, reorder descending and add to the custom array.
      for (
        var nSurveyIndex = 0;
        nSurveyIndex < objCountry.value.length;
        nSurveyIndex++
      ) {
        //Get the original survey.
        var objTempSurvey = objCountry.value[nSurveyIndex];

        //Get the correct position to add the survey in (descending order).
        strSurveyYear = objTempSurvey.alias;
        var nCorrectPos = getSortedArrayIndex(arrYears, strSurveyYear, true);

        //If the correct location is found, add it there.
        if (nCorrectPos != -1) {
          arrCustomSurveys.splice(nCorrectPos, 0, objTempSurvey);
          arrYears.splice(nCorrectPos, 0, strSurveyYear);
        } else {
          //Add to end.
          arrCustomSurveys.push(objTempSurvey);
          arrYears.push(strSurveyYear);
        }
      }

      //Add Country to Custom Array.
      var objTempCountry = nameValueLib.createObject(
        objCountry.name,
        objCountry.alias,
        arrCustomSurveys,
        false
      );
      arrCustomSortedCountriesSurveys.push(objTempCountry);
    } //END for(var nIndex = 0; nIndex < _arrSortedCountriesSurveys.length...

    //Add the Country and Survey Column.
    _addColumn(strCountryColName, false, true, undefined, undefined, undefined);
    _addColumn(strSurveyColName, false, true, undefined, undefined, undefined);
    //Add the By Variable Column if needed and create a ByVariable Array.
    for (
      var nIndicatorIndex = 0;
      nIndicatorIndex < _arrSortedIndicators.length;
      nIndicatorIndex++
    ) {
      //Get the Indicator Name.
      var objIndicator = _arrSortedIndicators[nIndicatorIndex];
      var denomsAvailable = _checkDenominatorValues(objIndicator);
      var specialValues = _checkSpecialValues(objIndicator);

      if (
        (_bDisplayWeightedDenominators && denomsAvailable.D) ||
        (_bDisplayUnweightedDenominators && denomsAvailable.U) ||
        (_bDisplayTotals &&
          objIndicator.type === 'T' &&
          totals.indexOf(objIndicator.alias) > -1) ||
        (_bDisplaySpecialIndicators && specialValues.S) ||
        objIndicator.type === 'I'
      ) {
        //Check if the Indicator has any By Variables.
        var arrTemp =
          nameValueLib.getValue(_arrSortedByVariableLabels, [
            objIndicator.alias,
          ]) || [];
        if (arrTemp.length != 0) {
          if (!bByVarColumnAdded) {
            _addColumn(
              strByVariableLabelName,
              false,
              true,
              undefined,
              undefined,
              undefined
            );
            bByVarColumnAdded = true;
          }
          for (var nIndex = 0; nIndex < arrTemp.length; nIndex++) {
            if (arrByVarLabels.indexOf(arrTemp[nIndex]) == -1) {
              arrByVarLabels.push(arrTemp[nIndex]);
            }
          }
        } else {
          //Add Empty String.
          if (arrByVarLabels.indexOf('') == -1) {
            arrByVarLabels.push('');
          }
        }
      }
    }

    //Add the Characteristic Column (Char Cat + Char Label)
    _addColumn(
      strCharacteristicColName,
      false,
      true,
      undefined,
      undefined,
      undefined
    );

    //Loop through all the countries.
    for (
      var nCountryIndex = 0;
      nCountryIndex < arrCustomSortedCountriesSurveys.length;
      nCountryIndex++
    ) {
      //Get Current Country Object.
      var objCountry = arrCustomSortedCountriesSurveys[nCountryIndex];

      //Process only if country is selected.
      if (_arrUnSelectedCountries.indexOf(objCountry.name) == -1) {
        //Loop through all the surveys for the particular country.
        for (
          var nSurveyIndex = 0;
          nSurveyIndex < objCountry.value.length;
          nSurveyIndex++
        ) {
          //Get current Survey object.
          var objSurvey = objCountry.value[nSurveyIndex];

          //If survey is not enabled, ignore it.
          if (!objSurvey.value) {
            continue;
          }

          //For each By Variable Label.
          for (
            var nByVariableIndex = 0;
            nByVariableIndex < arrByVarLabels.length;
            nByVariableIndex++
          ) {
            //Obtain the By Variable Label.
            var strByVariableLabel = arrByVarLabels[nByVariableIndex];

            //Loop through all Char Cats for that survey.
            for (
              var nCharCatIndex = 0;
              nCharCatIndex < _arrSortedCharLabels.length;
              nCharCatIndex++
            ) {
              //Get Current Char Cat.
              var objCharCat = _arrSortedCharLabels[nCharCatIndex];

              //If Characteristic Category is not enabled, ignore it.
              if (arrEnabledCharCats.indexOf(objCharCat.name) == -1) {
                continue;
              }

              //Loop through all characteristic labels for the particular Char Cat.
              for (
                var nCharLabelIndex = 0;
                nCharLabelIndex < objCharCat.value.length;
                nCharLabelIndex++
              ) {
                //Get Current Char Label.
                var objCharLabel = objCharCat.value[nCharLabelIndex];
                //! added to sort by
                var objCharacteristicOrder = objCharLabel.alias;
                //If char label is not enabled or is a region that is not valid for this particular country/survey, ignore it.
                if (
                  !objCharLabel.value ||
                  (_isRegionCategory(objCharCat.name) &&
                    nameValueLib.objectExists(_arrSortedRegions, [
                      objCountry.name,
                      objSurvey.name,
                      objCharLabel.name,
                    ]) == -1)
                ) {
                  continue;
                }

                //Start New Row.
                var objNewRow = {};

                //Add Country / Survey / Char Cat / Char Label to Row.
                objNewRow[strCountryColName] = objCountry.name;
                objNewRow[strSurveyColName] = objSurvey.name;
                objNewRow[strByVariableLabelName] = strByVariableLabel;
                objNewRow.CharacteristicOrder = objCharacteristicOrder;
                if (
                  objCharCat.name != objCharLabel.name.toString() &&
                  objCharCat.name !== Config.getUniversalString('region') // Region does not match but is already formatted
                ) {
                  objNewRow[strCharacteristicColName] =
                    objCharCat.name + ' : ' + objCharLabel.name.toString();
                } else if (
                  objCharCat.name === Config.getUniversalString('region')
                ) {
                  objNewRow[strCharacteristicColName] = objCharLabel.name;
                } else {
                  objNewRow[strCharacteristicColName] = objCharCat.name;
                }
                objNewRow[strCharLabelIDColName] = nameValueLib.getAlias(
                  _arrSortedCharLabels,
                  [objCharCat.name, objCharLabel.name]
                );

                //Loop through Indicators for that label.
                for (
                  var nIndicatorIndex = 0;
                  nIndicatorIndex < _arrSortedIndicators.length;
                  nIndicatorIndex++
                ) {
                  //Get Current Indicators
                  var objIndicator = _arrSortedIndicators[nIndicatorIndex];
                  var denomsAvailable = _checkDenominatorValues(objIndicator);
                  var specialValues = _checkSpecialValues(objIndicator);

                  if (
                    (_bDisplayWeightedDenominators && denomsAvailable.D) ||
                    (_bDisplayUnweightedDenominators && denomsAvailable.U) ||
                    (_bDisplayTotals &&
                      objIndicator.type === 'T' &&
                      totals.indexOf(objIndicator.alias) > -1) ||
                    (_bDisplaySpecialIndicators && specialValues.S) ||
                    objIndicator.type === 'I'
                  ) {
                    //Obtain the value for the particular Inidicator.
                    strValue = nameValueLib
                      .getValueEmptyMixed(
                        _arrValues,
                        [
                          objCountry.name,
                          objSurvey.name,
                          objIndicator.alias,
                          objCharCat.name,
                          objCharLabel.name.toString(),
                          strByVariableLabel,
                        ],
                        [
                          g_nameProp,
                          g_nameProp,
                          g_aliasProp,
                          g_nameProp,
                          g_nameProp,
                          g_nameProp,
                        ]
                      )
                      .toString();
                    var objConfidenceIntervals = nameValueLib.getValueMixed(
                      _arrSortedConfidenceIntervals,
                      [
                        objCountry.name,
                        objSurvey.name,
                        objIndicator.alias,
                        objCharCat.name,
                        objCharLabel.name.toString(),
                        strByVariableLabel,
                      ],
                      [
                        g_nameProp,
                        g_nameProp,
                        g_aliasProp,
                        g_nameProp,
                        g_nameProp,
                        g_nameProp,
                      ]
                    );

                    const nameAliasCombo = `${objIndicator.name.replace(
                      /\s/g,
                      ''
                    )}${objIndicator.alias ? `_${objIndicator.alias}` : ''}`;

                    //Add data for this column to the row.
                    if (strValue) {
                      //Add name to the column list.
                      _addColumn(
                        objIndicator.name,
                        false,
                        false,
                        'float',
                        true,
                        objIndicator.alias,
                        denomsAvailable.D || denomsAvailable.U
                      );
                      if (
                        objConfidenceIntervals != null &&
                        objConfidenceIntervals[CONFIDENCE_INTERVAL.High] !=
                          '' &&
                        objConfidenceIntervals[CONFIDENCE_INTERVAL.Low] != ''
                      ) {
                        objNewRow[nameAliasCombo] =
                          Config.sanitizeNumberString(strValue) +
                          ' (CI: ' +
                          objConfidenceIntervals[CONFIDENCE_INTERVAL.Low] +
                          ' &#8211 ' +
                          objConfidenceIntervals[CONFIDENCE_INTERVAL.High] +
                          ')';
                      } else {
                        if (denomsAvailable.U || denomsAvailable.D) {
                          objNewRow[nameAliasCombo] =
                            '<i>' +
                            Config.sanitizeNumberString(strValue) +
                            '</i>';
                        } else {
                          objNewRow[nameAliasCombo] =
                            Config.sanitizeNumberString(strValue);
                        }
                      }
                    }
                  } //END for(var nIndicatorIndex = 0
                  //Add new row.
                  if (_arrGridData.length > 0) {
                    if (
                      objNewRow[Config.getUniversalString('country')] +
                        objNewRow[Config.getUniversalString('survey')] +
                        objNewRow.CharLabelID +
                        objNewRow.By !==
                      _arrGridData[_arrGridData.length - 1][
                        Config.getUniversalString('country')
                      ] +
                        _arrGridData[_arrGridData.length - 1][
                          Config.getUniversalString('survey')
                        ] +
                        _arrGridData[_arrGridData.length - 1].CharLabelID +
                        _arrGridData[_arrGridData.length - 1].By
                    ) {
                      _arrGridData.push(objNewRow);
                    }
                  } else {
                    _arrGridData.push(objNewRow);
                  }
                }
              } //END for(var nCharLabelIndex = 0
            } //END for(var nCharCatIndex = 0...
          } //END for(var nByVariableIndex = 0...
        } //END for(var nSurveyIndex = 0...
      } //END if(_arrUnSelectedCountries.indexOf(objCountry.name) == -1) {...
    } //END for(var nCountryIndex = 0...

    // Finally sort by CharacteristicOrder;

    _arrGridData = _.orderBy(
      _arrGridData,
      [strCountryColName, strSurveyColName, 'CharacteristicOrder'],
      ['asc', 'desc', 'asc']
    );
  };

  /**
   * @fn 		_createGridDataForCharCatSurveyPivot
   * @brief 	Creates data required for the grid for a Char Cat/Survey pivot.
   * @return 	void.
   */
  var _createGridDataForCharCatSurveyPivot = function () {
    _setGetGridOptionsState();

    var objColumnSuffix = {};
    var strStartColNameLvl1 = '';
    var nNumberOfColLvl1 = 0;
    var strStartColNameLvl2 = '';
    var nNumberOfColLvl2 = 0;
    var arrEnabledCharCats = [];
    var bByVarColumnAdded = false;
    var arrByVarLabels = [];
    var arrCustomSortedCountriesSurveys = [];
    //var countryHasDenominators = false;

    var strByVariableLabelName = Config.getUniversalString('by');
    var strCountryColName = Config.getUniversalString('country');
    var strSurveyColName = Config.getUniversalString('survey');
    var strCharacteristicColName = Config.getUniversalString('characteristic');
    var strCharLabelIDColName = 'CharLabelID';

    //Reset Grid Display Data.
    _resetGridDisplayData();

    //Create an array of all enabled Characteristic Categories.
    for (
      var nCharCatIndex = 0;
      nCharCatIndex < _arrSortedCharLabels.length;
      nCharCatIndex++
    ) {
      var objCharCat = _arrSortedCharLabels[nCharCatIndex];
      for (
        var nCharLabelIndex = 0;
        nCharLabelIndex < objCharCat.value.length;
        nCharLabelIndex++
      ) {
        var objCharLabel = objCharCat.value[nCharLabelIndex];
        if (objCharLabel.value) {
          arrEnabledCharCats.push(objCharCat.name);
          break;
        }
      }
    }

    _addGroupHeader(
      '',
      arrEnabledCharCats[0],
      arrEnabledCharCats.length,
      1,
      'charSur',
      undefined,
      undefined
    );

    //Create a custom descending order of surveys for each country.
    for (var nIndex = 0; nIndex < _arrSortedCountriesSurveys.length; nIndex++) {
      //Obtain the country object from the original array.
      var objCountry = _arrSortedCountriesSurveys[nIndex];

      //Reset the arrays for this country.
      var arrYears = [];
      var arrCustomSurveys = [];

      //Go through the surveys, reorder descending and add to the custom array.
      for (
        var nSurveyIndex = 0;
        nSurveyIndex < objCountry.value.length;
        nSurveyIndex++
      ) {
        //Get the original survey.
        var objTempSurvey = objCountry.value[nSurveyIndex];

        //Get the correct position to add the survey in (descending order).
        strSurveyYear = objTempSurvey.alias;
        var nCorrectPos = getSortedArrayIndex(arrYears, strSurveyYear, true);

        //If the correct location is found, add it there.
        if (nCorrectPos != -1) {
          arrCustomSurveys.splice(nCorrectPos, 0, objTempSurvey);
          arrYears.splice(nCorrectPos, 0, strSurveyYear);
        } else {
          //Add to end.
          arrCustomSurveys.push(objTempSurvey);
          arrYears.push(strSurveyYear);
        }
      }

      //Add Country to Custom Array.
      var objTempCountry = nameValueLib.createObject(
        objCountry.name,
        objCountry.alias,
        arrCustomSurveys,
        false
      );
      arrCustomSortedCountriesSurveys.push(objTempCountry);
    } //END for(var nIndex = 0; nIndex < _arrSortedCountriesSurveys.length...

    //Add the By Variable Column if needed and create a ByVariable Array.
    for (
      var nIndicatorIndex = 0;
      nIndicatorIndex < _arrSortedIndicators.length;
      nIndicatorIndex++
    ) {
      //Get the Indicator Name.
      var objIndicator = _arrSortedIndicators[nIndicatorIndex];
      var denomsAvailable = _checkDenominatorValues(objIndicator);
      var specialValues = _checkSpecialValues(objIndicator);
      if (
        (_bDisplayWeightedDenominators && denomsAvailable.D) ||
        (_bDisplayUnweightedDenominators && denomsAvailable.U) ||
        (_bDisplayTotals &&
          objIndicator.type === 'T' &&
          totals.indexOf(objIndicator.alias) > -1) ||
        (_bDisplaySpecialIndicators && specialValues.S) ||
        objIndicator.type === 'I'
      ) {
        //Check if the Indicator has any By Variables.
        var arrTemp =
          nameValueLib.getValue(_arrSortedByVariableLabels, [
            objIndicator.alias,
          ]) || [];
        if (arrTemp.length != 0) {
          if (!bByVarColumnAdded) {
            _addColumn(
              strByVariableLabelName,
              false,
              true,
              undefined,
              undefined,
              undefined,
              denomsAvailable.U || denomsAvailable.D
            );
            bByVarColumnAdded = true;
          }
          for (var nIndex = 0; nIndex < arrTemp.length; nIndex++) {
            if (arrByVarLabels.indexOf(arrTemp[nIndex]) == -1) {
              arrByVarLabels.push(arrTemp[nIndex]);
            }
          }
        } else {
          //Add Empty String.
          if (arrByVarLabels.indexOf('') == -1) {
            arrByVarLabels.push('');
          }
        }
      }
    }

    //Add the other columns.
    _addColumn(
      strCharacteristicColName,
      false,
      true,
      undefined,
      undefined,
      undefined,
      undefined
    ); //Add the Characteristic Column (Char Cat + Char Label)
    _addColumn(
      strCountryColName,
      false,
      true,
      undefined,
      undefined,
      undefined,
      undefined
    );
    _addColumn(
      strSurveyColName,
      false,
      true,
      undefined,
      undefined,
      undefined,
      undefined
    );

    //For each By Variable Label.
    for (
      var nByVariableIndex = 0;
      nByVariableIndex < arrByVarLabels.length;
      nByVariableIndex++
    ) {
      //Obtain the By Variable Label.
      var strByVariableLabel = arrByVarLabels[nByVariableIndex];

      //Loop through all Char Cats for that survey.
      for (
        var nCharCatIndex = 0;
        nCharCatIndex < _arrSortedCharLabels.length;
        nCharCatIndex++
      ) {
        //Get Current Char Cat.
        var objCharCat = _arrSortedCharLabels[nCharCatIndex];

        //If Characteristic Category is not enabled, ignore it.
        if (arrEnabledCharCats.indexOf(objCharCat.name) == -1) {
          continue;
        }

        //Loop through all characteristic labels for the particular Char Cat.
        for (
          var nCharLabelIndex = 0;
          nCharLabelIndex < objCharCat.value.length;
          nCharLabelIndex++
        ) {
          //Get Current Char Label.
          var objCharLabel = objCharCat.value[nCharLabelIndex];

          //If Char Label is not enabled, ignore it.
          if (
            !nameValueLib.getValue(_arrSortedCharLabels, [
              objCharCat.name,
              objCharLabel.name.toString(),
            ])
          ) {
            continue;
          }

          //Loop through all the countries.
          for (
            var nCountryIndex = 0;
            nCountryIndex < arrCustomSortedCountriesSurveys.length;
            nCountryIndex++
          ) {
            //Get Current Country Object.
            var objCountry = arrCustomSortedCountriesSurveys[nCountryIndex];

            //Process only if country is selected.
            if (_arrUnSelectedCountries.indexOf(objCountry.name) == -1) {
              //Loop through all the surveys for the particular country.
              for (
                var nSurveyIndex = 0;
                nSurveyIndex < objCountry.value.length;
                nSurveyIndex++
              ) {
                //Get current Survey object.
                var objSurvey = objCountry.value[nSurveyIndex];

                //If survey is not enabled or is a region that is not valid for this particular country/survey, ignore it.
                if (
                  !objSurvey.value ||
                  (_isRegionCategory(objCharCat.name) &&
                    nameValueLib.objectExists(_arrSortedRegions, [
                      objCountry.name,
                      objSurvey.name,
                      objCharLabel.name,
                    ]) == -1)
                ) {
                  continue;
                }
                //Start New Row.
                var objNewRow = {};

                //Add Country / Survey / Char Cat / Char Label to Row.
                objNewRow[strByVariableLabelName] = strByVariableLabel;
                objNewRow[strCharLabelIDColName] = nameValueLib.getAlias(
                  _arrSortedCharLabels,
                  [objCharCat.name, objCharLabel.name]
                );
                if (
                  objCharCat.name != objCharLabel.name.toString() &&
                  objCharCat.name !== Config.getUniversalString('region') // Region does not match but is already formatted
                ) {
                  objNewRow[strCharacteristicColName] =
                    objCharCat.name + ' : ' + objCharLabel.name.toString();
                } else if (
                  objCharCat.name === Config.getUniversalString('region')
                ) {
                  objNewRow[strCharacteristicColName] = objCharLabel.name;
                } else {
                  objNewRow[strCharacteristicColName] = objCharCat.name;
                }
                objNewRow[strCountryColName] = objCountry.name;
                objNewRow[strSurveyColName] = objSurvey.name;

                //Loop through Indicators for that label.
                for (
                  var nIndicatorIndex = 0;
                  nIndicatorIndex < _arrSortedIndicators.length;
                  nIndicatorIndex++
                ) {
                  var objDenominators = nameValueLib.getValueMixed(
                    _arrSortedDenominators,
                    [
                      objCountry.name,
                      objSurvey.name,
                      objIndicator.alias,
                      objCharCat.name,
                      objCharLabel.name.toString(),
                      strByVariableLabel,
                    ],
                    [
                      g_nameProp,
                      g_nameProp,
                      g_aliasProp,
                      g_nameProp,
                      g_nameProp,
                      g_nameProp,
                    ]
                  );

                  //Get Current Indicators
                  var objIndicator = _arrSortedIndicators[nIndicatorIndex];
                  var denomsAvailable = _checkDenominatorValues(objIndicator);
                  var specialValues = _checkSpecialValues(objIndicator);

                  if (
                    (_bDisplayWeightedDenominators && denomsAvailable.D) ||
                    (_bDisplayUnweightedDenominators && denomsAvailable.U) ||
                    (_bDisplayTotals &&
                      objIndicator.type === 'T' &&
                      totals.indexOf(_arrSortedIndicators.alias) > -1) ||
                    (_bDisplaySpecialIndicators && specialValues.S) ||
                    objIndicator.type === 'I'
                  ) {
                    //Obtain the value for the particular Inidicator.
                    var strValue = nameValueLib
                      .getValueEmptyMixed(
                        _arrValues,
                        [
                          objCountry.name,
                          objSurvey.name,
                          objIndicator.alias,
                          objCharCat.name,
                          objCharLabel.name.toString(),
                          strByVariableLabel,
                        ],
                        [
                          g_nameProp,
                          g_nameProp,
                          g_aliasProp,
                          g_nameProp,
                          g_nameProp,
                          g_nameProp,
                        ]
                      )
                      .toString();
                    var objConfidenceIntervals = nameValueLib.getValueMixed(
                      _arrSortedConfidenceIntervals,
                      [
                        objCountry.name,
                        objSurvey.name,
                        objIndicator.alias,
                        objCharCat.name,
                        objCharLabel.name.toString(),
                        strByVariableLabel,
                      ],
                      [
                        g_nameProp,
                        g_nameProp,
                        g_aliasProp,
                        g_nameProp,
                        g_nameProp,
                        g_nameProp,
                      ]
                    );

                    const strCleansedColumnName = objIndicator.name.replace(
                      /\s/g,
                      ''
                    );
                    const strNameAliasColName = `${strCleansedColumnName}${
                      objIndicator.alias ? `_${objIndicator.alias}` : ''
                    }`;
                    //Add data for this column to the row.
                    if (strValue) {
                      //Add name to the column list.
                      _addColumn(
                        objIndicator.name,
                        false,
                        false,
                        'float',
                        true,
                        objIndicator.alias,
                        denomsAvailable.D || denomsAvailable.U
                      );
                      if (
                        objConfidenceIntervals != null &&
                        objConfidenceIntervals[CONFIDENCE_INTERVAL.High] !=
                          '' &&
                        objConfidenceIntervals[CONFIDENCE_INTERVAL.Low] != ''
                      ) {
                        objNewRow[strNameAliasColName] =
                          Config.sanitizeNumberString(strValue) +
                          ' (CI: ' +
                          objConfidenceIntervals[CONFIDENCE_INTERVAL.Low] +
                          ' &#8211 ' +
                          objConfidenceIntervals[CONFIDENCE_INTERVAL.High] +
                          ')';
                      } else {
                        if (denomsAvailable.U || denomsAvailable.D) {
                          objNewRow[strNameAliasColName] =
                            '<i>' +
                            Config.sanitizeNumberString(strValue) +
                            '</i>';
                        } else {
                          objNewRow[strNameAliasColName] =
                            Config.sanitizeNumberString(strValue);
                        }
                      }
                    }
                  } //END for(var nIndicatorIndex = 0...
                }
                //Add new row.
                _arrGridData.push(objNewRow);
              } //END for(var nSurveyIndex = 0...
            } //END if(_arrUnSelectedCountries.indexOf(objCountry.name) == -1) {...
          } //END for(var nCountryIndex = 0...
        } //END for(var nCharLabelIndex = 0...
      } //END for(var nCharCatIndex = 0...
    } //END for(var nByVariableIndex = 0...
  };

  /**
   * @fn 		_createColumnChartData
   * @brief 	Creates data required for the Column chart. Chart data is only for a single indicator.
   * @param	indicatorId: The currently selected indicator ID.
   * @return 	void.
   */
  var _createColumnChartData = function (indicatorId) {
    //Reset Graph Display Data.
    _resetColumnGraphDisplayData();

    //Go through each Country/Survey to create Categories.
    $.each(_arrSortedCountriesSurveys, function (countryIndex, objCountry) {
      //If country has been unchecked, ignore it.
      if (_arrUnSelectedCountries.indexOf(objCountry.name) == -1) {
        $.each(objCountry.value, function (surveyIndex, objSurvey) {
          //if Survey is not enabled, ignore it.
          if (!objSurvey.value) {
            return;
          }

          //Create Category Name.

          var strCategory =
            '<span>' + objCountry.name + '<br />' + objSurvey.name + '</span>';
          //Add Category to High Charts.
          _arrHighChartsColumnCategories.push(strCategory);
        });
      }
    });

    var _currIndicatorId = indicatorId;

    //Go through each enabled label and create a series name array.
    $.each(_arrSortedCharLabels, function (charCatIndex, objCharCat) {
      $.each(objCharCat.value, function (charLabelIndex, objCharLabel) {
        var existsFromNameValueLib = nameValueLib.objectExistsMixed(
          _arrSortedIndicators,
          [_currIndicatorId, objCharCat.name],
          [g_aliasProp, g_nameProp]
        );

        if (existsFromNameValueLib > -1) {
          //If not enabled, value is null or if category is region, ignore it.
          if (!objCharLabel.value || _isRegionCategory(objCharCat.name)) {
            return;
          }

          //Add name to series.
          _arrHighChartsColumnSeriesNames.push(
            objCharCat.name + ':' + objCharLabel.name.toString()
          );

          //Add name to Confidence Interval series.
          _arrHighChartsColumnCISeriesNames.push(
            objCharCat.name + ':' + objCharLabel.name.toString() + '_CI'
          );
        }
      });
    });

    //Go through each series to create survey values.
    $.each(_arrHighChartsColumnSeriesNames, function (index, strSeries) {
      //Split the string to get the Char Cat and Char Label.
      var arrTemp = strSeries.split(':');
      var strCharCat = arrTemp[0];
      var strCharLabel = arrTemp[1];

      //Add a new series value.
      _arrHighChartsColumnSeriesValues[strSeries] = [];

      //Add a new Confidence Interval series value.
      _arrHighChartsColumnCISeriesValues[
        _arrHighChartsColumnCISeriesNames[index]
      ] = [];

      //Go through each Country/Survey to obtain the values.
      $.each(_arrSortedCountriesSurveys, function (countryIndex, objCountry) {
        //If country has been unchecked, ignore it.
        if (_arrUnSelectedCountries.indexOf(objCountry.name) == -1) {
          $.each(objCountry.value, function (surveyIndex, objSurvey) {
            //if Survey is not enabled, ignore it.
            if (!objSurvey.value) {
              return;
            }

            //Obtain the value for the particular Indicator.
            var strValue = '';
            var arrCI = [null, null];

            //First obtain the ByVariable if any.

            // var strByVarLabel = byVariableState.get(
            // 	indicatorName + '.current',
            // 	''
            //   );
            var arrAllByVariable = byVariableState.get(indicatorId, '');
            if (arrAllByVariable.current) {
              var strByVarLabel = arrAllByVariable.current;
            } else {
              var strByVarLabel = byVariableState.get(
                indicatorId + '.current',
                ''
              );
            }

            //Get the Value.
            if (
              nameValueLib.objectExistsMixed(
                _arrValues,
                [
                  objCountry.name,
                  objSurvey.name,
                  indicatorId,
                  strCharCat,
                  strCharLabel,
                  strByVarLabel,
                ],
                [
                  g_nameProp,
                  g_nameProp,
                  g_aliasProp,
                  g_nameProp,
                  g_nameProp,
                  g_nameProp,
                ]
              ) != -1
            ) {
              strValue = nameValueLib.getValueMixed(
                _arrValues,
                [
                  objCountry.name,
                  objSurvey.name,
                  indicatorId,
                  strCharCat,
                  strCharLabel,
                  strByVarLabel,
                ],
                [
                  g_nameProp,
                  g_nameProp,
                  g_aliasProp,
                  g_nameProp,
                  g_nameProp,
                  g_nameProp,
                ]
              );
              strValue = parseFloat(strValue);
              //Keep a check on min/max value. To be used for Y-Axis display.
              _nHighChartsMinYValue = Math.min(_nHighChartsMinYValue, strValue);
              _nHighChartsMaxYValue = Math.max(_nHighChartsMaxYValue, strValue);
            }

            _arrHighChartsColumnSeriesValues[strSeries].push(strValue);
            //Get the Confidence Interval Values.
            if (
              nameValueLib.objectExistsMixed(
                _arrSortedConfidenceIntervals,
                [
                  objCountry.name,
                  objSurvey.name,
                  indicatorId,
                  strCharCat,
                  strCharLabel,
                  strByVarLabel,
                ],
                [
                  g_nameProp,
                  g_nameProp,
                  g_aliasProp,
                  g_nameProp,
                  g_nameProp,
                  g_nameProp,
                ]
              ) != -1
            ) {
              var objCI = nameValueLib.getValueMixed(
                _arrSortedConfidenceIntervals,
                [
                  objCountry.name,
                  objSurvey.name,
                  indicatorId,
                  strCharCat,
                  strCharLabel,
                  strByVarLabel,
                ],
                [
                  g_nameProp,
                  g_nameProp,
                  g_aliasProp,
                  g_nameProp,
                  g_nameProp,
                  g_nameProp,
                ]
              );

              //Get the Low/High value.
              if (
                objCI != null &&
                objCI[CONFIDENCE_INTERVAL.Low] != '' &&
                objCI[CONFIDENCE_INTERVAL.High] != ''
              ) {
                arrCI = [];

                arrCI.push(parseFloat(objCI[CONFIDENCE_INTERVAL.Low]));
                arrCI.push(parseFloat(objCI[CONFIDENCE_INTERVAL.High]));

                //Keep a check on min/max value. To be used for Y-Axis display.
                _nHighChartsMinYValue = Math.min(
                  _nHighChartsMinYValue,
                  objCI[CONFIDENCE_INTERVAL.Low]
                );
                _nHighChartsMaxYValue = Math.max(
                  _nHighChartsMaxYValue,
                  objCI[CONFIDENCE_INTERVAL.High]
                );

                //Mark there is actually CI data.
                _bHighChartsHasConfidenceIntervals = true;
              }
            }
            //Push as new CI series values.
            _arrHighChartsColumnCISeriesValues[
              _arrHighChartsColumnCISeriesNames[index]
            ].push(arrCI);
          });
        }
      });
    });

    //In order to hide the categories that have no data, we have to go through each series to check which category has no data.
    for (
      var nCurCategory = 0;
      nCurCategory < _arrHighChartsColumnCategories.length;
      nCurCategory++
    ) {
      var bCategoryEmpty = true;

      //Go through each series to check this specific category.
      for (
        var nCurSeries = 0;
        nCurSeries < _arrHighChartsColumnSeriesNames.length;
        nCurSeries++
      ) {
        if (
          _arrHighChartsColumnSeriesValues[
            _arrHighChartsColumnSeriesNames[nCurSeries]
          ][nCurCategory] != ''
        ) {
          bCategoryEmpty = false;
          break;
        }
      }

      //If Category is empty, remove it.
      if (bCategoryEmpty) {
        //Remove Category from the Category Array.
        _arrHighChartsColumnCategories.splice(nCurCategory, 1);

        //Remove Category from all series arrays.
        for (
          var nCurSeries = 0;
          nCurSeries < _arrHighChartsColumnSeriesNames.length;
          nCurSeries++
        ) {
          _arrHighChartsColumnSeriesValues[
            _arrHighChartsColumnSeriesNames[nCurSeries]
          ].splice([nCurCategory], 1);
        }

        //Remove Category from all CI series arrays.
        for (
          var nCurSeries = 0;
          nCurSeries < _arrHighChartsColumnCISeriesNames.length;
          nCurSeries++
        ) {
          _arrHighChartsColumnCISeriesValues[
            _arrHighChartsColumnCISeriesNames[nCurSeries]
          ].splice([nCurCategory], 1);
        }

        //Reset Current Category to make sure you do not skip a category.
        nCurCategory--;
      }
    }

    //Finalize Max value. Simply add 10% more to the max value.
    _nHighChartsMaxYValue = (_nHighChartsMaxYValue * 1.1).toFixed(
      nameValueLib.getValueEX(_arrPrecision, [_strSelectedIndicatorCode])
    );
  };

  /**
   * @fn 		_createLineChartData
   * @brief 	Creates data required for the Line chart. Chart data is only for a single indicator.
   * @param	indicatorId: The currently selected indicator name.
   * @return 	void.
   */
  var _createLineChartData = function (indicatorId) {
    //Declare Important Variables.
    var arrYears = []; //This will be all the years that are in the surveys being charted.
    var arrCountries = []; //This will be all the countries there are surveys for.

    //Reset Graph Display Data.
    _resetLineGraphDisplayData();

    //Get the minimum and Maximum Year Range and create a Years array for the range.
    for (
      var nCurYear = _strCurYearRange.min;
      nCurYear <= _strCurYearRange.max;
      nCurYear++
    ) {
      arrYears.push(nCurYear);
    }

    //Sort the years.
    arrYears.sort();

    //Go through each Country/Surveys array and add the counrty to the array if even a single survey is enabled.
    $.each(_arrSortedCountriesSurveys, function (countryIndex, objCountry) {
      if (_arrUnSelectedCountries.indexOf(objCountry.name) == -1) {
        $.each(objCountry.value, function (surveyIndex, objSurvey) {
          //if Survey is not enabled, ignore it.
          if (!objSurvey.value) {
            return;
          }

          //Add country to array, if it does not already exist.
          if (arrCountries.indexOf(objCountry.name) == -1) {
            arrCountries.push(objCountry.name);
          }
        });
      }
    });

    //Create categories from all the years.
    _arrHighChartsLineCategories = arrYears;
    //Go through each enabled label and create a series name array.
    $.each(arrCountries, function (nIndex, countryName) {
      $.each(_arrSortedCharLabels, function (charCatIndex, objCharCat) {
        $.each(objCharCat.value, function (charLabelIndex, objCharLabel) {
          //If not enabled or if category is region, ignore it.
          if (!objCharLabel.value || _isRegionCategory(objCharCat.name)) {
            return;
          }

          //Check to make sure the category/label are part of this indicator.
          if (
            nameValueLib.objectExistsMixed(
              _arrSortedIndicators,
              [
                _strSelectedIndicatorCode,
                objCharCat.name,
                objCharLabel.name.toString(),
              ],
              [g_aliasProp, g_nameProp, g_nameProp]
            ) === -1
          ) {
            return;
          }

          //Add name to series.
          _arrHighChartsLineSeriesNames.push(
            countryName +
              ':' +
              objCharCat.name +
              ':' +
              objCharLabel.name.toString()
          );

          //Add name to Confidence Interval Series.
          _arrHighChartsLineCISeriesNames.push(
            countryName +
              ':' +
              objCharCat.name +
              ':' +
              objCharLabel.name.toString() +
              '_CI'
          );
        });
      });
    });

    //Now go through each country / char cat / year to get the values and create series values.
    $.each(_arrHighChartsLineSeriesNames, function (seriesIndex, seriesName) {
      //Split the string to get the country Name, Char Cat and Char Label.
      var arrTemp = seriesName.split(':');
      var strCountryName = arrTemp[0];
      var strCharCat = arrTemp[1];
      var strCharLabel = arrTemp[2];

      //Obtain the array of surveys for this country.
      var arrSurveys = nameValueLib.getValue(_arrSortedCountriesSurveys, [
        strCountryName,
      ]);

      //Setup a new array for the series.
      var arrNewSeriesValues = [];

      //Setup a new array for the Confidence Interval series.
      var arrNewSeriesCIValues = [];

      $.each(arrYears, function (nIndex, nYear) {
        var strValue = null;
        var arrCI = [null, null];

        //If you find a survey that matches the year.
        var nArrIndex = nameValueLib.objectExistsEX(arrSurveys, [nYear]);
        if (nArrIndex != -1) {
          //If the survey is enabled.
          if (arrSurveys[nArrIndex].value) {
            //Get the Value, if it exists.
            //First obtain the ByVariable if any.
            var arrAllByVariable = byVariableState.get(indicatorId, []);
            if (arrAllByVariable.current) {
              var strByVarLabel = arrAllByVariable.current;
              if (Array.isArray(strByVarLabel)) {
                strByVarLabel = strByVarLabel[0];
              }
            } else {
              var strByVarLabel = '';
            }

            if (
              nameValueLib.objectExistsMixed(
                _arrValues,
                [
                  strCountryName,
                  arrSurveys[nArrIndex].name,
                  indicatorId,
                  strCharCat,
                  strCharLabel,
                  strByVarLabel,
                ],
                [
                  g_nameProp,
                  g_nameProp,
                  g_aliasProp,
                  g_nameProp,
                  g_nameProp,
                  g_nameProp,
                ]
              ) != -1
            ) {
              strValue = nameValueLib.getValueMixed(
                _arrValues,
                [
                  strCountryName,
                  arrSurveys[nArrIndex].name,
                  indicatorId,
                  strCharCat,
                  strCharLabel,
                  strByVarLabel,
                ],
                [
                  g_nameProp,
                  g_nameProp,
                  g_aliasProp,
                  g_nameProp,
                  g_nameProp,
                  g_nameProp,
                ]
              );
              strValue = parseFloat(strValue);

              //Keep a check on min/max value. To be used for Y-Axis display.
              _nHighChartsMinYValue = Math.min(_nHighChartsMinYValue, strValue);
              _nHighChartsMaxYValue = Math.max(_nHighChartsMaxYValue, strValue);
            }

            //Get the Confidence Interval Values.
            if (
              nameValueLib.objectExistsMixed(
                _arrSortedConfidenceIntervals,
                [
                  strCountryName,
                  arrSurveys[nArrIndex].name,
                  indicatorId,
                  strCharCat,
                  strCharLabel,
                  strByVarLabel,
                ],
                [
                  g_nameProp,
                  g_nameProp,
                  g_aliasProp,
                  g_nameProp,
                  g_nameProp,
                  g_nameProp,
                ]
              ) != -1
            ) {
              var objCI = nameValueLib.getValueMixed(
                _arrSortedConfidenceIntervals,
                [
                  strCountryName,
                  arrSurveys[nArrIndex].name,
                  indicatorId,
                  strCharCat,
                  strCharLabel,
                  strByVarLabel,
                ],
                [
                  g_nameProp,
                  g_nameProp,
                  g_aliasProp,
                  g_nameProp,
                  g_nameProp,
                  g_nameProp,
                ]
              );

              //Get the Low/High value.
              if (
                objCI[CONFIDENCE_INTERVAL.Low] != '' &&
                objCI[CONFIDENCE_INTERVAL.High] != ''
              ) {
                arrCI = [];
                arrCI.push(parseFloat(objCI[CONFIDENCE_INTERVAL.Low]));
                arrCI.push(parseFloat(objCI[CONFIDENCE_INTERVAL.High]));

                //Keep a check on min/max value. To be used for Y-Axis display.
                _nHighChartsMinYValue = Math.min(
                  _nHighChartsMinYValue,
                  objCI[CONFIDENCE_INTERVAL.Low]
                );
                _nHighChartsMaxYValue = Math.max(
                  _nHighChartsMaxYValue,
                  objCI[CONFIDENCE_INTERVAL.High]
                );

                //Mark there is actually CI data.
                _bHighChartsHasConfidenceIntervals = true;
              }
            }
          }
        }

        //Add the value to the series in the correct spot.
        arrNewSeriesValues.push(strValue);

        //Add the value to the Confidence Interval series in the correct spot.
        arrNewSeriesCIValues.push(arrCI);
      });

      //Push as new series values.
      _arrHighChartsLineSeriesValues[seriesName] = arrNewSeriesValues;

      //Push as new CI series values.
      _arrHighChartsLineCISeriesValues[
        _arrHighChartsLineCISeriesNames[seriesIndex]
      ] = arrNewSeriesCIValues;
    });

    //Finalize Max value. Simply add 10% more to the max value.
    _nHighChartsMaxYValue = (_nHighChartsMaxYValue * 1.1).toFixed(
      nameValueLib.getValueEX(_arrPrecision, [_strSelectedIndicatorCode])
    );
    // chart.xAxis[0].redraw();
  };

  /**
   * @fn 		_createMapData
   * @brief 	Creates data required for the map. Map data is only for a single indicator.
   * @param	indicatorId: The currently selected indicator name.
   * @return 	void.
   */
  var _createMapData = function (indicatorId) {
    //Declare Important Variables.
    var strSurveyName = '';

    //Clear Map Data Array.
    _arrNationalMapData = [];
    _arrNationalMapCIData = [];
    _arrNationalAllMapData = [];
    _arrNationalAllMapCIData = [];
    _arrNationalMapValues = [];
    _arrSubnationalMapData = [];
    _arrSubnationalAllMapData = [];
    _arrSubnationalAllMapCIData = [];
    _arrSubnationalMapCIData = [];
    _arrSubnationalMapValues = [];
    _customObjCountryValues = [];

    let currTotalObj = nameValueLib.getObjectEX(_arrSortedTotals, [
      indicatorId,
    ]);

    if (currTotalObj === null) {
      currTotalObj = _arrSortedTotals[0];
    }

    //Set Total to be the Char Cat for the selected indicator.
    _strCurMapCharCat = currTotalObj ? currTotalObj.name : '';

    //Set Total to be the Char label for the specified Char Cat.
    _strCurMapCharLabel = currTotalObj ? currTotalObj.value : '';

    //Obtain the By Variable Label for the specified indicator.
    var arrAllByVariable = byVariableState.get(indicatorId, []);
    if (arrAllByVariable.current) {
      var strByVarLabel = arrAllByVariable.current;
      if (Array.isArray(strByVarLabel)) {
        strByVarLabel = strByVarLabel[0];
      }
    } else {
      var strByVarLabel = '';
    }

    //Loop through all countries to setup map data.
    $.each(_arrSortedCountriesSurveys, function (countryIndex, objCountry) {
      //If the country is selected.

      if (_arrUnSelectedCountries.indexOf(objCountry.name) == -1) {
        //Reset Survey Name.
        strSurveyName = '';
        getLastValueInArr = '';

        //Make sure there are surveys for the country before you look for the selected survey.
        if (objCountry.value.length != 0) {
          _currDisplay = statCompilerDashboard.getCurrentDisplayType();
          //If survey selection is custom, obtain the custom survey selected.
          //Just take the last/most recent survey if it is selected. (Accounting for disabled countries)
          //Also account for surveys which may not have a value.
          //strSurveyName = objCountry.value[objCountry.value.length - 1].name;

          if (_curSurveySelection == 'Custom') {
            // Use a per-country local array so surveys from different countries
            // don't accumulate across loop iterations (old module-level
            // _customObjCountryValues was never reset between countries).
            var _customCountryValues = [];
            _arrCustomSurveySelectionsMap.forEach(function (obj) {
              objCountry.value.forEach(function (objCountryValue) {
                if (obj.value == objCountryValue.name) {
                  _customCountryValues.push(objCountryValue);
                }
              });
            });
            getLastValueInArr = _customCountryValues.slice(-1);
          } else {
            getLastValueInArr = objCountry.value.slice(-1);
          }
          // Guard: if a country has no surveys matching the custom selection
          // (e.g. no MIS surveys when MIS type is chosen), leave strSurveyName
          // as '' so the inner survey loop below produces no map data for it.
          if (getLastValueInArr.length > 0) {
            strSurveyName = getLastValueInArr[0].name;
          }
        }
        //Go through all the surveys to add data to the values and data array.
        $.each(objCountry.value, function (surveyIndex, objSurvey) {
          //Get the Survey Value (National).
          var strNationalValue = nameValueLib.getValueMixed(
            _arrValues,
            [
              objCountry.name,
              objSurvey.name,
              indicatorId,
              _strCurMapCharCat,
              _strCurMapCharLabel,
              strByVarLabel,
            ],
            [
              g_nameProp,
              g_nameProp,
              g_aliasProp,
              g_nameProp,
              g_nameProp,
              g_nameProp,
            ]
          );

          //Get the Survey Confidence Intervals (National).
          var objCIValues = nameValueLib.getValueMixed(
            _arrSortedConfidenceIntervals,
            [
              objCountry.name,
              objSurvey.name,
              indicatorId,
              _strCurMapCharCat,
              _strCurMapCharLabel,
              strByVarLabel,
            ],
            [
              g_nameProp,
              g_nameProp,
              g_aliasProp,
              g_nameProp,
              g_nameProp,
              g_nameProp,
            ]
          );

          ////////////////////////////////////////////
          //SETUP CI National DATA.
          ////////////////////////////////////////////
          if (objSurvey.name == strSurveyName) {
            //Add Confidence Interval.
            var arrCI = [null, null];
            if (objCIValues != null) {
              //Get the Low/High value.
              if (
                objCIValues[CONFIDENCE_INTERVAL.Low] != '' &&
                objCIValues[CONFIDENCE_INTERVAL.High] != ''
              ) {
                arrCI = [];
                arrCI.push(parseFloat(objCIValues[CONFIDENCE_INTERVAL.Low]));
                arrCI.push(parseFloat(objCIValues[CONFIDENCE_INTERVAL.High]));
              }
            }

            //Create an Object and add to the CI Data Array.
            var newNationalCISurveyObject = nameValueLib.createObject(
              objSurvey.name,
              objSurvey.alias,
              arrCI,
              false
            );

            //Add to Map Data.
            if (
              nameValueLib.objectExists(_arrNationalMapCIData, [
                objCountry.name,
              ]) == -1
            ) {
              var newObj = nameValueLib.createObject(
                objCountry.name,
                objCountry.alias,
                [newNationalCISurveyObject],
                false
              );
              _arrNationalMapCIData.push(newObj);
            } else {
              var arrSurveys = nameValueLib.getValue(_arrNationalMapCIData, [
                objCountry.name,
              ]);
              arrSurveys.push(newNationalCISurveyObject);
            }
          }

          ////////////////////////////////////////////
          //SETUP SUBNATIONAL DATA.
          ////////////////////////////////////////////

          //Obtain all the region names and values for this survey.
          var arrSubNationalRegions = nameValueLib.getValue(_arrSortedRegions, [
            objCountry.name,
            objSurvey.name,
          ]);
          //If their are regions available for the particular survey, loop through the regions to create the subnational data.
          if (typeof arrSubNationalRegions != undefined) {
            $.each(arrSubNationalRegions, function (index, objRegion) {
              //Obtain the region name.
              var strRegionName = objRegion.name;
              //Obtain the region ID.
              var strRegionID = objRegion.alias;
              //Obtain the Region Value.
              var strRegionValue = nameValueLib.getValueMixed(
                arrSubNationalRegions,
                [strRegionName, _strSelectedIndicatorCode, strByVarLabel],
                [g_nameProp, g_aliasProp, g_nameProp]
              );
              //Obtain the Region Confidence Intervals.
              var objRegionCIValues = nameValueLib.getValueMixed(
                _arrSortedConfidenceIntervals,
                [
                  objCountry.name,
                  objSurvey.name,
                  indicatorId,
                  _strRegionCharCat,
                  strRegionName,
                  strByVarLabel,
                ],
                [
                  g_nameProp,
                  g_nameProp,
                  g_aliasProp,
                  g_nameProp,
                  g_nameProp,
                  g_nameProp,
                ]
              );

              //If selected survey, create an object and add the survey to the data array.
              if (objSurvey.name == strSurveyName) {
                if (strRegionValue != null) {
                  //Create a new object
                  var objRegion = nameValueLib.createObject(
                    strRegionName,
                    strRegionID,
                    strRegionValue,
                    false
                  );

                  //Create a new CI object
                  var arrRegionCIValues = [null, null];
                  if (
                    objRegionCIValues != null &&
                    objRegionCIValues[CONFIDENCE_INTERVAL.Low] != '' &&
                    objRegionCIValues[CONFIDENCE_INTERVAL.High] != ''
                  ) {
                    arrRegionCIValues = [];
                    arrRegionCIValues.push(
                      parseFloat(objRegionCIValues[CONFIDENCE_INTERVAL.Low])
                    );
                    arrRegionCIValues.push(
                      parseFloat(objRegionCIValues[CONFIDENCE_INTERVAL.High])
                    );
                  }
                  var objCIRegion = nameValueLib.createObject(
                    strRegionName,
                    strRegionID,
                    arrRegionCIValues,
                    false
                  );

                  //Add to Subnational CI Map Data.
                  if (
                    nameValueLib.objectExists(_arrSubnationalMapCIData, [
                      objCountry.name,
                    ]) == -1
                  ) {
                    var newObj = nameValueLib.createObject(
                      objCountry.name,
                      objCountry.alias,
                      nameValueLib.createObject(
                        objSurvey.name,
                        objSurvey.alias,
                        [objCIRegion],
                        true
                      ),
                      false
                    );
                    _arrSubnationalMapCIData.push(newObj);
                  } else if (
                    nameValueLib.objectExists(_arrSubnationalMapCIData, [
                      objCountry.name,
                      objSurvey.name,
                    ]) == -1
                  ) {
                    var newObj = nameValueLib.createObject(
                      objSurvey.name,
                      objSurvey.alias,
                      [objCIRegion],
                      false
                    );
                    _arrSubnationalMapCIData.push(newObj);
                  } else {
                    var arrSurveys = nameValueLib.getValue(
                      _arrSubnationalMapCIData,
                      [objCountry.name, objSurvey.name]
                    );
                    arrSurveys.push(objCIRegion);
                  }
                }
              }

              var objRegion = nameValueLib.createObject(
                strRegionName,
                strRegionID,
                strRegionValue,
                false
              );

              //Create a new CI object
              var arrRegionCIValues = [null, null];
              if (
                objRegionCIValues != null &&
                objRegionCIValues[CONFIDENCE_INTERVAL.Low] != '' &&
                objRegionCIValues[CONFIDENCE_INTERVAL.High] != ''
              ) {
                arrRegionCIValues = [];
                arrRegionCIValues.push(
                  parseFloat(objRegionCIValues[CONFIDENCE_INTERVAL.Low])
                );
                arrRegionCIValues.push(
                  parseFloat(objRegionCIValues[CONFIDENCE_INTERVAL.High])
                );
              }
              var objCIRegion = nameValueLib.createObject(
                strRegionName,
                strRegionID,
                arrRegionCIValues,
                false
              );

              //Add to Subnational All Map Data.
              if (objRegion.value !== null) {
                if (
                  nameValueLib.objectExists(_arrSubnationalAllMapData, [
                    objCountry.name,
                  ]) == -1
                ) {
                  var newObj = nameValueLib.createObject(
                    objCountry.name,
                    objCountry.alias,
                    nameValueLib.createObject(
                      objSurvey.name,
                      objSurvey.alias,
                      [objRegion],
                      true
                    ),
                    false
                  );
                  _arrSubnationalAllMapData.push(newObj);
                } else if (
                  nameValueLib.objectExists(_arrSubnationalAllMapData, [
                    objCountry.name,
                    objSurvey.name,
                  ]) == -1
                ) {
                  var newObj = nameValueLib.createObject(
                    objSurvey.name,
                    objSurvey.alias,
                    [objRegion],
                    false
                  );
                  var arrSurvey = nameValueLib.getValue(
                    _arrSubnationalAllMapData,
                    [objCountry.name]
                  );
                  arrSurvey.push(newObj);
                } else {
                  var arrSubnationalRegions = nameValueLib.getValue(
                    _arrSubnationalAllMapData,
                    [objCountry.name, objSurvey.name]
                  );
                  arrSubnationalRegions.push(objRegion);
                }
              }

              //Add to Subnational CI Map Data.
              if (
                nameValueLib.objectExists(_arrSubnationalAllMapCIData, [
                  objCountry.name,
                ]) == -1
              ) {
                var newObj = nameValueLib.createObject(
                  objCountry.name,
                  objCountry.alias,
                  nameValueLib.createObject(
                    objSurvey.name,
                    objSurvey.alias,
                    [objCIRegion],
                    true
                  ),
                  false
                );
                _arrSubnationalAllMapCIData.push(newObj);
              } else if (
                nameValueLib.objectExists(_arrSubnationalAllMapCIData, [
                  objCountry.name,
                  objSurvey.name,
                ]) == -1
              ) {
                var newObj = nameValueLib.createObject(
                  objSurvey.name,
                  objSurvey.alias,
                  [objCIRegion],
                  false
                );
                var arrSurvey = nameValueLib.getValue(
                  _arrSubnationalAllMapCIData,
                  [objCountry.name]
                );
                arrSurvey.push(newObj);
              } else {
                var arrSubnationalRegions = nameValueLib.getValue(
                  _arrSubnationalAllMapCIData,
                  [objCountry.name, objSurvey.name]
                );
                arrSubnationalRegions.push(objCIRegion);
              }
            }); //END $.each(arrSubNationalRegions, function(index, objRegion)) {...
          }

          //If the survey actually has a value (i.e. not null), add it to all map data.
          if (strNationalValue != null) {
            //Create an Object and add to the All Data Array.
            var newAllNationalSurveyObject = nameValueLib.createObject(
              objSurvey.name,
              objSurvey.alias,
              strNationalValue,
              false
            );

            //Add to Map Data.
            if (
              nameValueLib.objectExists(_arrNationalAllMapData, [
                objCountry.name,
              ]) == -1
            ) {
              var newObj = nameValueLib.createObject(
                objCountry.name,
                objCountry.alias,
                [newAllNationalSurveyObject],
                false
              );
              _arrNationalAllMapData.push(newObj);
            } else {
              var arrSurveys = nameValueLib.getValue(_arrNationalAllMapData, [
                objCountry.name,
              ]);
              arrSurveys.push(newAllNationalSurveyObject);
            }

            ////////////////////////////////////////////
            //SETUP ALL CI DATA.
            ////////////////////////////////////////////

            //If the survey has a value for Confidence Intervals, add those as well.
            var arrCI = [null, null];
            if (objCIValues != null) {
              //Get the Low/High value.
              if (
                objCIValues[CONFIDENCE_INTERVAL.Low] != '' &&
                objCIValues[CONFIDENCE_INTERVAL.High] != ''
              ) {
                arrCI = [];
                arrCI.push(parseFloat(objCIValues[CONFIDENCE_INTERVAL.Low]));
                arrCI.push(parseFloat(objCIValues[CONFIDENCE_INTERVAL.High]));
              }
            }

            //Create an Object and add to the All Data Array.
            var newAllNationalCISurveyObject = nameValueLib.createObject(
              objSurvey.name,
              objSurvey.alias,
              arrCI,
              false
            );

            //Add to Map Data.
            if (
              nameValueLib.objectExists(_arrNationalAllMapCIData, [
                objCountry.name,
              ]) == -1
            ) {
              var newObj = nameValueLib.createObject(
                objCountry.name,
                objCountry.alias,
                [newAllNationalCISurveyObject],
                false
              );
              _arrNationalAllMapCIData.push(newObj);
            } else {
              var arrSurveys = nameValueLib.getValue(_arrNationalAllMapCIData, [
                objCountry.name,
              ]);
              arrSurveys.push(newAllNationalCISurveyObject);
            }
          } //END if(strNationalValue != null) {...
        });
      }
    }); //END $.each(_arrSortedCountriesSurveys, function(countryIndex, objCountry)...

    // Function for handling populating _arrNationalMapData and _arrSubnationalMapData
    const populateMapData = (arrAllMapData, type) => {
      // Loop through all countries
      for (const country of arrAllMapData) {
        const { name, alias, value } = country;
        const selectedSurveys = nameValueLib.getValue(
          _arrSortedCountriesSurveys,
          [name]
        );

        // Get all enabled surveys
        const enabledSurveys = selectedSurveys.filter((survey) => survey.value);
        // Skip countries that have no enabled surveys (e.g. a country with no
        // surveys of the selected type — MIS, range, etc.).
        if (enabledSurveys.length === 0) continue;
        const latestEnabledSurveyYear =
          enabledSurveys[enabledSurveys.length - 1].alias;
        let latestValidSurveyData = value.find(
          (survey) => survey.alias === latestEnabledSurveyYear
        );

        // If there is no data for the latest enabled survey, get the latest survey data that has data
        if (!latestValidSurveyData) {
          latestValidSurveyData =
            value.filter((survey) => survey.alias <= latestEnabledSurveyYear)[
              value.length - 1
            ] || null;
        }

        // If there is data for the latest enabled survey, add it to the map data
        if (latestValidSurveyData) {
          const mapDataObject = nameValueLib.createObject(
            name,
            alias,
            [latestValidSurveyData],
            false
          );

          if (type === 'national') {
            _arrNationalMapData.push(mapDataObject);
            const latestValidSurveyValue = latestValidSurveyData.value;
            _arrNationalMapValues.push(latestValidSurveyValue);
          } else if (type === 'subnational') {
            _arrSubnationalMapData.push(mapDataObject);
          }
        }
      }
    };

    // Now that national and subnational data is populated, get the latest survey year for each country and subregion for map
    populateMapData(_arrNationalAllMapData, 'national');
    populateMapData(_arrSubnationalAllMapData, 'subnational');
  };

  /**
   * @fn 		_createInfoWindowData
   * @brief 	Creates data required for the Info Windows/Map. This data is stored for every country.
   * @param	indicatorName: The currently selected indicator name.
   * @return 	void.
   */
  var _createInfoWindowData = function (indicatorName) {
    //Reset Graph Display Data.
    _resetColumnGraphDisplayData();

    //Go through each Country/Survey to create Categories.
    $.each(_arrSortedCountriesSurveys, function (countryIndex, objCountry) {
      $.each(objCountry.value, function (surveyIndex, objSurvey) {
        //if Survey is not enabled, ignore it.
        if (!objSurvey.value) {
          return;
        }

        //Create Category Name.
        var strCategory = objCountry.name + ' ' + objSurvey.name;

        //Add Category to High Charts.
        _arrHighChartsColumnCategories.push(strCategory);
      });
    });

    //Go through each enabled label and create a series name array.
    $.each(_arrSortedCharLabels, function (charCatIndex, objCharCat) {
      $.each(objCharCat.value, function (charLabelIndex, objCharLabel) {
        //If not enabled or if category is region, ignore it.
        if (!objCharLabel.value || _isRegionCategory(objCharCat.name)) {
          return;
        }

        //Add name to series.
        _arrHighChartsColumnSeriesNames.push(
          objCharCat.name + ':' + objCharLabel.name.toString()
        );
      });
    });

    //Go through each series to create survey values.
    $.each(_arrHighChartsColumnSeriesNames, function (index, strSeries) {
      //Split the string to get the Char Cat and Char Label.
      var arrTemp = strSeries.split(':');
      var strCharCat = arrTemp[0];
      var strCharLabel = arrTemp[1];

      //Add a new series value.
      _arrHighChartsColumnSeriesValues[strSeries] = [];

      //Go through each Country/Survey to obtain the values.
      $.each(_arrSortedCountriesSurveys, function (countryIndex, objCountry) {
        $.each(objCountry.value, function (surveyIndex, objSurvey) {
          //if Survey is not enabled, ignore it.
          if (!objSurvey.value) {
            return;
          }

          //Obtain the value for the particular Indicator.
          var strValue = '';
          //First obtain the ByVariable if any.

          var arrAllByVariable = byVariableState.get(indicatorName, []);
          if (arrAllByVariable.current) {
            var strByVarLabel = arrAllByVariable.current;
            if (Array.isArray(strByVarLabel)) {
              strByVarLabel = strByVarLabel[0];
            }
          } else {
            var strByVarLabel = '';
          }

          if (
            nameValueLib.objectExists(_arrValues, [
              objCountry.name,
              objSurvey.name,
              indicatorName,
              strCharCat,
              strCharLabel,
              strByVarLabel,
            ]) != -1
          ) {
            strValue = nameValueLib.getValue(_arrValues, [
              objCountry.name,
              objSurvey.name,
              indicatorName,
              strCharCat,
              strCharLabel,
              strByVarLabel,
            ]);
            strValue = parseFloat(strValue);

            //Keep a check on min/max value. To be used for Y-Axis display.
            _nHighChartsMinYValue = Math.min(_nHighChartsMinYValue, strValue);
            _nHighChartsMaxYValue = Math.max(_nHighChartsMaxYValue, strValue);
          }
          _arrHighChartsColumnSeriesValues[strSeries].push(strValue);
        });
      });
    });
  };

  /**
   * @fn _setupControlPanel
   * @brief 	Sets up the control panel with the correct data. Used for initial load and updates.
   * @return 	void
   */
  var _setupControlPanel = function () {
    //Declare Important Variables.
    var arrCharLabels = []; //An array of character categories and labels for jstree.
    var arrCountries = []; //An array of countries for jstree plug-in.
    var lstIndicators = $(_lstIndicators); //DOM containing the list of indicators (select box)
    var lstCharLabels = $(_lstCharLabels); //DOM containing the list of Char Cats / Char Labels.
    var lstCountries = $(_lstCountries); //DOM containing the list of countries.
    var level1ID = 1000; //Assign a random number for the moment for parent IDs.
    var level2ID = 3000; //This id is used for child items in the tree.

    var objOpenSelected = {};
    objOpenSelected['opened'] = true;
    objOpenSelected['selected'] = true;
    var objOpenUnSelected = {};
    objOpenUnSelected['opened'] = false;
    objOpenUnSelected['selected'] = false;

    //////////////////////////////////////////////////////////
    //
    // SET THE INDICATOR TEXT.
    //
    //////////////////////////////////////////////////////////
    $('#indicatorName').text(_strSelectedIndicator);
    $('#indicatorName').attr('title', _strSelectedIndicator);

    //////////////////////////////////////////////////////////
    //
    // POPULATE THE INDICATORS DROP DOWN.
    //
    //////////////////////////////////////////////////////////

    //Clear the Indicator list before you update it.
    //$('#lstIndicators').find('option').remove().end();
    lstIndicators.find('option').remove();

    //Create a drop list of Indicators that have been found.
    $.each(_arrSortedIndicators, function (indicatorIndex, objIndicator) {
      if (objIndicator.type === 'I') {
        lstIndicators.append(
          $('<option />')
            .val(objIndicator.name + '|' + objIndicator.alias)
            .text(objIndicator.name)
        );
      }
    });

    //Create a drop list of Indicators that were selected but not found.
    // for(var nIndex = 0; nIndex < arrSelectedIndicatorNames.length; nIndex++) {

    // 	if(nameValueLib.objectExists(_arrSortedIndicators, [arrSelectedIndicatorNames[nIndex]]) == -1) {
    // 		lstIndicators.append($("<option />").val(arrSelectedIndicatorNames[nIndex] + '|' + ' ').text(arrSelectedIndicatorNames[nIndex]));
    // 	}
    // }

    //Select the current Indicator.
    if (_selectedIndicatorDropdown.length > 0) {
      var currInd =
        _selectedIndicatorDropdown[_selectedIndicatorDropdown.length - 1];
      var strSelect = '#lstIndicators option:contains(' + currInd + ')';
      $(strSelect).attr('selected', true);
      $('#indicatorName').text(currInd);
      $('#indicatorName').attr('title', currInd);
      var values = $('#lstIndicators').val().split('|');

      statCompilerDashboard.updateSelectedIndicator(values[0], values[1]);
      //Update the Dashboard.
      statCompilerDashboard.updateDashboard(null, false);
    } else {
      if (_strInfoIndicatorId != '') {
        var strSelect = `#lstIndicators option[value="${_strSelectedIndicator}|${_strInfoIndicatorId}"]`;
        $(strSelect).attr('selected', true);
      }
    }

    try {
      lstIndicators.indicatorselectmenu('refresh');
      statCompilerDashboard.resetSelectedIndicatorDropdown();
    } catch (err) {
      console.error(err);
    }

    //////////////////////////////////////////////////////////
    //
    //! POPULATE THE BY VARIABLE LABEL DROP DOWN.
    //
    //////////////////////////////////////////////////////////
    //Clear the existing drop down.
    $('#byVariableSelect').find('option').remove().end();

    //Create a drop list of by variable labels if there are any.
    //Get the particular list of By Variables.
    var objByVariableLabel = byVariableState.get(_strSelectedIndicatorCode);
    if (objByVariableLabel) {
      $('#byVariableSelect').data('byVariable', objByVariableLabel);

      var arrSelectedLabel = objByVariableLabel.current;
      $.each(
        objByVariableLabel.all,
        function (byVariableIndex, strByVariableLabel) {
          if (strByVariableLabel.length !== 0) {
            $('#byVariableSelect').append(
              $('<option />').val(strByVariableLabel).text(strByVariableLabel)
            );
          }
        }
      );

      //Select the correct Label.
      if ($('select#byVariableSelect option').length) {
        if (arrSelectedLabel.length > 1 && _curDisplayType != 'Grid') {
          objByVariableLabel.current = [arrSelectedLabel[0]];
          $('#byVariableSelect').val(objByVariableLabel.current);
          $('#byVariableSelect').change();

          return; // Important!!!!!! return from function otherwise an infinite loop will ensue as changing the select in turn triggers this fn.
        }

        $('#byVariableSelect').val(arrSelectedLabel);
        var selection_as_text = arrSelectedLabel.join(', ');
        if (arrSelectedLabel.length > 1) {
          selection_as_text =
            '(' + arrSelectedLabel.length + ') ' + selection_as_text;
        }
        $('.current_byvariable_string')
          .text(selection_as_text)
          .attr('title', selection_as_text);
      }

      //Hide/Display the drop down.
      if ($('#byVariableSelect').children('option').length == 0) {
        $('#byVariableContainer').addClass('hidden');
      } else {
        $('#byVariableContainer').removeClass('hidden');
      }
    } else {
      $('#byVariableContainer').addClass('hidden');
    }

    //////////////////////////////////////////////////////////
    //
    // CREATE THE CHAR CAT/CHAR LABEL TREE.
    //
    //////////////////////////////////////////////////////////

    //Populate the CharCats and Char Labels for that indicator.
    let arrIndicatorValues = [];
    const arrAddedCharLabels = new Set();
    let hasAnySelected = false;

    // Builds list off of all available indicators' cat/char, not just for selected indicator
    for (const charLabel of _arrSortedCharLabels) {
      const { value, name } = charLabel;
      if (!arrAddedCharLabels.has(name)) {
        arrAddedCharLabels.add(name);
        arrIndicatorValues.push(charLabel);
        // Check if value is an array, indicating it has subcategories
        if (Array.isArray(value)) {
          for (const subChar of value) {
            if (subChar.value) {
              hasAnySelected = true;
              if (subChar.name === 'Total') {
                _bTotalDataSelected = true;
              }
              break;
            }
          }
        } else {
          if (value) {
            hasAnySelected = true;
            if (name === 'Total') {
              _bTotalDataSelected = true;
            }
          }
        }
      }
    }

    arrIndicatorValues.sort(function (a, b) {
      var a_order = _.get(
        _.find(_arrRawData, ['CharacteristicId', _.get(a, 'value.0.alias')]),
        'CharacteristicOrder'
      );
      var b_order = _.get(
        _.find(_arrRawData, ['CharacteristicId', _.get(b, 'value.0.alias')]),
        'CharacteristicOrder'
      );
      return a_order - b_order;
    });

    if (arrIndicatorValues === null) {
      arrIndicatorValues = [];
    }

    // Make sure at least one char is selected on load
    if (!hasAnySelected) {
      if (_arrSortedCharLabels.length > 0) {
        if (_arrSortedCharLabels[0].value) {
          _arrSortedCharLabels[0].value[0].value = true;
          // Seems necessary, otherwise char will be selected but the data will not be loaded
          statCompilerDashboard.updateDashboard(null, false);
        }
      }
    }

    // Populate object of unique level names by level rank, to be used in Region inidicator labeling
    objUniqueLevelNaByLevelRnk = {
      1: new Set(),
      2: new Set(),
      3: new Set(),
    };
    // Reset SubnationalLabels for map updates
    objMapLevelLabels = { 1: new Set(), 2: new Set(), 3: new Set() };

    // Build object of all unique level names by level rank, for surveys that are enabled
    const arrMostRecentSelectedSurveyAdded = new Set(); // used for getting latest survey for Map dashboard labels
    //Iterate through each country and survey currently loaded
    for (const country of _arrSortedCountriesSurveys) {
      //Iterate backwards through survey loaded for the country, to get most recent survey first
      for (let i = country.value.length - 1; i >= 0; i--) {
        const survey = country.value[i]; // specific survey e.g. DHS 1996
        if (survey.value === true) {
          // is enabled for this view
          // Some surveys exist for countries that do not have matching region ids
          if (
            objUniqueLvlNames[survey.name] &&
            objUniqueLvlNames[survey.name][country.alias]
          ) {
            // Iterate through level ranks
            for (let i = 1; i <= 3; i++) {
              const levelRank = i;
              const levelName =
                objUniqueLvlNames[survey.name][country.alias][levelRank];

              if (levelName) {
                objUniqueLevelNaByLevelRnk[levelRank].add(levelName);

                // Map only looks at the most recent survey to get level names
                // We are iterating from most recent to oldest, if we already found a matching survey, skip
                if (!arrMostRecentSelectedSurveyAdded.has(country.alias)) {
                  const levelRank = i;
                  objMapLevelLabels = addLvlNaToMapLevelLabels(
                    objMapLevelLabels,
                    levelRank,
                    levelName
                  );
                }
              }
            }
            // Survey for the country was enabled, so add it to tracked list so we don't get an older one later
            arrMostRecentSelectedSurveyAdded.add(country.alias);
          }
        }
      }
    }

    // Check if there are any conflicts existing, so we know whether or not to use specific or generic subregion label
    // A conflicts can be:
    //    Within a level rank, within one country, but between surveys of that country
    //    Within a level rank between different countries
    //    Between level ranks, generally between different countries or surveys
    const checkLvlNaForConflicts = (uniqueLevelNaByLevelRnk) => {
      const lvlRnkConflicts = {
        1: { hasConflict: false },
        2: { hasConflict: false },
        3: { hasConflict: false },
      };

      const _compareLvlRanksForConflict = (
        lvlNameValue,
        firstLvlRnk,
        secondLvlRnk
      ) => {
        if (
          !lvlRnkConflicts[firstLvlRnk].hasConflict &&
          uniqueLevelNaByLevelRnk[firstLvlRnk].has(lvlNameValue)
        ) {
          lvlRnkConflicts[firstLvlRnk].hasConflict = true;
          lvlRnkConflicts[secondLvlRnk].hasConflict = true;
        }
      };

      // Check if any level ranks have inner conflicts.
      // More than one level name per level rank means conflict exists
      for (levelRank in lvlRnkConflicts) {
        lvlRnkConflicts[levelRank].hasConflict =
          uniqueLevelNaByLevelRnk[levelRank].size > 1;
      }

      // Check if there is a conflict between the level names of level ranks
      for (let rnkOneLevelNaValue of uniqueLevelNaByLevelRnk[1]) {
        // If no conflict has been found, check for conflict between rank 1 name and rank 2 names
        _compareLvlRanksForConflict(rnkOneLevelNaValue, 2, 1);
        // If no conflict has been found, check for conflict between rank 1 name and rank 3 names
        _compareLvlRanksForConflict(rnkOneLevelNaValue, 3, 1);
      }

      // Check if there is a conflict between the level names of level rank 2 and 3
      if (!lvlRnkConflicts[2].hasConflict && !lvlRnkConflicts[3].hasConflict) {
        for (let rnkTwoLevelNaValue of uniqueLevelNaByLevelRnk[2]) {
          // If no conflict has been found, check for conflict between rank 2 name and rank 3 names
          _compareLvlRanksForConflict(rnkTwoLevelNaValue, 3, 2);
        }
      }
      return lvlRnkConflicts;
    };
    // Check for conflicts between all countries, level ranks, and surveys
    objLevelRnkWithDuplicateLevelNa = checkLvlNaForConflicts(
      objUniqueLevelNaByLevelRnk
    );
    // Check for conflicts between all countries and level ranks only for most recent survey
    objMapLevelLabelConflicts = checkLvlNaForConflicts(objMapLevelLabels);

    $.each(arrIndicatorValues, function (charCatIndex, objCharCat) {
      //Obtain and add the Char Cats.
      var objLevel1 = {};
      objLevel1['id'] = level1ID.toString(); //Set ID.
      objLevel1['parent'] = '#'; //Set Parent.
      objLevel1['text'] = objCharCat.name; //Set Text.
      objLevel1['icon'] = false; //Set Icon.
      if (_isRegionCategory(objCharCat.name) && _bRegionalDataSelected) {
        objLevel1['state'] = objOpenSelected;
      } else if (
        _isTotalCategory(objCharCat.name) &&
        _bTotalDataSelected &&
        nameValueLib.getValue(_arrSortedCharLabels, [
          objCharCat.name,
          objCharCat.value[0].name,
        ])
      ) {
        objLevel1['state'] = objOpenSelected;
      } else {
        objLevel1['state'] = objOpenUnSelected;
      }
      arrCharLabels.push(objLevel1);

      //Obtain and add the Char Labels for this particular Char Cat.
      if (
        !_isRegionCategory(objCharCat.name) &&
        !_isTotalCategory(objCharCat.name)
      ) {
        $.each(objCharCat.value, function (charLabelIndex, objCharLabel) {
          //Add Char Label to the list.
          var objLevel2 = {};
          objLevel2['id'] = level2ID.toString(); //Set ID.
          objLevel2['parent'] = level1ID.toString(); //Set Parent.
          objLevel2['text'] = objCharLabel.name.toString(); //Set Text.
          objLevel2['icon'] = false; //Set Icon.
          if (
            nameValueLib.getValue(_arrSortedCharLabels, [
              objCharCat.name,
              objCharLabel.name.toString(),
            ])
          ) {
            objLevel2['state'] = objOpenSelected;
          } else {
            objLevel2['state'] = objOpenUnSelected;
          }
          arrCharLabels.push(objLevel2);

          level2ID++;
        });
      } else if (_isRegionCategory(objCharCat.name)) {
        // We want the subregions to be in order of level rank, with Other at the end
        const arrCharLabelsOrder = [null, null, null, null];

        $.each(objCharCat.value, function (charLabelIndex, objCharLabel) {
          const subRegionLabel = extractSubRegionFromLabelName(
            objCharLabel.name
          );
          const levelRnk = extractLevelRnkFromLabelStr(objCharLabel.name);
          const hasConflictingLevelNa = levelRnk
            ? objLevelRnkWithDuplicateLevelNa[levelRnk].hasConflict
            : null;

          // If data is not currently displayed, don't create label for it
          if (
            levelRnk &&
            !objUniqueLevelNaByLevelRnk[levelRnk].has(subRegionLabel)
          ) {
            return;
          }

          let isOtherLabel = false;
          let objLevel2Text = '';

          //If there is a level rank and subregion names apply specific label, or generic if there are conflicts
          if (levelRnk) {
            objLevel2Text = hasConflictingLevelNa
              ? _strSubnationalConst + ' ' + levelRnk
              : subRegionLabel;
          } else {
            // If no level rank exists it is put in Other category
            objLevel2Text = _strOtherConst;
            isOtherLabel = true;
          }

          //If this subregion option has already been added, continue to next
          for (charLabel of arrCharLabelsOrder) {
            if (
              charLabel !== null &&
              extractSubRegionFromLabelName(charLabel.text) === objLevel2Text
            ) {
              return;
            }
          }

          //Add Char Label to the list.
          var objLevel2 = {};
          objLevel2['id'] = level2ID.toString(); //Set ID.
          objLevel2['parent'] = level1ID.toString(); //Set Parent.
          objLevel2['text'] = objLevel2Text.toString(); //Set Text.
          objLevel2['icon'] = false; //Set Icon.
          if (
            nameValueLib.getValue(_arrSortedCharLabels, [
              objCharCat.name,
              objCharLabel.name.toString(),
            ])
          ) {
            objLevel2['state'] = objOpenSelected;
          } else {
            objLevel2['state'] = objOpenUnSelected;
          }
          // Add label at index based on level rank or last for other
          if (!isOtherLabel) {
            arrCharLabelsOrder[levelRnk - 1] = objLevel2;
          } else {
            arrCharLabelsOrder[arrCharLabelsOrder.length - 1] = objLevel2;
          }
          level2ID++;
        });
        //Apply labels in acending order of level rank, with other last
        for (const charLabel of arrCharLabelsOrder) {
          if (charLabel !== null) {
            arrCharLabels.push(charLabel);
          }
        }
      }
      level1ID++;
    });

    //Create the tree.
    //Remove old tree if previously initialized.
    if (_bDashboardInitialized) {
      lstCharLabels.jstree('destroy');
    }
    /*
		arrCharLabels.sort(function(a,b){
    		var testA = a.text.toLowerCase();
    		var testB = b.text.toLowerCase();
    		if(testA == 'total') return -100;
    		if(testA.indexOf('total') !== -1) return -50;
    		return 0;
		});
*/
    lstCharLabels
      .jstree({
        core: {
          data: arrCharLabels,
        },
        checkbox: {
          whole_node: true,
        },
        plugins: ['html_data', 'types', 'themes', 'checkbox'],
      })
      .on('ready.jstree', function () {
        new State(this);
      });

    //Setup onclick event for CharCat/CharLabel List.
    lstCharLabels.on('changed.jstree', function (e, data) {
      var strCharCat = '';
      var strCharLabel = '';
      var nID;
      var nParenID;
      var isEnabled = false;
      var bPrevRegionalDataSelected = _bRegionalDataSelected;
      //Make sure there is a node selected.
      if (typeof data.node == 'undefined') {
        return;
      }

      //If the selected node is a parent/CharCat.
      if (data.node.children.length > 0) {
        // Region category is tracked separately of other charCats
        if (_isRegionCategory(data.node.text)) {
          //If the selected node is the Region Node.
          //Update Status of all the items underneath.
          var bStatus = data.node.state.selected;

          //Update status in sorted array.
          var arrCharLabels = nameValueLib.getValue(_arrSortedCharLabels, [
            data.node.text,
          ]);
          $.each(arrCharLabels, function (charLabelIndex, objCharLabel) {
            objCharLabel.value = bStatus;
          });

          //Set whether regional data has been selected/unselected.
          _bRegionalDataSelected = bStatus;
        } else {
          //Obtain the text of the Char Cat.
          strCharCat = data.node.text;

          //Update Status of all the items underneath.
          var bStatus = data.node.state.selected;
          $.each(data.node.children, function (index, childID) {
            //Obtain the text of the child item.
            strCharLabel = $(data.instance.get_node(childID)).attr('text');

            //Update status in sorted array.
            var objCharLabel = nameValueLib.getObject(_arrSortedCharLabels, [
              strCharCat,
              strCharLabel,
            ]);
            if (objCharLabel) {
              objCharLabel.value = bStatus;
            }
          });
        }
      } else if (_isTotalCategory(data.node.text)) {
        //If the selected node is the Total Node.
        //Update Status of all the items underneath.
        var bStatus = data.node.state.selected;

        //Update status in sorted array.
        var arrCharLabels = nameValueLib.getValue(_arrSortedCharLabels, [
          data.node.text,
        ]);
        $.each(arrCharLabels, function (charLabelIndex, objCharLabel) {
          objCharLabel.value = bStatus;
        });

        //Set whether total data has been selected/unselected.
        _bTotalDataSelected = bStatus;
      } else {
        //Selected node is a child/CharLabel.
        //Obtain the text of the parent/Char Cat
        strCharCat = $(data.instance.get_node(data.node.parent)).attr('text');

        //Obtain the Char Label.
        strCharLabel = data.node.text;

        //Obtain Status.
        var bStatus = data.node.state.selected;

        //Handle Region children separetely by checking if name contains the subregion type
        //and updating all matches
        if (_isRegionCategory(strCharCat)) {
          const subRegionCharLabels = _arrSortedCharLabels.find((charLabel) =>
            _isRegionCategory(charLabel.name)
          ).value;
          let subRegionLabel = strCharLabel; //visble name in the Region list of event triggered e.g. Subnational 1
          let isOtherToggled = subRegionLabel === _strOtherConst;
          let isGenericLevelRnk = subRegionLabel.includes(_strSubnationalConst);

          //Check if the label is a generic one for undefined level rank and level name types
          if (isGenericLevelRnk) {
            const levelRnk = subRegionLabel.slice(-1);
            subRegionLabel = `(L${levelRnk})`;
          }

          //A name with any of these substrings indicates it has a level rank, so doesn't apply to Other
          const levelRnkSubStrings = ['(L1)', '(L2)', '(L3)'];

          //Check if any of the subRegion data needs to be toggled based on selection
          for (const subRegionCharLabel of subRegionCharLabels) {
            if (isOtherToggled) {
              //If the name DOES NOT includes any of the substrings, it is part of the Other group
              if (
                !levelRnkSubStrings.some((subStr) =>
                  subRegionCharLabel.name.includes(subStr)
                )
              ) {
                subRegionCharLabel.value = bStatus;
              }
            } else if (
              isGenericLevelRnk &&
              subRegionCharLabel.name.includes(subRegionLabel)
            ) {
              subRegionCharLabel.value = bStatus;
            } else if (
              extractSubRegionFromLabelName(subRegionCharLabel.name) ===
              subRegionLabel
            ) {
              //Check if name includes specific label
              subRegionCharLabel.value = bStatus;
            }
          }
        } else {
          //Update status in sorted array.
          var objCharLabel = nameValueLib.getObject(_arrSortedCharLabels, [
            strCharCat,
            strCharLabel,
          ]);
          if (objCharLabel) {
            objCharLabel.value = bStatus;
          }
        }
      }

      //Update pivot depending on Regional Count.
      if (
        bPrevRegionalDataSelected == false &&
        _bRegionalDataSelected == true
      ) {
        //Update if regional data is selected for the first time.
        //If the current pivot type is either surveys or Indicators, update the pivot type to be Surveys/Char.
        if (
          _curPivotType == statCompilerDashboard.PIVOT_TYPE.Survey ||
          _curPivotType == statCompilerDashboard.PIVOT_TYPE.Indicator
        ) {
          //Update Pivot to SurveyChar.
          statCompilerDashboard.updatePivot(
            statCompilerDashboard.PIVOT_TYPE.SurveyChar
          );

          //Select the correct drop down.
          $(_pivotDropDownElement).find('[data-value="SurveyChar"]').click();
        }
        $('#selectPivot .menu')
          .find('[data-value="Survey"], [data-value="Indicator"]')
          .addClass('ui-state-disabled');

        $(_pivotDropDownElement)
          .find('[value="Survey"], [value="Indicator"]')
          .attr('disabled', 'disabled');
      } else if (
        bPrevRegionalDataSelected == true &&
        _bRegionalDataSelected == false
      ) {
        //Update if regional data is unselected.
        //Enable the first two Pivot Options.
        $('#selectPivot .menu')
          .find('[data-value="Survey"], [data-value="Indicator"]')
          .removeClass('ui-state-disabled');

        $(_pivotDropDownElement)
          .find('[value="Survey"], [value="Indicator"]')
          .removeAttr('disabled');
      }

      //Update Labels if the dashboard is already initialized.
      //This will avoid double updates during initialization.
      if (_bDashboardInitialized) {
        statCompilerDashboard.updateDashboard(null, false);
      }
    }); // close lstCharLabels.on('changed.jstree'
    //////////////////////////////////////////////////////////
    //
    // CREATE THE COUNTRIES TREE.
    //
    //////////////////////////////////////////////////////////

    //Reset level1ID.
    level1ID = 1000;

    //Put all countries in a list of countries recognizable by jstree.
    //Start with countries actually present in the data.
    $.each(_arrSortedCountriesSurveys, function (countryIndex, objCountry) {
      var objLevel1 = {};
      objLevel1['id'] = level1ID.toString(); //Set ID.
      objLevel1['parent'] = '#'; //Set Parent.
      objLevel1['text'] = objCountry.name; //Set Text.
      objLevel1['icon'] = false; //Set Icon.
      //Check if all surveys are unchecked then uncheck country.
      var bChecked = false;
      $.each(objCountry.value, function (surveyIndex, objSurvey) {
        if (objSurvey.value) {
          bChecked = true;
        }
      });
      objLevel1['state'] = bChecked ? objOpenSelected : objOpenUnSelected;
      arrCountries.push(objLevel1);
      level1ID++;
    });

    //Add remaining selected countries, if any that have no data.
    for (var nIndex = 0; nIndex < arrSelectedCountryNames.length; nIndex++) {
      if (
        nameValueLib.objectExists(_arrSortedCountriesSurveys, [
          arrSelectedCountryNames[nIndex],
        ]) == -1
      ) {
        var objLevel1 = {};
        objLevel1['id'] = level1ID.toString(); //Set ID.
        objLevel1['parent'] = '#'; //Set Parent.
        objLevel1['text'] = arrSelectedCountryNames[nIndex]; //Set Text.
        objLevel1['icon'] = false; //Set Icon.
        objLevel1['state'] = { disabled: true };
        arrCountries.push(objLevel1);
        level1ID++;
      }
    }

    //Create the tree.
    //Remove old tree if previously initialized.
    if (_bDashboardInitialized) {
      lstCountries.jstree('destroy');
    }

    sortAPIData(arrCountries, ['text'], true);
    lstCountries
      .jstree({
        core: {
          data: arrCountries,
        },
        checkbox: {
          whole_node: true,
        },
        plugins: ['html_data', 'types', 'themes', 'checkbox'],
      })
      .bind('ready.jstree', function () {
        new State(this);
      });

    //Setup onclick event for Countries List.
    lstCountries.on('changed.jstree', function (e, data) {
      var strCountry = '';
      var arrSurveys;
      var isEnabled = false;

      //Make sure there is a node selected.
      if (typeof data.node == 'undefined') {
        return;
      }

      //Obtain the text for the node.
      strCountry = data.node.text;

      //Obtain the status of the item.
      var bStatus = data.node.state.selected;

      //Obtain the particular country.
      arrSurveys = nameValueLib.getValue(_arrSortedCountriesSurveys, [
        strCountry,
      ]);
      $.each(arrSurveys, function (index, objSurvey) {
        objSurvey.value = bStatus;
      });
      //Depending on status, insert or delete country from array.
      if (bStatus) {
        var nIndex = _arrUnSelectedCountries.indexOf(strCountry);
        if (nIndex != -1) {
          _arrUnSelectedCountries.splice(nIndex, 1);
        }
      } else {
        _arrUnSelectedCountries.push(strCountry);
      }

      switch (_curSurveySelection) {
        case statCompilerDashboard.SURVEY_SELECTION.Recent:
          statCompilerDashboard.displayRecentSurveys(false, 1);
          break;
        case statCompilerDashboard.SURVEY_SELECTION.Custom:
          if (statCompilerDashboard.getCurrentDisplayType() == 'Line') {
            statCompilerDashboard.displayCustomSurveySelector(
              statCompilerDashboard.getUnSelectedCountries(),
              false
            );
          } else {
            statCompilerDashboard.displayCustomSurveySelector(
              statCompilerDashboard.getUnSelectedCountries(),
              false
            );
          }
          break;
        default:
          statCompilerDashboard.displayAllSurveys();
          break;
      }
    });
  };

  var _updateXAxisLables = function (chart) {
    //Declare Important Variables.
    var barWidth;
    var fontSize;
    if (chart.series.length && chart.series[0].barW) {
      barWidth = chart.series[0].barW;
      barWidth = barWidth * chart.colorCounter;
      fontSize =
        barWidth > 50
          ? barWidth / (2 * chart.colorCounter)
          : barWidth / chart.colorCounter;

      //var fontSize = (barWidth > 50) ? barWidth/ 10 : barWidth;
      var axisFontSize = barWidth < 50 ? barWidth / 10 : barWidth / 3;

      if (fontSize > 16) {
        fontSize = 16;
      }

      if (axisFontSize > 12.000001) {
        axisFontSize = 12;
      }

      if (chart.series) {
        var ci = chart.series.filter(function (serie) {
          if (name === 'Total:Total_CI') {
            return serie;
          }
        });
        if (ci[0]) {
        }
      }
      //$('#charts').highcharts().data[0].dataLabel.styles = {fontSize: fontSize + "px", cursor: "default"};
      $('#charts .highcharts-data-labels text').css(
        'font-size',
        fontSize + 'px'
      );
      $('#charts .highcharts-data-labels text tspan').css(
        'font-size',
        fontSize + 'px'
      );
      $('#charts .highcharts-xaxis-labels text').css(
        'font-size',
        axisFontSize + 'px'
      );
      setTimeout(function () {
        $('#charts .highcharts-data-labels text').attr('y', fontSize / 2);
        $(
          '#charts .highcharts-xaxis-labels text, #charts .highcharts-data-labels tspan'
        ).css('font-size', axisFontSize + 'px');
      }, 0);
    }
  };

  /**
   * @fn displayGrid
   * @brief 	Display Grid.
   * @return 	void
   */
  var _displayGrid = function () {
    gridIntroInit = true;
    if ($('.introTour').hasClass('hidden')) {
      $('.introTour').removeClass('hidden');
    }
    //Reset the current display before adding a new grid.
    _resetDisplay();
    var header = $('#resultsDiv .ui-jqgrid-hdiv');
    var height = $('#resultsDiv').height() - header.height();
    var width = $('#resultsDiv').width();
    //Reset buttons.
    _resetButtons();

    //Determine Sort options.
    var strSortOptions = '';
    switch (_curPivotType) {
      case statCompilerDashboard.PIVOT_TYPE.Survey:
        //strSortOptions = "Country asc, Survey";
        strSortOptions = '';
        break;
      case statCompilerDashboard.PIVOT_TYPE.Indicator:
        strSortOptions = '';
        //strSortOptions = "Indicator asc, CharLabelID asc";
        break;
      case statCompilerDashboard.PIVOT_TYPE.SurveyChar:
        //strSortOptions = "Country asc, Survey, CharLabelID asc";
        //strSortOptions = "CharLabelID asc";
        strSortOptions = '';
        break;
      case statCompilerDashboard.PIVOT_TYPE.CharSurvey:
        //strSortOptions = "CharLabelID asc, Country asc, Survey";
        //strSortOptions = "CharLabelID asc";
        strSortOptions = '';
        break;
      default:
        //strSortOptions = "Country asc, Survey";
        strSortOptions = '';
        break;
    }
    //Initialize JQGRID with the pivoted data.
    $(_gridElement).jqGrid({
      altRows: true,
      rowNum: '10000',
      datatype: 'local',
      heightStyle: 'fill',
      data: _arrGridData,
      colNames: _arrColNames,
      colModel: _arrColModel,
      height: height, //I like auto, so there is no blank space between.
      width: width,
      shrinkToFit: false,
      loadonce: true,
      viewrecords: true,
      caption: '',
      multiSort: true,
      sortname: strSortOptions,
      sortorder: 'desc',
      loadComplete: function (data) {},
    });

    $(window).resize(function () {
      var header = $('#resultsDiv .ui-jqgrid-hdiv');

      var resultsDiv = $('#resultsDiv');

      var height = $('#resultsDiv').height() - header.height();
      var width = resultsDiv.width();

      if ($(_highChartsElement).highcharts()) {
        $(_highChartsElement)
          .highcharts()
          .setSize(resultsDiv.width(), resultsDiv.height());
      }
      $(_gridElement).jqGrid('setGridWidth', width);
      $(_gridElement).jqGrid('setGridHeight', height);
    });

    //Add Group Headers: Level 1
    if (_arrGroupHeadersLevel1.length > 0) {
      $(_gridElement).jqGrid('setGroupHeaders', {
        useColSpanStyle: false,
        groupHeaders: _arrGroupHeadersLevel1,
      });
    }

    //Add Group Headers: Level 2
    if (_arrGroupHeadersLevel2.length > 0) {
      $(_gridElement).jqGrid('setGroupHeaders', {
        useColSpanStyle: false,
        groupHeaders: _arrGroupHeadersLevel2,
      });
    }

    //Add Group Headers: Level 3
    if (_arrGroupHeadersLevel3.length > 0) {
      $(_gridElement).jqGrid('setGroupHeaders', {
        useColSpanStyle: false,
        groupHeaders: _arrGroupHeadersLevel3,
      });
    }

    //Set Display Type.
    _curDisplayType = statCompilerDashboard.DISPLAY_TYPE.Grid;

    //Set an active class on the control button
    $('.topToolbar .iconTable').addClass('active');

    var header = $('#resultsDiv .ui-jqgrid-hdiv');

    var resultsDiv = $('#resultsDiv');

    var height = $('#resultsDiv').height() - header.height();

    $(_gridElement).jqGrid('setGridWidth', width);
    $(_gridElement).jqGrid('setGridHeight', height);

    // if(localStorage.getItem('startedTour_grid') === 'true') {
    // 	statCompilerDashboard.startTourGrid();
    // 	localStorage.setItem('startedTour_grid', false);
    // }
  };

  /**
   * @fn _displayColumnChart
   * @brief 	Displays a column chart for the data.
   * @return 	void
   */
  var _displayColumnChart = function () {
    if ($('.introTour').hasClass('hidden')) {
      $('.introTour').removeClass('hidden');
    }
    //Declare Important Variables.
    var arrSeries = [];
    var bCustomSeriesName = false;
    var yAxisMax = _nHighChartsMaxYValue;

    //Clear Display.
    _resetDisplay();

    //Reset buttons.
    _resetButtons();

    //Determine Height of chart based on height of resultsDiv.
    var curHeight = $('#resultsDiv').height();

    //Obtain precision for current indicator.
    var strPrecision = nameValueLib.getValueEX(_arrPrecision, [
      _strSelectedIndicatorCode,
    ]);

    //Determine if the current indicator is a percentage type.
    var strMeasurementType = nameValueLib.getValueEX(
      arrIndicatorMeasurementType,
      [_strSelectedIndicatorCode]
    );
    //If the Indicator is percent based, set the YMax to the YMax boolean and update the Max Y value to 100.
    if (strMeasurementType == 'Percent') {
      if (_bHighChartsYAxisToMaxEnabled) {
        yAxisMax = 100;
      }
    }

    //Calculate Tick Interval for Y Axis based on 6 splits.
    var yInterval = (yAxisMax - _nHighChartsMinYValue) / 6;
    yInterval = parseFloat(yInterval.toFixed(strPrecision));
    if (yInterval == 0) {
      yInterval = 0.1;
    } else if (yInterval > 1) {
      yInterval = null;
    }

    //Before doing anything, check if the only series is Total.
    if (_isTotalSeries(_arrHighChartsColumnSeriesNames)) {
      //if the only series checked is Total, remove series name and legend.
      bCustomSeriesName = true;
    }

    //Setup Chart Options.
    var options = {
      chart: {
        zoomType: 'x',
        height: curHeight,
        animation: {
          duration: 1,
        },
        events: {
          click: function (event) {},
          redraw: function () {
            var chart = $(_highChartsElement).highcharts();
            _updateXAxisLables(chart);
            var minLabelEdge = 1;
            var minFont = 1;
            var fontDelta = 2;

            //setTimeout(function(){$('#charts .highcharts-data-labels text').attr("y", (fontSize/2))},0);
            var curLabelEdge = chart.xAxis[0].labelEdge.length;
            if (curLabelEdge > minLabelEdge) {
              //Obtain the Font size currently being used for labels.
              // var strFont = chart.xAxis[0].options.labels.style.fontSize;
              // var nFont = strFont.substring(0, strFont.indexOf("px"));
            } else {
              hideLoader();
            }
            _redrawY();
          },
          load: function () {
            var chart = $(_highChartsElement).highcharts();
            //Declare Important Variables.
            var minLabelEdge = 1;
            var minFont = 1;
            var fontDelta = 2;
            var barWidth = 20;
            var chartContainer = $('#charts');
            var curLabelEdge = chart.xAxis[0].labelEdge.length;

            if (curLabelEdge > minLabelEdge) {
              //Show Loading.
              showLoader();

              //Obtain the Font size currently being used for labels.
              var strFont = chart.xAxis[0].options.labels.style.fontSize;
              var nFont = strFont.substring(0, strFont.indexOf('px'));
              //If the font is already at 1, just hide the loader and break.
              if (nFont == minFont) {
                hideLoader();
                return;
              }

              //Make the font smaller and redraw.
              nFont -= fontDelta;
              if (nFont < minFont) {
                nFont = minFont;
              }
              var objNewFont = {
                labels: { style: { fontSize: nFont + 'px' } },
              };

              //setTimeout(function(){chart.xAxis[0].update(objNewFont, true);}, 100);
            } else {
              //Check out Chart Series
              var bWidthChanged = false;
              for (
                var nCurSeries = 0;
                nCurSeries < chart.series.length;
                nCurSeries++
              ) {
                var series = chart.series[nCurSeries];
                if (series.barW > _maxBarWidth) {
                  series.options.pointWidth = _maxBarWidth;
                  bWidthChanged = true;
                }
              }

              //If Width changed, redraw chart.
              if (bWidthChanged) {
                //Force chart to redraw by resetting the font size.
                var strFont = chart.xAxis[0].options.labels.style.fontSize;
                var nFont = strFont.substring(0, strFont.indexOf('px'));
                var updateChart = chart.series.length - 1 === nCurSeries;
                var objNewFont = {
                  labels: { style: { fontSize: nFont + 'px' } },
                };
                $(window).trigger('resize');
              }
            }
            chart.setSize(
              chartContainer.width(),
              chartContainer.height(),
              false
            );
            _redrawY();
          },
        },
        style: {
          fontFamily: 'GillSansLight',
        },
      },
      exporting: {
        enabled: false,
        chartOptions: {
          title: {
            text: _strSelectedIndicator,
          },
          credits: {
            enabled: true,
            text:
              'ICF, 2015. The DHS Program STATcompiler. Funded by USAID. http://www.statcompiler.com. ' +
              _arrMonthNames[_date.getMonth()] +
              ' ' +
              _date.getDate() +
              ' ' +
              _date.getFullYear(),
            href: '',
          },
        },
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: _arrHighChartsColumnCategories,
        tickWidth: 0,
        labels: {
          staggerLines: 1,
          autoRotation: [false],
          useHTML: false,
          style: {
            textOverflow: 'hidden',
          },
          step: 1,
        },
      },
      yAxis: {
        title: {
          text: '',
        },
        labels: {
          enabled: _bHighChartsYAxisLabelEnabled,
          format: '{value:.' + strPrecision + 'f}',
          step: 1,
        },
        gridLineWidth: _bHighChartsGridEnabled ? 1 : 0,
        min: _nHighChartsMinYValue,
        max: yAxisMax,
        tickInterval: yInterval,
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: _bHighChartsDataPointsEnabled,
            format: '{point.y:.' + strPrecision + 'f}',
            allowOverlap: true,
          },
          minPointLength: 3,
        },
      },
      tooltip: {
        shared: false,
        useHTML: true,
        formatter: function () {
          //Declare Important Variables.
          var strHeader = '';
          var strCharLabel = '';
          var nPointIndex = -1; //Used to find the corresponding value when you have Confidence Intervals.
          var nMainValue = 0;
          var nCILow = 0;
          var nCIHigh = 0;
          var strToolTip = '';
          var strPrecision = nameValueLib.getValueEX(_arrPrecision, [
            _strSelectedIndicatorCode,
          ]);
          var chart = $(_highChartsElement).highcharts();
          //Check if Confidence Intervals are being used.
          if (_bHighChartsHasConfidenceIntervals) {
            //Check if the area chosen is a Normal point or not
            if (this.point.series.linkedSeries.length > 0) {
              //Get the actual point value.
              nMainValue = this.point.y.toFixed(strPrecision);

              //Obtain the index in the series for this point, to get the other point.
              nPointIndex = this.point.index;

              //Obtain the other corresponding series.
              var strSeriesName =
                this.point.series.points.length > 100
                  ? this.point.series.options.id + '_CI'
                  : this.point.series.options.id + '_CI';
              var objSeries = this.series.chart.get(strSeriesName);

              //Obtain the Confidence Interval Values.
              if (objSeries) {
                nCILow = objSeries.data[nPointIndex]
                  ? objSeries.data[nPointIndex].low.toFixed(strPrecision)
                  : '';
                nCIHigh = objSeries.data[nPointIndex]
                  ? objSeries.data[nPointIndex].high.toFixed(strPrecision)
                  : '';
              }

              //Set the Char Label: if only one in series and total
              if (
                _arrHighChartsColumnSeriesNames.length > 1 ||
                !_isTotalCategory(this.point.series.options.id)
              ) {
                strCharLabel =
                  this.point.series.options.id.split(':')[1] + ': ';
              }

              var chartContainer = $('#charts');

              if (chartContainer.width() !== chart.chartWidth) {
                chart.setSize(chartContainer.width(), chartContainer.height());
              }
            } else {
              //This is a Confidence Interval, select the Low and High.
              nCILow = this.point.low.toFixed(strPrecision);
              nCIHigh = this.point.high.toFixed(strPrecision);

              //Obtain the index in the series for this point, to get the other point.
              nPointIndex = this.point.index;

              //Obtain the other corresponding series.
              var strSeriesName =
                this.point.series.options.id.indexOf('_CI') < 0
                  ? this.point.series.options.id
                  : this.point.series.options.id.split('_CI')[0];
              //-var strSeriesName = this.point.series.options.id.split("_CI")[0];
              var objSeries = this.series.chart.get(strSeriesName);

              //Obtain the value from that series.
              nMainValue = objSeries.data[nPointIndex]
                ? objSeries.data[nPointIndex].y.toFixed(strPrecision)
                : 'no value';

              //Set the Char Label:
              if (
                _arrHighChartsColumnSeriesNames.length > 1 ||
                !_isTotalCategory(this.point.series.options.id)
              ) {
                strCharLabel = strSeriesName.split(':')[1] + ': ';
              }
            }
          } //END if(_bHighChartsHasConfidenceIntervals) {...
          else {
            //Get the actual point value.
            nMainValue = this.point.y.toFixed(strPrecision);

            //Set the Chart Label.
            strCharLabel = this.series.name + ': ';
          }
          //Sanitize the decimal on the Main Value.
          var strMainValue = Config.sanitizeNumberString(String(nMainValue));

          //Obtain Header Label
          strHeader = this.x;

          //Setup the table for the tooltip.
          strToolTip = '<table>';

          //ROW 1: Add the header to the first row.
          strToolTip +=
            '<tr class="gillSansRegular"><small><td colspan="2"><strong>' +
            strHeader +
            '</strong></td>';
          strToolTip += '</small></tr>';

          //ROW 2: Add the Values to the second row.
          strToolTip +=
            '<tr><td class="gillSansRegular"><strong>' +
            strCharLabel +
            '</strong></td>';
          if (_bHighChartsHasConfidenceIntervals) {
            strToolTip +=
              '<td align="left">' +
              strMainValue +
              ' (CI ' +
              nCILow +
              ' - ' +
              nCIHigh +
              ')</td>';
          } else {
            strToolTip += '<td align="center">' + strMainValue + '</td>';
          }
          strToolTip += '</tr></table>';

          return strToolTip;
        },
      },
      legend: {
        enabled: bCustomSeriesName ? false : true,
      },
      credits: {
        enabled: false,
      },
    };
    //Add Series Data to chart options.
    var checkbox_data = $('#lstCharLabels').jstree('get_json');
    if (!_.isArray(checkbox_data)) checkbox_data = false;
    $.each(_arrHighChartsColumnSeriesNames, function (key, value) {
      if (!_.filter(_arrHighChartsColumnSeriesValues[value]).length) {
        (function (char_label_name) {
          $('#lstCharLabels')
            .tree_value(char_label_name)
            .then(function ($elem) {
              $elem.find('a').addClass('XXXtext-red has_no_data');
              $elem.attr('disabled', 'disabled');
            });
        })(value);
        return;
      } else {
        (function (char_label_name) {
          $('#lstCharLabels')
            .tree_value(char_label_name)
            .then(function ($elem) {
              $elem.removeAttr('disabled');
              $elem.find('a').removeClass('XXXtext-red has_no_data');
            });
        })(value);
      }

      //Setup Line Series Data.
      let objSeries = {};
      if (bCustomSeriesName) {
        objSeries['name'] = _strSelectedIndicator;
        objSeries['id'] = value;
      } else {
        objSeries['name'] = value.split(':')[1];
        objSeries['id'] = value;
      }
      objSeries['type'] = 'column';
      objSeries['data'] = _arrHighChartsColumnSeriesValues[value];
      objSeries['pointPadding'] = 0.0;
      objSeries['groupPadding'] = 0.1;
      objSeries['showInLegend'] = _bHighChartsLegendEnabled;
      arrSeries.push(objSeries);
      //Setup Confidence Interval Series Data.
      strName = _arrHighChartsColumnCISeriesNames[key];
      objSeries = {};
      objSeries['name'] = strName;
      objSeries['id'] = strName;
      objSeries['type'] = 'errorbar';
      objSeries['linkedTo'] = ':previous';
      objSeries['color'] = '#8C8C8C';
      objSeries['data'] = _arrHighChartsColumnCISeriesValues[strName];
      objSeries['visible'] = _bHighChartsConfidenceIntervalsVisible;
      objSeries['dataLabels'] = {
        formatter: function () {
          if (this.y != 0) {
            return this.y;
          }
        },
        enabled: _bHighChartsDataPointsEnabled,
      };
      arrSeries.push(objSeries);
    });
    options['series'] = arrSeries;

    //Set color options.
    Highcharts.setOptions({
      colors: _arrHighChartsColors,
    });
    //Display High Charts.
    var _existingColumnChart = $('#charts').highcharts();
    if (_existingColumnChart) _existingColumnChart.destroy();
    $('#charts').highcharts(options);
    _curDisplayType = statCompilerDashboard.DISPLAY_TYPE.Column;

    // Highcharts conistently positions the high confidence interval data point label incorrectly
    // running the update method on the series appears to fix this.
    let chartSeries = Highcharts.charts[Highcharts.charts.length - 1].series;
    $.each(chartSeries, function (index, ser) {
      if (ser.type === 'errorbar') {
        ser.update({
          dataLabels: {
            enabled: _bHighChartsDataPointsEnabled,
          },
        });
      }
    });

    //Set an active class on the control button
    $('.topToolbar .iconBarChart').addClass('active');
    count++;
  };

  var _getYCoordinates = function (cleanedChartSeries) {
    var dataToReturn = [];
    $.each(cleanedChartSeries.data, function (i, data) {
      // NOTE. SB added ternary statement below to avoid error caused when new slide added to carousel. This alleviates the problem but error still persists. Spent roughly 2 hours debugging, need to track down cause of error. Error = data.dataLabel is undefined
      dataToReturn.push(
        typeof data.dataLabel === 'object' ? data.dataLabel.translateY : 0
      );
    });
    return dataToReturn;
  };

  var _redrawY = function () {
    var chartSeries = $('#charts').highcharts().series;
    var chartObj = $('#charts').highcharts();
    var cleanedChartSeries = [];
    var yDataPrev = [];

    // Clean up the chart series from unused/hidden data
    $.each(chartSeries, function (i, feature) {
      if ((feature.dataMax || feature.dataMin) === undefined) return true;
      cleanedChartSeries.push(feature);
    });

    // Data labels should not overlay each other
    for (var i = 0; i < cleanedChartSeries.length; i++) {
      if (i === 0) {
        yDataPrev = _getYCoordinates(cleanedChartSeries[i]);
        continue;
      }
      yDataCurr = _getYCoordinates(cleanedChartSeries[i]);
      for (var j = 0; j < yDataPrev.length; j++) {
        // Missing dataLabel results in error that breaks toggling options
        if (cleanedChartSeries[i].data[j].dataLabel !== undefined) {
          var diff = yDataCurr[j] - yDataPrev[j];
          if (diff <= 0 && diff > -1.5) {
            var y = cleanedChartSeries[i].data[j].dataLabel.translateY + 5.5;
            cleanedChartSeries[i].data[j].dataLabel.ySetter(y);
          } else if (diff <= 0 && diff > -4) {
            var y = cleanedChartSeries[i].data[j].dataLabel.translateY + 4;
            cleanedChartSeries[i].data[j].dataLabel.ySetter(y);
          } else if (diff > 0 && diff < 0.5) {
            var y = cleanedChartSeries[i].data[j].dataLabel.translateY - 7;
            cleanedChartSeries[i].data[j].dataLabel.ySetter(y);
          } else if (diff > 0 && diff < 2) {
            var y = cleanedChartSeries[i].data[j].dataLabel.translateY - 10;
            cleanedChartSeries[i].data[j].dataLabel.ySetter(y);
          } else if (diff > 0 && diff < 3) {
            var y = cleanedChartSeries[i].data[j].dataLabel.translateY - 2;
            cleanedChartSeries[i].data[j].dataLabel.ySetter(y);
          }
        }
      }
      yDataPrev = cleanedChartSeries[i].yData;
    }
  };

  /**
   * @fn _displayLineChart
   * @brief 	Displays a line chart for the data.
   * @return 	void
   */
  var _displayLineChart = function () {
    // Hide the introjs tour for the line chart
    // $(".introTour").addClass("hidden");
    //Declare Important Variables.
    var yAxisMax = _nHighChartsMaxYValue;
    bCustomSeriesName = false;

    //Clear Display.
    _resetDisplay();

    //Reset buttons.
    _resetButtons();

    //Determine Height of chart based on height of resultsDiv.
    var curHeight = $('#resultsDiv').height();

    //Obtain precision for current indicator.
    var strPrecision = nameValueLib.getValueEX(_arrPrecision, [
      _strSelectedIndicatorCode,
    ]);

    //Determine if the current indicator is a percentage type.
    var strMeasurementType = nameValueLib.getValueEX(
      arrIndicatorMeasurementType,
      [_strSelectedIndicatorCode]
    );
    //If the Indicator is percent based, set the YMax to the YMax boolean and update the Max Y value to 100.
    if (strMeasurementType == 'Percent') {
      if (_bHighChartsYAxisToMaxEnabled) {
        yAxisMax = 100;
      }
    }

    // Check if the series is Total (excluding Total_)
    if (_isTotalLineSeries(_arrHighChartsLineSeriesNames)) {
      //if the only series checked is Total, remove series name and legend.
      bCustomSeriesName = true;
    }

    //Calculate Tick Interval for Y Axis based on 6 splits.
    var yInterval = (yAxisMax - _nHighChartsMinYValue) / 6;
    yInterval = parseFloat(yInterval.toFixed(strPrecision));
    if (yInterval == 0) {
      yInterval = 0.1;
    } else if (yInterval > 1) {
      yInterval = null;
    }

    //Setup Chart Options.

    var options = {};
    options.chart = {
      zoomType: 'x',
      height: curHeight,
      animation: {
        duration: 1,
      },
      style: {
        fontFamily: 'GillSansLight',
      },
    };
    options.exporting = {
      enabled: false,
      chartOptions: {
        itemStyle: { fontFamily: 'Arial', fontSize: '8px' },
        title: {
          text: _strSelectedIndicator != null ? _strSelectedIndicator : '',
        },
        credits: {
          enabled: true,
          text:
            'ICF, 2015. The DHS Program STATcompiler. Funded by USAID. http://www.statcompiler.com. ' +
            _arrMonthNames[_date.getMonth()] +
            ' ' +
            _date.getDate() +
            ' ' +
            _date.getFullYear(),
          href: '',
        },
      },
    };
    options.title = {
      text: '',
    };
    options.xAxis = {
      categories: _arrHighChartsLineCategories,
      tickWidth: 0,
    };
    options.yAxis = {
      title: {
        text: '',
      },
      labels: {
        enabled: _bHighChartsYAxisLabelEnabled,
        format: '{value:.' + strPrecision + 'f}',
      },
      gridLineWidth: _bHighChartsGridEnabled ? 1 : 0,
      min: _nHighChartsMinYValue,
      max: yAxisMax,
      tickInterval: yInterval,
    };

    options.plotOptions = {
      arearange: {
        connectNulls: true,
      },
      line: {
        dataLabels: {
          enabled: _bHighChartsDataPointsEnabled,
          format: '{point.y:.' + strPrecision + 'f}',
        },
        connectNulls: true,
        stickyTracking: false,
        enableMouseTracking: true,
        lineWidth: 4,
      },
      series: {
        events: {
          mouseOver: function (event) {
            /*var nSelectedIndex = this.index;
                			var arrAllSeries = this.chart.series;
                			$.each(arrAllSeries, function(index, curSeries) {
                				if(index != nSelectedIndex) {
	                				curSeries.update({lineWidth: 0})
                				}
                			}*/
          },
          mouseOut: function (event) {},
        },
        states: {
          hover: {
            lineWidth: 8,
          },
        },
        connectNulls: true,
      },
    };

    options.tooltip = {
      snap: 0,
      shared: false,
      useHTML: true,
      formatter: function () {
        //Declare Important Variables.
        var strCISeriesName = '';
        var strCountryName = '';
        var strCharCat = '';
        var strCharLabel = '';
        var strByVarLabel = '';
        var strSurveyName = '';
        var strSurveyYear = this.x;
        var strCategory = '';
        var strToolTip = '';
        var arrSurveyNames = [];
        var arrMainValues = [];
        var arrCILowValues = [];
        var arrCIHighValues = [];
        var strPrecision = nameValueLib.getValueEX(_arrPrecision, [
          _strSelectedIndicatorCode,
        ]);

        //Obtain variables from id.
        var arrTemp = this.series.options.id.split(':');
        strCountryName = arrTemp[0];
        strCharCat = arrTemp[1];
        strCharLabel = arrTemp[2];
        arrByVarLabels = nameValueLib.getObject(_arrSortedByVariableLabels, [
          _strSelectedIndicatorCode,
        ]);

        var arrAllByVariable = byVariableState.get(
          _strSelectedIndicatorCode,
          []
        );
        if (arrAllByVariable.current) {
          var strByVarLabel = arrAllByVariable.current;
          if (Array.isArray(strByVarLabel)) {
            strByVarLabel = strByVarLabel[0];
          }
        } else {
          var strByVarLabel = '';
        }
        //Obtain all Survey Names .
        var arrSurveys = nameValueLib.getValue(_arrSortedCountriesSurveys, [
          strCountryName,
        ]);
        for (
          var nCurSurveyIndex = 0;
          nCurSurveyIndex < arrSurveys.length;
          nCurSurveyIndex++
        ) {
          var objSurvey = arrSurveys[nCurSurveyIndex];
          if (
            nameValueLib.getValueMixed(
              _arrValues,
              [
                strCountryName,
                objSurvey.name,
                _strSelectedIndicatorCode,
                strCharCat,
                strCharLabel,
                strByVarLabel,
              ],
              [
                g_nameProp,
                g_nameProp,
                g_aliasProp,
                g_nameProp,
                g_nameProp,
                g_nameProp,
              ]
            ) != null
          ) {
            arrSurveyNames.push(objSurvey.name);
          }
        }

        //If there are confidence Intervals.
        if (_bHighChartsHasConfidenceIntervals) {
          //If the series currently highlighted contain the main values.

          if (this.point.series.linkedSeries.length > 0) {
            //First get all the main values.
            var nMaxSeriesLength = this.series.data.length;
            for (
              var nCurSeriesIndex = 0;
              nCurSeriesIndex < nMaxSeriesLength;
              nCurSeriesIndex++
            ) {
              arrMainValues.push(this.series.data[nCurSeriesIndex].y);
            }

            //Obtain the other corresponding CI series.
            var strSeriesName = this.point.series.options.id + '_CI';
            var objSeries = this.series.chart.get(strSeriesName);

            //Get all the CI values.
            nMaxSeriesLength = objSeries.data.length;
            for (
              var nCurSeriesIndex = 0;
              nCurSeriesIndex < nMaxSeriesLength;
              nCurSeriesIndex++
            ) {
              arrCILowValues.push(objSeries.data[nCurSeriesIndex].low);
              arrCIHighValues.push(objSeries.data[nCurSeriesIndex].high);
            }

            //Set the Category Label.
            if (
              _arrHighChartsLineSeriesNames.length > 1 ||
              !_isTotalCategory(this.point.series.options.id)
            ) {
              strCategory = strCharLabel;
            }
          } else {
            //If the series currently highlighted is a confidence interval.
            //Get all the CI values.
            var nMaxSeriesLength = this.series.data.length;
            for (
              var nCurSeriesIndex = 0;
              nCurSeriesIndex < nMaxSeriesLength;
              nCurSeriesIndex++
            ) {
              arrCILowValues.push(this.series.data[nCurSeriesIndex].low);
              arrCIHighValues.push(this.series.data[nCurSeriesIndex].high);
            }

            //Obtain the other corresponding Main Value series.
            var strSeriesName = this.point.series.options.id.split('_CI')[0];
            var objSeries = this.series.chart.get(strSeriesName);

            //Get all the main values.
            nMaxSeriesLength = objSeries.data.length;
            for (
              var nCurSeriesIndex = 0;
              nCurSeriesIndex < nMaxSeriesLength;
              nCurSeriesIndex++
            ) {
              arrMainValues.push(objSeries.data[nCurSeriesIndex].y);
            }

            //Set the Category Label.
            if (
              _arrHighChartsLineSeriesNames.length > 1 ||
              !_isTotalCategory(this.point.series.options.id)
            ) {
              strCategory = strCharLabel;
            }
          }
        } //END if(_bHighChartsHasConfidenceIntervals) {...
        else {
          //Normal Data
          //First get all the main values.
          var nMaxSeriesLength = this.series.data.length;
          for (
            var nCurSeriesIndex = 0;
            nCurSeriesIndex < nMaxSeriesLength;
            nCurSeriesIndex++
          ) {
            arrMainValues.push(this.series.data[nCurSeriesIndex].y);
          }

          //Set the Category Label.
          if (
            _arrHighChartsLineSeriesNames.length > 1 ||
            !_isTotalCategory(this.point.series.options.id)
          ) {
            strCategory = strCharLabel;
          }
        } //END else...

        //Display the Data.
        if (_bHighChartsHasConfidenceIntervals) {
          //Setup the table for the tooltip.
          strToolTip = '<table>';

          //ROW 1: Add the country name to the first row.
          strToolTip +=
            '<tr class="gillSansRegular"><small><td><strong>' +
            strCountryName +
            '</strong></td>';
          //Add the first row with survey names.
          for (
            var nCurIndex = 0;
            nCurIndex < arrSurveyNames.length;
            nCurIndex++
          ) {
            strToolTip +=
              '<td style="padding:0px 4px" align="center"><strong>' +
              arrSurveyNames[nCurIndex] +
              '</strong></td>';
          }
          strToolTip += '</small></tr>';

          //ROW 2: Add the Category Name.
          strToolTip +=
            '<tr><td class="gillSansRegular"><strong>' +
            strCategory +
            '</strong></td>';
          //Add the second row with survey values.
          for (
            var nCurIndex = 0;
            nCurIndex < arrMainValues.length;
            nCurIndex++
          ) {
            if (arrMainValues[nCurIndex] != null) {
              strToolTip +=
                '<td align="center">' +
                Config.sanitizeNumberString(
                  arrMainValues[nCurIndex].toFixed(strPrecision)
                ) +
                '</td>';
            }
          }

          //ROW 3: Add the Confidence Intervals
          strToolTip +=
            '<tr><td class="gillSansRegular"><strong>CI</strong></td>';
          //Add the second row with survey values.
          for (
            var nCurIndex = 0;
            nCurIndex < arrMainValues.length;
            nCurIndex++
          ) {
            if (arrMainValues[nCurIndex] != null) {
              strToolTip +=
                '<td align="center">(' +
                arrCILowValues[nCurIndex].toFixed(strPrecision) +
                ' - ' +
                arrCIHighValues[nCurIndex].toFixed(strPrecision) +
                ')</td>';
            }
          }

          strToolTip += '</tr></table>';
        } else {
          //Setup the table for the tooltip.
          strToolTip = '<table>';

          //ROW 1: Add the country name to the first row.
          strToolTip +=
            '<tr class="gillSansRegular"><small><td><strong>' +
            strCountryName +
            '</strong></td>';
          //Add the first row with survey names.
          for (
            var nCurIndex = 0;
            nCurIndex < arrSurveyNames.length;
            nCurIndex++
          ) {
            strToolTip +=
              '<td style="padding:0px 4px" align="center"><strong>' +
              arrSurveyNames[nCurIndex] +
              '</strong></td>';
          }
          strToolTip += '</small></tr>';

          //ROW 2: Add the Category Name.
          strToolTip +=
            '<tr><td class="gillSansRegular"><strong>' +
            strCategory +
            '</strong></td>';
          //Add the second row with survey values.
          for (
            var nCurIndex = 0;
            nCurIndex < arrMainValues.length;
            nCurIndex++
          ) {
            if (arrMainValues[nCurIndex] != null) {
              strToolTip +=
                '<td align="center">' +
                Config.sanitizeNumberString(
                  arrMainValues[nCurIndex].toFixed(strPrecision)
                ) +
                '</td>';
            }
          }
          strToolTip += '</tr></table>';
        }

        return strToolTip;
      },
    };
    options.credits = {
      enabled: false,
    };
    options.legend = {
      enabled: true,
    };

    //Before adding series data, check the number of series. If 20 or greater, hide legend.
    // if(_arrHighChartsLineSeriesNames.length >= 20) {
    // 	_bHighChartsLegendEnabled = false;
    //        $("#hideLabels").removeClass("checked");
    //       	$("#hideLabels").addClass("unchecked");
    // }

    //Add Series Data to chart options.
    var arrSeries = [];

    for (
      var nIndex = 0;
      nIndex < _arrHighChartsLineSeriesNames.length;
      nIndex++
    ) {
      //Setup Line Series Data.
      var strName = _arrHighChartsLineSeriesNames[nIndex];
      var arrName = strName.split(':');
      var objSeries = {};
      if (bCustomSeriesName) {
        objSeries['name'] = arrName[0];
        objSeries['id'] = strName;
      } else {
        objSeries['name'] = arrName[0] + ': ' + arrName[2];
        objSeries['id'] = strName;
      }

      objSeries['data'] = _arrHighChartsLineSeriesValues[strName];
      objSeries['showInLegend'] = _bHighChartsLegendEnabled;
      objSeries['connectNulls'] = true;
      objSeries['marker'] = {
        fillColor: 'white',
        lineWidth: 2,
        lineColor: _getValidColorForChart(nIndex),
      };

      objSeries['color'] = _getValidColorForChart(nIndex);
      objSeries['dataLabels'] = {
        y: 10,
      };
      arrSeries.push(objSeries);

      //Setup Confidence Interval Series Data.
      strName = _arrHighChartsLineCISeriesNames[nIndex];
      var arrName = strName.split(':');
      objSeries = {};
      objSeries['name'] = arrName[0] + ': ' + arrName[2];
      objSeries['id'] = strName;
      objSeries['type'] = 'arearange';
      objSeries['linkedTo'] = ':previous';
      objSeries['connectNulls'] = true;
      objSeries['color'] = _getValidColorForChart(nIndex);
      //objSeries["fillColor"] = _getValidColorForChart(nIndex);
      objSeries['lineWidth'] = 0;
      objSeries['fillOpacity'] = 0.3;
      objSeries['zIndex'] = 0;
      objSeries['data'] = _arrHighChartsLineCISeriesValues[strName];
      objSeries['visible'] = _bHighChartsConfidenceIntervalsVisible;
      objSeries['dataLabels'] = {
        formatter: function () {
          if (this.y != 0) {
            return this.y;
          }
        },
      };

      arrSeries.push(objSeries);
    }

    options['series'] = arrSeries;

    // Set color options.
    Highcharts.setOptions(_arrHighChartsColors);

    options = (function (_options) {
      var vals = _options.series.map(function (v) {
        return _.findIndex(v.data, function (vv) {
          return typeof vv === 'number';
        });
      });
      var first_year_index = Math.min.apply(
        null,
        _.filter(vals, function (vvv) {
          return vvv > -1;
        })
      );
      var lastvals = _options.series.map(function (v) {
        return _.findLastIndex(v.data, function (vv) {
          return typeof vv === 'number';
        });
      });
      var last_year_index = Math.max.apply(
        null,
        _.filter(lastvals, function (vvv) {
          return vvv > -1;
        })
      );
      last_year_index++;
      _options.series = _options.series.map(function (v) {
        v.data = v.data.slice(0, last_year_index).slice(first_year_index);
        return v;
      });
      _options.xAxis.categories = _options.xAxis.categories
        .slice(0, last_year_index)
        .slice(first_year_index);
      return _options;
    })(options);

    //Display High Charts.
    var _existingLineChart = $(_highChartsElement).highcharts();
    if (_existingLineChart) _existingLineChart.destroy();
    $(_highChartsElement).highcharts(options);

    //Set Display Type.
    _curDisplayType = statCompilerDashboard.DISPLAY_TYPE.Line;

    //Set an active class on the control button
    $('.topToolbar .iconLineChart').addClass('active');
    var chart = $(_highChartsElement).highcharts();

    _updateXAxisLables(chart);
    // why is this being redrawn???
    chart.redraw();
  };

  /**
   * @fn _displayMap
   * @brief 	Displays a map of the data.
   * @param 	dataChanged: A boolean to specify whether the data has been updated as well.
   * @return 	void
   */
  var _displayMap = function(redrawControlPanel) {
    if ($('.introTour').hasClass('hidden')) {
      $('.introTour').removeClass('hidden');
    }
    _resetDisplay();
    document.getElementById('mapDiv').classList.remove('hidden');

    _resetButtons();

    var obj = {
      _arrNationalAllMapData: _arrNationalAllMapData,
      _arrNationalAllMapCIData: _arrNationalAllMapCIData,
      _arrNationalMapData: _arrNationalMapData,
      _arrNationalMapCIData: _arrNationalMapCIData,
      _arrNationalMapValues: _arrNationalMapValues,
      _arrSubnationalAllMapData: _arrSubnationalAllMapData,
      _arrSubnationalMapData: _arrSubnationalMapData,
      _arrSubnationalMapCIData: _arrSubnationalAllMapCIData,
      _arrSubnationalMapValues: _arrSubnationalMapValues,
      _currentIndicator: _strSelectedIndicator,
      _currentIndicatorCode: _strSelectedIndicatorCode,
      _mapControlsDiv: _mapControlsDiv,
      _mapElement: _mapElement,
      _strCurMapCharLabel: _strCurMapCharLabel,
      _strCurMapCharCat: _strCurMapCharCat,
      _strPrecision: nameValueLib.getValueEX(_arrPrecision, [_strSelectedIndicatorCode]),
      _currentSurveySelected: _curSurveySelection,
      _arrCustomSurveySelections: _arrCustomSurveySelections,
      _nCurMapLevelRank: _nCurMapLevelRank,
      _strCurBreakType: _strCurBreakType,
      _arrCustomBreaks: _arrCustomBreaks,
      _bCustBrksFromShare: _bCustBrksFromShare,
    };

    //Set an active class on the control button
    $('.topToolbar .iconMap').addClass('active');

    window.loadMapBundle().then(function(mod) {
      var map = mod.default;
      //If the map is not initialized
      if (map) {
        if (!map.getInitialized() && !map.isMapLoading()) {
          map.init(obj);
          map.displayMap(obj);
        } else if (_bDataUpdated) {
          map.updateCountries(obj);
        } else if (redrawControlPanel) {
          map.updateCurrentData(obj);
        }
      } else {
        map.displayMap(obj);
      }
    });
  };

  //! Bookmarks!
  /**
   * @fn _getBookmark
   * @brief 	Obtains a bookmark link for the current state of the Application.
   * @return 	string specifying the bitly URL.
   */
  var _getBookmark = function () {
    //Declare Important Variables.
    var strFinalURL =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname +
      '?';
    var strTemp = '';
    var arrTemp = [];

    //Obtain the Country Codes being used. "cc" parameter.
    if (
      global_all_countries.length ===
      $('#lstCountries .jstree-anchor').not('.jstree-disabled').length
    ) {
      strTemp = 'ALL';
    } else {
      $.each(_arrSortedCountriesSurveys, function (countryIndex, objCountry) {
        arrTemp.push(objCountry.alias);
      });

      strTemp = arrTemp.join(',');
    }
    //Add to Final URL.
    strFinalURL += 'cc=' + strTemp;

    //Get the unselected ones now from the "ucc"
    var countries_inverted = _.invert(dhsAPI.allCountriesMap);
    strTemp = statCompilerDashboard
      .getCurrUnSelectedCountries()
      .map(function (v) {
        return countries_inverted[v];
      })
      .join(',');

    strFinalURL += '&ucc=' + strTemp;

    //Obtain the Indicator Codes being used. "is" parameter.
    strTemp = '';
    arrTemp = [];
    $.each(_arrSortedIndicators, function (indicatorIndex, objIndicator) {
      strTemp += objIndicator.alias + ',';
    });
    //Remove the last comma.
    strTemp = strTemp.substring(0, strTemp.length - 1);
    //Add to Final URL.
    strFinalURL += '&ic=' + strTemp;

    //Obtain the selected char labels being used. "scl" parameter.
    arrTemp = _getSelectedCharLabelIDs();
    strTemp = arrTemp.join(',');

    //Add to Final URL.
    strFinalURL += '&scl=' + strTemp;

    //Obtain the Display type.
    strTemp = '&dt=';
    switch (_curDisplayType) {
      case statCompilerDashboard.DISPLAY_TYPE.Grid:
        strTemp += '0';
        break;
      case statCompilerDashboard.DISPLAY_TYPE.Column:
        strTemp += '1';
        break;
      case statCompilerDashboard.DISPLAY_TYPE.Line:
        strTemp += '2';
        break;
      case statCompilerDashboard.DISPLAY_TYPE.ScatterPlot:
        strTemp += '3';
        break;
      case statCompilerDashboard.DISPLAY_TYPE.Map:
        strTemp += '4';
        break;
      default:
        strTemp += '0';
        break;
    }
    strFinalURL += strTemp;

    //Obtain Pivot Type.
    strTemp = '&pt=';
    switch (_curPivotType) {
      case statCompilerDashboard.PIVOT_TYPE.Survey:
        strTemp += '0';
        break;
      case statCompilerDashboard.PIVOT_TYPE.Indicator:
        strTemp += '1';
        break;
      case statCompilerDashboard.PIVOT_TYPE.SurveyChar:
        strTemp += '2';
        break;
      case statCompilerDashboard.PIVOT_TYPE.CharSurvey:
        strTemp += '3';
        break;
      default:
        strTemp += '0';
        break;
    }
    strFinalURL += strTemp;

    //Check to see what kind of a survey selection had been made.
    switch (_curSurveySelection) {
      case statCompilerDashboard.SURVEY_SELECTION.Recent:
      case statCompilerDashboard.SURVEY_SELECTION.Custom:
        const unselectedCountries = [];
        //Create a string of all unselected surveys by country
        for (let country of _arrSortedCountriesSurveys) {
          const unselectedSurveyYears = [];
          for (let survey of country.value) {
            if (!survey.value) {
              unselectedSurveyYears.push(survey.alias);
            }
          }
          if (unselectedSurveyYears.length > 0) {
            unselectedCountries.push(
              `${country.alias}-${unselectedSurveyYears.join('+')}`
            );
          }
        }

        if (unselectedCountries.length > 0) {
          // Example: sy=BF-1993+2017_BO-1989
          // Expected format for parsing a shared link when page loads
          const selectedSurveysByCountryParam = `sy=${unselectedCountries.join(
            '_'
          )}`;
          strTemp = `&ss=1&${selectedSurveysByCountryParam}`;
        } else {
          strTemp = '&ss=0';
        }
        break;
      default:
        strTemp = '&ss=0';
        break;
    }
    strFinalURL += strTemp;

    // Region level selected. 0 is national and 1, 2, or 3 are subnational
    // Corresponds to levelRank in Feature Service Data
    switch (_nCurMapLevelRank) {
      case 0:
        strTemp = '&lvlRnk=0';
        break;
      case 1:
        strTemp = '&lvlRnk=1';
        break;
      case 2:
        strTemp = '&lvlRnk=2';
        break;
      case 3:
        strTemp = '&lvlRnk=3';
        break;
      default:
        strTemp = '&lvlRnk=0';
        break;
    }
    strFinalURL += strTemp;

    // Get survey year range
    if (g_arrCurrSurveyRange.length === 2) {
      strTemp = `&syr=${g_arrCurrSurveyRange[0]}-${g_arrCurrSurveyRange[1]}`;
      strFinalURL += strTemp;
    }

    if (_strCurBreakType) {
      if (_strCurBreakType === 'Custom') {
        let customBreaks = [];
        for (let breaks of _arrCustomBreaks) {
          const breakLevelVals = [];
          for (let breakItem of breaks) {
            breakLevelVals.push(breakItem.value);
          }
          customBreaks.push(`${breakLevelVals.join()}`);
        }
        const customBreaksStr = customBreaks.join('+');
        strTemp = `&brk=${_strCurBreakType}&custbrks=${customBreaksStr}`;
      } else {
        strTemp = `&brk=${_strCurBreakType}`;
      }
      strFinalURL += strTemp;
    }

    strFinalURL += (function () {
      // get the selected indicator -- si
      var si =
        '&si=' + statCompilerDashboard.getIndicatorMetaData().Indicator_ID;

      // get the selected byvariable -- sbv
      var rrr = [];
      var allstate = byVariableState.all();
      // var inverted_map = _.invert(byVariableState.indicator_id_map);
      for (var i in allstate) {
        if (allstate[i].current == allstate[i].preferred) continue; // only add in if it has been change in order to conserve URL characters
        var segment = allstate[i].current
          .map(function (v) {
            return allstate[i].all.indexOf(v);
          })
          .join(',');
        rrr.push(i + '[' + segment + ']');
      }
      rrr = rrr.join('');
      var sbv = '&sbv=' + rrr;

      return si + sbv;
    })();

    //Return Final URL.
    return strFinalURL;
  };

  /**
   * @fn _setLangSpecificConstants
   * @brief 	Sets the language specfic constants
   * @return 	void
   */
  var _setLangSpecificConstants = function () {
    var curLang = Config.getLanguage();

    switch (curLang) {
      case 'fr':
        _strRegionCharCat = 'Région';
        break;
      default:
        _strRegionCharCat = 'Region';
    }
  };

  /**
   * @fn _isRegionCategory
   * @brief 	Compares the Char Cat passed to check if it is a regions char cat.
   * @param 	curCategory: String specifying the category to compare to.
   * @return 	true if it is a regions category, false otherwise.
   */
  var _isRegionCategory = function (curCategory) {
    //Check if the category is Region.
    if (curCategory.indexOf(_strRegionCharCat) > -1) {
      return true;
    } else {
      return false;
    }
  };
  //! _isTotalCategory
  /**
   * @fn _isTotalCategory
   * @brief 	Compares the Char Cat passed to check if it is a Total char cat.
   * @param 	curCategory: String specifying the category to compare to.
   * @return 	true if it is a Total category, false otherwise.
   */
  var _isTotalCategory = function (curCategory) {
    var matched = (curCategory || '').match(/[total:]/gi);
    return _.isEmpty(matched) ? false : matched.length === curCategory.length;
  };

  /**
   * @fn _isTotalCategoryExact
   * @brief 	Compares the Char Cat passed to check if it is a Total char cat.
   * @param 	curCategory: String specifying the category to compare to.
   * @return 	true if it is a Total category, false otherwise.
   */
  var _isTotalCategoryExact = function (curCategory) {
    return curCategory == _strTotalTotalConstant;
  };

  /**
   * @fn _isTotalSeries
   * @brief 	Compares all the series names and see if they are just Total category.
   * @param 	arrSeries: Array of all series (charcat) names
   * @return 	true if it is, false otherwise.
   */
  var _isTotalSeries = function (arrSeries) {
    for (var nIndex = 0; nIndex < arrSeries.length; nIndex++) {
      if (!_isTotalCategoryExact(arrSeries[nIndex])) {
        return false;
      }
    }
    return true;
  };

  /**
   * @fn _isTotalSeries
   * @brief 	Compares all the series names and see if they are just Total category.
   * @param 	arrSeries: Array of all series (charcat) names
   * @return 	true if it is, false otherwise.
   */
  var _isTotalLineSeries = function (arrSeries) {
    for (var nIndex = 0; nIndex < arrSeries.length; nIndex++) {
      if (
        !_isTotalCategoryExact(
          arrSeries[nIndex].substr(arrSeries[nIndex].indexOf(':') + 1)
        )
      ) {
        return false;
      }
    }
    return true;
  };

  //! RETURN values from object start here.
  return {
    /**
     *	DISPLAY_TYPE: The type of pivot you want to apply to the data.
     */
    PIVOT_TYPE: {
      Survey: 'Survey',
      Indicator: 'Indicator',
      SurveyChar: 'SurveyChar',
      CharSurvey: 'CharSurvey',
    },

    /**
     *	DISPLAY_TYPE: The type of display you want to see.
     */
    DISPLAY_TYPE: {
      Grid: 'Grid',
      Column: 'Column',
      Line: 'Line',
      ScatterPlot: 'ScatterPlot',
      Map: 'Map',
    },

    /**
     *	SURVEY_SELECTION: The type of survey selection, used for switching survey selection type.
     */
    SURVEY_SELECTION: {
      All: 'All',
      Recent: 'Recent',
      Custom: 'Custom',
    },

    /**
     *	MAP_GEOTYPE: Sets map to load with regional data or subnational data.
     */
    MAP_GEOTYPE: {
      SUBNATIONAL: 0,
      NATIONAL: 1,
    },

    /**
     * @fn initializeDashboard
     * @brief 	Initializes the Dashboard.
     * @details	Initially parses through the raw data, create all storage arrays and calls the appropriate display.
     * @param 	gridElement: Used to specify a HTML Table element where the grid will be created.
     * @param 	data: The data in json format retreived from the DHS API.
     * @param 	arrPivot: An array specifying the columns on which to initially pivot the data. Default is SurveyID
     * @return 	void
     */
    initializeDashboard: async function (
      gridElement,
      highChartElement,
      indicatorListElement,
      mapElement,
      mapControlsElement,
      charLabelListElement,
      countryListElement,
      pivotDropDownElement,
      data,
      selectedCharLabelIds,
      selectedCountryCodes,
      pivotType,
      displayType,
      mapLevelRank,
      breakType,
      customBreaks,
      hasCustomBreakPoints
    ) {
      //Save the grid element for future use.
      _gridElement = gridElement;

      //Save the high charts element for future use.
      _highChartsElement = highChartElement;

      //Save the Indicators List element for future use.
      _lstIndicators = indicatorListElement;

      //Save the Map Element for future use.
      _mapElement = mapElement;

      //Save the Map Controls Element for future use.
      _mapControlsDiv = mapControlsElement;

      //Save the Char Cat / Char Labels element for future use.
      _lstCharLabels = charLabelListElement;

      //Save the Countries List element for future use.
      _lstCountries = countryListElement;

      //Save the Pivot Drop Down Element for future use.
      _pivotDropDownElement = pivotDropDownElement;

      //Set map geography type for loading regions or countries.
      _nCurMapLevelRank = mapLevelRank;

      //Set map geography type for loading regions or countries.
      _strCurBreakType = breakType;

      //Set custom break points for the Custom break type.
      _arrCustomBreaks = customBreaks;

      //Set if custom break points are being shared.
      _bCustBrksFromShare = hasCustomBreakPoints;

      //Assign the raw data for future use.
      _arrRawData = data;

      //Setup Language Specific Constants.
      _setLangSpecificConstants();

      //Setup regional raw data and countries to match with their corresponding level ranks
      if (_arrRawData && _arrRawData.length > 0) {
        var getUniqueCountries = [
          ...new Set(_arrRawData.map((item) => item.DHS_CountryCode)),
        ];
        var getUniqueLVLRNK = [1, 2, 3];

        var strCountryNameIDS = getUniqueCountries
          .map((countryName) => {
            return "'" + countryName + "'";
          })
          .join(',');
        var strLVLRNK = getUniqueLVLRNK.join(',');
        _arrRawData = await nameValueLib.getResults(
          strCountryNameIDS,
          _arrRawData,
          strLVLRNK
        );
      }

      //Setup Sorted Arrays.
      _setupSortedData(selectedCharLabelIds, selectedCountryCodes);

      //Create Grid Data (depending on pivot).
      statCompilerDashboard.createGridData(pivotType);

      //Create Column Chart Data.
      _createColumnChartData(_strSelectedIndicatorCode);

      //Create Line Chart Data.
      _createLineChartData(_strSelectedIndicatorCode);

      //Create Map Data.
      _createMapData(_strSelectedIndicatorCode);

      //Display Data (depending on display choice).
      statCompilerDashboard.displayData(displayType, false);

      //Setup the Control Panel.
      _setupControlPanel();

      //Set Initialize to true.
      _bDashboardInitialized = true;

      window.onresize = function () {
        if (Highcharts.charts.length > 0) {
          var chart = Highcharts.charts[Highcharts.charts.length - 1];

          var chartContainer = $('#charts');
          if (chart) {
            chart.setSize(chartContainer.width(), chartContainer.height());

            // On resize Highcharts positions high confidence interval data label with low one
            // This fixes that issue by placing them in the correct position.
            $.each(chart.series, function (index, ser) {
              if (ser.type === 'errorbar') {
                ser.update({
                  dataLabels: {
                    enabled: _bHighChartsDataPointsEnabled,
                  },
                });
              }
            });
          }
        }
      };
    },
    /**
     * @fn updateDashboard
     * @brief 	Updates the Dashboard.
     * @details	The function updates the dashboard. If there is new data, it parses it first. Updates the controls if needed.
     * @param 	newdata: New data in json format retreived from the DHS API.
     * @param 	redrawControlPanel: A boolean specifying whether to redraw the control panel or not.
     * @return 	void
     */
    updateDashboard: async function (newdata, redrawControlPanel) {
      if (newdata) {
        //Assign the new raw data for future use.
        _arrRawData = newdata;

        //Obtain the currently selected labels to make sure and select them after update.
        var arrSelectedLabels = _getSelectedCharLabelIDs();

        //Obtain the currently selected country names to make sure and select them after update.
        var arrSelectedCountries = _getSelectedCountryCodes();

        //Setup regional raw data and countries to match with their corresponding level ranks
        if (_arrRawData && _arrRawData.length > 0) {
          var getUniqueCountries = [
            ...new Set(_arrRawData.map((item) => item.DHS_CountryCode)),
          ];
          var getUniqueLVLRNK = [1, 2, 3];

          var strCountryNameIDS = getUniqueCountries
            .map((countryName) => {
              return "'" + countryName + "'";
            })
            .join(',');
          var strLVLRNK = getUniqueLVLRNK.join(',');
          _arrRawData =
            (await nameValueLib.getResults(
              strCountryNameIDS,
              _arrRawData,
              strLVLRNK
            )) || _arrRawData;
        }
        //Initialize Sorted Arrays.
        _setupSortedData(arrSelectedLabels, arrSelectedCountries);

        //Update data to reflect current Survey Selection.
        switch (_curSurveySelection) {
          case statCompilerDashboard.SURVEY_SELECTION.Recent:
            statCompilerDashboard.displayRecentSurveys(true, 1);
            break;
          case statCompilerDashboard.SURVEY_SELECTION.Custom:
            statCompilerDashboard.displayCustomSurveySelector(
              _arrCustomSurveySelections,
              true
            );
            break;
          default:
            //No need to do anything, data is already selected.
            break;
        }

        //Set boolean to specify data has been updated.
        _bDataUpdated = true;

        // Finalize the pending indicator selection BEFORE building/rendering the display below.
        // When new data is added (e.g. adding an indicator from the parameters popup), the newly
        // added indicator becomes the current map indicator — but the selection is otherwise only
        // finalized later in _setupControlPanel(), which runs AFTER the map has already rendered.
        // Without this, _createMapData()/the map render below use the *previous* indicator, so the
        // dropdown shows the new indicator while the map still shows the old one's data (until the
        // user toggles the dropdown). This mirrors the selection _setupControlPanel makes from
        // _selectedIndicatorDropdown (its last entry = most recently selected).
        if (_selectedIndicatorDropdown.length > 0) {
          var strPendingIndicator =
            _selectedIndicatorDropdown[_selectedIndicatorDropdown.length - 1];
          for (var nPendingIndex = 0; nPendingIndex < _arrSortedIndicators.length; nPendingIndex++) {
            var objPendingIndicator = _arrSortedIndicators[nPendingIndex];
            if (objPendingIndicator.type === 'I' && objPendingIndicator.name === strPendingIndicator) {
              _strSelectedIndicator = objPendingIndicator.name;
              _strSelectedIndicatorCode = objPendingIndicator.alias;
              _strInfoIndicatorId = objPendingIndicator.alias;
              break;
            }
          }
        }
      }

      switch (_curDisplayType) {
        case statCompilerDashboard.DISPLAY_TYPE.Grid:
          //Create Grid Data (depending on pivot).
          statCompilerDashboard.createGridData(_curPivotType);
          break;
        case statCompilerDashboard.DISPLAY_TYPE.Column:
          _createColumnChartData(_strSelectedIndicatorCode);
          break;
        case statCompilerDashboard.DISPLAY_TYPE.Line:
          _createLineChartData(_strSelectedIndicatorCode);
          break;
        case statCompilerDashboard.DISPLAY_TYPE.Map:
          _createMapData(_strSelectedIndicatorCode);
          break;
      }

      //Display Data (depending on display choice).
      statCompilerDashboard.displayData(_curDisplayType, redrawControlPanel);

      //Setup the Control Panel.
      if (redrawControlPanel) {
        _setupControlPanel();
      }

      //Set Data updated to false after updates have been performed.
      _bDataUpdated = false;

      switch (_curDisplayType) {
        case statCompilerDashboard.DISPLAY_TYPE.Grid:
          _createColumnChartData(_strSelectedIndicatorCode);
          _createLineChartData(_strSelectedIndicatorCode);
          _createMapData(_strSelectedIndicatorCode);
          break;
        case statCompilerDashboard.DISPLAY_TYPE.Column:
          statCompilerDashboard.createGridData(_curPivotType);
          _createLineChartData(_strSelectedIndicatorCode);
          _createMapData(_strSelectedIndicatorCode);
          break;
        case statCompilerDashboard.DISPLAY_TYPE.Line:
          statCompilerDashboard.createGridData(_curPivotType);
          _createColumnChartData(_strSelectedIndicatorCode);
          _createMapData(_strSelectedIndicatorCode);
          break;
        case statCompilerDashboard.DISPLAY_TYPE.Map:
          statCompilerDashboard.createGridData(_curPivotType);
          _createColumnChartData(_strSelectedIndicatorCode);
          _createLineChartData(_strSelectedIndicatorCode);
          break;
      }
    },
    /**
     * @fn createGridData
     * @brief 	Creates grid data depending on the pivot type.
     * @param 	pivotType: An enumeration specifying the correct Pivot Type.
     * @return 	void
     */
    createGridData: function (pivotType) {
      //Create data depending on the pivot type.
      switch (pivotType) {
        case statCompilerDashboard.PIVOT_TYPE.Survey:
          _createGridDataForSurveysPivot();
          break;
        case statCompilerDashboard.PIVOT_TYPE.Indicator:
          _createGridDataForIndicatorsPivot();
          break;
        case statCompilerDashboard.PIVOT_TYPE.SurveyChar:
          _createGridDataForSurveyCharCatPivot();
          break;
        case statCompilerDashboard.PIVOT_TYPE.CharSurvey:
          _createGridDataForCharCatSurveyPivot();
          break;
        default:
          _createGridDataForSurveysPivot();
          break;
      }

      //Save the pivot type.
      _curPivotType = pivotType;
    },
    /**
     * @fn displayData
     * @brief 	Display's data depending on the display type.
     * @param 	displayType: An enumeration specifying the correct Display Type.
     * @return 	void
     */
    displayData: function (displayType, redrawControlPanel) {
      //Update Button Panel depending display type.
      if (displayType === statCompilerDashboard.DISPLAY_TYPE.Grid) {
        //Hide Chart Specific Buttons.
        $(
          '#disableGrid, #hideYAxis, #hideLabels, #hideDataPoints, #setYToMaxPercent, #toggleConfidenceIntervals'
        ).addClass('hidden');

        $('#mobileSelectPivot-button').removeClass('hidden');

        $('.indicatorName').addClass('visibilityHidden');

        $('#pivotMenu').removeClass('hidden');

        $('#optionsMenu').addClass('hidden');

        $('#mobileOptionsMenu').addClass('hidden');

        $('#exportsMenu').removeClass('hidden');

        $('#mobileExportsMenu').removeClass('hidden');

        $('#exportPDF, #exportJPG').addClass('hidden');
        $('#mobileExportPDF, #mobileExportJPG').addClass('hidden');

        $('#exportTable, #exportCSV').removeClass('hidden');
        $('#mobileExportTable, #mobileExportCSV').removeClass('hidden');

        $('#mapPrint, #mobileMapPrint, #mapExport, #mobileMapExport').addClass(
          'hidden'
        );

        $('#toggleMostRecent').removeClass('hidden');
        $('#gbox_gridDATA').removeClass('hidden');
      } else {
        $(
          '#disableGrid, #hideYAxis, #hideLabels, #hideDataPoints, #toggleConfidenceIntervals'
        ).removeClass('hidden');
        $(
          '#mobileDisableGrid, #mobileHideYAxis, #mobileHideLabels, #mobileHideDataPoints, #mobileToggleConfidenceIntervals'
        ).removeClass('hidden');

        //If the Indicator is percent based, display the Y-Axis Max option as well.
        var strMeasurementType = nameValueLib.getValueEX(
          arrIndicatorMeasurementType,
          [_strSelectedIndicatorCode]
        );
        if (strMeasurementType == Config.getUniversalString('Percent')) {
          $('#setYToMaxPercent').removeClass('hidden');
        }

        $('#mobileSelectPivot-button').addClass('hidden');

        $('.indicatorName').removeClass('visibilityHidden');
        $('.indicatorName').removeClass('hidden');

        $('#pivotMenu').addClass('hidden');

        $('#optionsMenu').removeClass('hidden');

        $('#mobileOptionsMenu').removeClass('hidden');

        $('#exportsMenu').removeClass('hidden');

        $('#mobileExportsMenu').removeClass('hidden');

        $('#exportPDF, #exportJPG').removeClass('hidden');
        $('#mobileExportPDF, #mobileExportJPG').removeClass('hidden');

        $('#exportTable, #exportCSV').addClass('hidden');
        $('#mobileExportTable, #mobileExportCSV').addClass('hidden');

        $('#mapPrint, #mobileMapPrint, #mapExport, #mobileMapExport').addClass(
          'hidden'
        );
        $('#gbox_gridDATA').addClass('hidden');
      }

      if (displayType === statCompilerDashboard.DISPLAY_TYPE.Map) {
        //$("#exportsMenu").addClass("hidden");
        $(
          '#disableGrid, #hideYAxis, #hideLabels, #hideDataPoints, #setYToMaxPercent, #toggleConfidenceIntervals'
        ).addClass('hidden');
        $(
          '#mobileDisableGrid, #mobileHideYAxis, #mobileHideLabels, #mobileHideDataPoints, #mobileSetYToMaxPercent, #mobileToggleConfidenceIntervals'
        ).addClass('hidden');

        $('#pivotMenu').addClass('hidden');

        $('#hideLayerLabels').removeClass('hidden');
        $('#toggleLightStyle').removeClass('hidden');

        $('#mobileHideLayerLabels').removeClass('hidden');
        $('#mobileToggleLightStyle').removeClass('hidden');

        $('#exportPDF, #exportJPG, #exportTable, #exportCSV').addClass(
          'hidden'
        );
        $(
          '#mobileExportPDF, #mobileExportJPG, #mobileExportTable, #mobileExportCSV'
        ).addClass('hidden');
        $(
          '#mapPrint, #mobileMapPrint, #mapExport, #mobileMapExport'
        ).removeClass('hidden');

        document.getElementById('mapDiv').classList.remove('hidden');

        $('#mapPanel').removeClass('hidden');
        if ($('#panelContainer.bottomIndividualPanelOpen').length > 0) {
          $('#panelContainer').removeClass('bottomIndividualPanelOpen');
        }
        $('#viewAllSurveys').addClass('hidden');

        $('#toggleMostRecent').addClass('hidden');
      } else {
        $('#hideLayerLabels').addClass('hidden');
        $('#toggleLightStyle').addClass('hidden');
        $('#mobileHideLayerLabels').addClass('hidden');
        $('#mobileToggleLightStyle').addClass('hidden');
        $('#mapPanel').addClass('hidden');
        $('#panelContainer').removeClass('mapPanelOpen');
        if ($('#panelContainer.countriesPanelOpen').length > 0) {
          $('#panelContainer').removeClass('countriesPanelOpen');
        }
        $('#viewAllSurveys').removeClass('hidden');
        document.getElementById('mapDiv').classList.remove('hidden');
      }

      if (displayType === statCompilerDashboard.DISPLAY_TYPE.Column) {
        $('#toggleMostRecent').removeClass('hidden');
      }

      if (displayType === statCompilerDashboard.DISPLAY_TYPE.Line) {
        $('#viewRecentSurveys').addClass('hidden');
        $('#toggleMostRecent').addClass('hidden');
        // $("#sliderButton").html("Custom Range");
      } else {
        $('#viewRecentSurveys').removeClass('hidden');

        // $("#sliderButton").html("Custom");
      }

      if (
        displayType === statCompilerDashboard.DISPLAY_TYPE.Line ||
        displayType === statCompilerDashboard.DISPLAY_TYPE.Column
      ) {
        $('#charts').removeClass('hidden');
        // Only display confidence interval toggle option if confidence intervals exist
        if (_bHighChartsHasConfidenceIntervals) {
          $(
            '#toggleConfidenceIntervals, #mobileToggleConfidenceIntervals'
          ).removeClass('hidden');
        } else {
          $(
            '#toggleConfidenceIntervals, #mobileToggleConfidenceIntervals'
          ).addClass('hidden');
        }
      } else {
        $('#charts').addClass('hidden');
      }

      //Create data depending on the pivot type.
      switch (displayType) {
        case statCompilerDashboard.DISPLAY_TYPE.Grid:
          //Diplay Grid
          _displayGrid();

          //Send GA pageview (grid).
          ga('set', { page: PV_GRID, title: TITLE_DATA });
          ga('send', 'pageview');
          gtag('event', 'pageview', {
            event_page: PV_GRID,
            event_title: TITLE_DATA,
          });

          break;
        case statCompilerDashboard.DISPLAY_TYPE.Column:
          //Display Column Chart.
          _displayColumnChart();

          //Send GA pageview (column chart).
          ga('set', { page: PV_COLUMNCHART, title: TITLE_DATA });
          ga('send', 'pageview');
          gtag('event', 'pageview', {
            event_page: PV_COLUMNCHART,
            event_title: TITLE_DATA,
          });

          break;
        case statCompilerDashboard.DISPLAY_TYPE.Line:
          //Display Line Chart.

          _displayLineChart();

          //Send GA pageview (line chart).
          ga('set', { page: PV_LINECHART, title: TITLE_DATA });
          ga('send', 'pageview');
          gtag('event', 'pageview', {
            event_page: PV_LINECHART,
            event_title: TITLE_DATA,
          });

          break;
        case statCompilerDashboard.DISPLAY_TYPE.Map:
          //Display Map.
          _displayMap(redrawControlPanel);

          //Send GA pageview (map).
          ga('set', { page: PV_MAP, title: TITLE_DATA });
          ga('send', 'pageview');
          gtag('event', 'pageview', {
            event_page: PV_MAP,
            event_title: TITLE_DATA,
          });

          break;
        default:
          //Display Grid (Default)
          _displayGrid();

          //Send GA pageview (grid).
          ga('set', { page: PV_GRID, title: TITLE_DATA });
          ga('send', 'pageview');
          gtag('event', 'pageview', {
            event_page: PV_GRID,
            event_title: TITLE_DATA,
          });

          break;
      }

      //Save the display type.
      _curDisplayType = displayType;
    },
    /**
     * @fn updatePivot
     * @brief 	Updates the Pivot Type and data.
     * @details	Updates the pivot and recreates the display data grid.
     * @param 	pivotType: An enumeration specifying the correct Pivot Type.
     * @return 	void
     */
    updatePivot: function (pivotType) {
      //Set current Pivot Type.
      _curPivotType = pivotType;

      //Recreate grid data.
      statCompilerDashboard.createGridData(_curPivotType);

      //Refresh the display.
      statCompilerDashboard.displayData(_curDisplayType, false);
    },

    getMapRenderingValues: function () {
      var obj = {
        _arrSortedCountriesSurveys: _arrSortedCountriesSurveys,
        _strSelectedIndicator: _strSelectedIndicator,
        _strSelectedIndicatorCode: _strSelectedIndicatorCode,
        _arrNationalMapData: _arrNationalMapData,
        _arrValues: _arrValues,
        _mapControlsDiv: _mapControlsDiv,
        _lstCharLabels: _lstCharLabels,
        _mapElement: _mapElement,
      };
      return obj;
    },

    updateSelectedIndicator: function (newIndicatorName, newIndicatorId) {
      //Set current Indicator.
      _strSelectedIndicator = newIndicatorName;
      _strSelectedIndicatorCode = newIndicatorId
        ? newIndicatorId
        : _strSelectedIndicatorCode;
      _strInfoIndicatorId = newIndicatorId
        ? newIndicatorId
        : _strSelectedIndicatorCode;

      //Set the Indicator Text.
      $('#indicatorName').text(_strSelectedIndicator);
      $('#indicatorName').attr('title', _strSelectedIndicatorCode);
      updateIndicatorName();
      $('#lstIndicators').indicatorselectmenu('refresh');
    },

    updateInfoIndicator: function (newIndicatorName, newIndicatorId) {
      //If not indicator is defined, set the info indicator
      //to the currently selected indicator.
      _strInfoIndicator = newIndicatorName
        ? newIndicatorName
        : _strInfoIndicator;
      _strInfoIndicatorId = newIndicatorId
        ? newIndicatorId
        : _strInfoIndicatorId;
    },

    updateByVariableLabel: function (newByVariableLabel) {
      console.error('This function has been removed.');
      ///////			// array_pluck is in nameValueLib..js
      ///////			var just_names = nameValueLib.array_pluck(_arrSortedIndicators, 'name');
      ///////			for(var i in just_names){
      ///////// 				var objByVariable = nameValueLib.getObject(_arrSortedByVariableLabels, [just_names[i]]);
      ///////				var objByVariable = byVariableState.get([just_names[i]]);
      ///////				if(objByVariable){
      ///////  				//Set Current to new By Variable Label.
      ///////  					objByVariable.current = newByVariableLabel;
      ///////
      ////////*
      ///////  				if(typeof newByVariableLabel === 'string'){
      ///////  					objByVariable.alias = [];
      ///////  					objByVariable.current = newByVariableLabel;
      ///////  				}
      ///////  				else{
      ///////  					objByVariable.alias = newByVariableLabel;
      ///////  				}
      ///////*/
      ///////				}
      ///////			}
      ///////
    },

    resetDisplay: function () {
      _resetDisplay();
    },

    resetButtons: function () {
      _resetButtons();
    },
    getSelectedCountryCodes: function () {
      return _getSelectedCountryCodes();
    },
    setUnselectedCountries: function (data) {
      _currArrSelectedCountries = data;
    },
    getUnSelectedCountries: function () {
      return _currArrSelectedCountries;
    },
    getCurrUnSelectedCountries: function () {
      return _arrUnSelectedCountries;
    },
    getNationalMapValues: function () {
      return _arrNationalMapValues;
    },
    getTest: function () {
      return _strSelectedIndicator;
    },
    updateNationalMapValues: function (data) {
      _arrNationalMapValues = data;
    },
    getNationalAllMapData: function () {
      return _arrNationalAllMapData;
    },
    getSubnationalMapData: function () {
      return _arrSubnationalAllMapData;
    },
    getSubnationalCIData: function () {
      return _arrSubnationalAllMapCIData;
    },
    getSubnationalMapValues: function () {
      return _arrSubnationalMapValues;
    },
    getNationalAllMapCIData: function () {
      return _arrNationalAllMapCIData;
    },
    updateSubnationalMapCIData: function (data) {
      _arrSubnationalMapCIData = data;
    },
    updateSubnationalMapValues: function (data) {
      _arrSubnationalMapValues = data;
    },
    updateSubnationalMapData: function (data) {
      _arrSubnationalMapData = data;
    },
    updateNationalMapCIData: function (data) {
      _arrNationalMapCIData = data;
    },

    updateNationalMapData: function (newArrNationalAllMapData) {
      _arrNationalMapData = {};
      _arrNationalMapData = newArrNationalAllMapData;
    },

    /**
     * @fn getCurrentDisplayType
     * @brief 	Obtains the current display type.
     * @details	Provides the current display type.
     * @return 	a string representig the current display type.
     */
    getCurrentDisplayType: function () {
      return _curDisplayType;
    },
    setCurrentDisplayType: function (currDisplay) {
      _curDisplayType = currDisplay;
    },

    /**
     * @fn getCurrentSurveySelection
     * @brief 	Obtains the current survey selection.
     * @details	Provides the current survey selection.
     * @return 	a string representig the current survey selection.
     */
    getCurrentSurveySelection: function () {
      return _curSurveySelection;
    },

    /**
     * @fn toggleGridLines
     * @brief 	toggles the grid lines for charts
     * @details	Turn on/off chart grid lines.
     * @return 	void
     */
    toggleGridLines: function () {
      //Declare Important Variables.
      var chart = $(_highChartsElement).highcharts();

      //Toggle the Boolean.
      _bHighChartsGridEnabled = !_bHighChartsGridEnabled;
      var lineWidth = _bHighChartsGridEnabled ? 1 : 0;

      //Go through each series and enable/disable the gridlines.
      $.each(chart.yAxis, function (index, ser) {
        ser.update({
          gridLineWidth: lineWidth,
        });
      });

      //Return the current status of the item.
      return _bHighChartsGridEnabled;
    },
    /**initializeDashboard√
     * @fn toggleYAxisLabel
     * @brief 	toggles the Y Axis label.
     * @details	Turn on/off displaying all the labels on the Y Axis.
     * @return 	void
     */
    toggleYAxisLabel: function () {
      //Declare Important Variables.
      var chart = $(_highChartsElement).highcharts();

      //Toggle the Boolean.
      _bHighChartsYAxisLabelEnabled = !_bHighChartsYAxisLabelEnabled;

      //Go through each series and enable/disable the label.
      $.each(chart.yAxis, function (index, ser) {
        ser.update({
          labels: {
            enabled: _bHighChartsYAxisLabelEnabled,
          },
        });
      });

      //Return the current status of the item.
      return _bHighChartsYAxisLabelEnabled;
    },
    /**
     * @fn toggleLegend
     * @brief 	toggles the legend for the chart.
     * @details	Turn on/off displaying the legend.
     * @return 	boolean determining which way to toggle the checkbox.
     */
    toggleLegend: function () {
      //Declare Important Variables.
      var chart = $(_highChartsElement).highcharts();
      var newBarWidth;

      //Toggle the Boolean.
      _bHighChartsLegendEnabled = !_bHighChartsLegendEnabled;

      //Go through each series and enable/disable the label.
      //hereitis
      $.each(chart.series, function (index, ser) {
        if (ser.type !== 'arearange' && ser.type !== 'columnrange') {
          if (ser.barW > _maxBarWidth) {
            newBarWidth = _maxBarWidth;
          } else {
            newBarWidth = ser.barW;
          }

          if (ser.name.indexOf('_CI') > -1) {
            ser.visible = false;
          }

          var visible = ser.visible ? _bHighChartsLegendEnabled : ser.visible;
          ser.update({
            showInLegend: visible,
            pointWidth: newBarWidth,
          });
        }
      });

      //Return the current status of the item.
      return _bHighChartsLegendEnabled;
    },
    /**
     * @fn toggleYToMaxPercent
     * @brief 	Toggles the Y-Axis 100% on the charts
     * @details	If the indicator is a percentage, changes the Y-Axis to be
     *			based on 100% or the actual max value.
     * @return 	boolean determining which way to toggle the checkbox.
     */
    toggleYToMaxPercent: function () {
      //Declare Important Variables.
      var chart = $(_highChartsElement).highcharts();
      var yAxisMax = _nHighChartsMaxYValue;

      //Toggle the Boolean.
      _bHighChartsYAxisToMaxEnabled = !_bHighChartsYAxisToMaxEnabled;

      //Obtain precision for current indicator.
      var strPrecision = nameValueLib.getValueEX(_arrPrecision, [
        _strSelectedIndicatorCode,
      ]);

      //If the Y-Axis is enabled for 100, set max to 100.
      if (_bHighChartsYAxisToMaxEnabled) {
        //Set Max Axis to 100.
        yAxisMax = 100;
      }

      //Calculate Tick Interval for Y Axis based on 6 splits.
      var yInterval = (yAxisMax - _nHighChartsMinYValue) / 6;
      yInterval = parseFloat(yInterval.toFixed(strPrecision));
      if (yInterval == 0) {
        yInterval = 0.1;
      } else if (yInterval > 1) {
        yInterval = null;
      }

      //Set tick interval.
      chart.yAxis[0].options.tickInterval = yInterval;

      //Set flag to dirty for redraw
      chart.yAxis[0].isDirty = true;

      //Set Extremes.
      chart.yAxis[0].setExtremes(_nHighChartsMinYValue, yAxisMax);

      //Return the current status of the item.
      return _bHighChartsYAxisToMaxEnabled;
    },
    /**
     * @fn toggleDataPoints
     * @brief 	toggles the data points for the chart.
     * @details	Turn on/off displaying the data points.
     * @return 	void
     */
    toggleDataPoints: function () {
      //Declare Important Variables.
      var newBarWidth;
      var chart = $(_highChartsElement).highcharts();

      //Toggle the Boolean.
      _bHighChartsDataPointsEnabled = !_bHighChartsDataPointsEnabled;

      //Go through each series and enable/disable the label.
      $.each(chart.series, function (index, ser) {
        if (ser.type != 'arearange' && ser.type != 'columnrange') {
          //Make sure we do not update the bar width from the maximum.
          if (ser.barW > _maxBarWidth) {
            newBarWidth = _maxBarWidth;
          } else {
            newBarWidth = ser.barW;
          }

          ser.update({
            dataLabels: {
              enabled: _bHighChartsDataPointsEnabled,
            },
            pointWidth: newBarWidth,
          });
        }
      });

      //Return the current status of the item.
      return _bHighChartsDataPointsEnabled;
    },
    /**
     * @fn toggleConfidenceIntervals
     * @brief 	toggles the confidence intervals for the chart.
     * @details	Turn on/off displaying the confidence intervals.
     * @return 	Confidence intervals visibility status
     */
    toggleConfidenceIntervals: function () {
      //Declare Important Variables.
      var chart = $(_highChartsElement).highcharts();

      //Toggle the Boolean.
      _bHighChartsConfidenceIntervalsVisible =
        !_bHighChartsConfidenceIntervalsVisible;

      // Go through each series, check if it is a Confidence Interval series by the "_CI" suffix.
      // If it is a CI series, toggle visibility
      $.each(chart.series, function (index, ser) {
        if (ser.name.indexOf('_CI') > -1) {
          ser.update({
            visible: !ser.visible,
          });
        }
      });

      //Return the current status of the item.
      return _bHighChartsConfidenceIntervalsVisible;
    },
    /**
     * @fn displayCustomSurvey
     * @brief 	updates the data to only use the year specified
     * @details If that survey year for a certain country is not present, data is used for the next most recent survey.
     * @param 	surveyYear: An integer specifying the year to use.
     * @param 	onUpdate: 	True if the process is being called from within updateDashboard. Only happens when you add new data
     *						to existing data.
     * @return 	void
     */
    displayCustomSurvey: function (surveyYear, onUpdate) {
      //Declare Important Variables.
      var strSelectedSurvey = '';

      //Reset Selected Survey Array.
      _arrCustomSurveySelections = [];

      //Go through each country/survey to disable all but the requested survey.
      $.each(_arrSortedCountriesSurveys, function (countryIndex, objCountry) {
        //If the country is selected.
        if (_arrUnSelectedCountries.indexOf(objCountry.name) == -1) {
          var bSurveySelected = false;
          $.each(objCountry.value, function (surveyIndex, objSurvey) {
            //Select the survey if the year is equal or the first survey
            //year greater than the survey year specified.
            // NOTE: Taking into account enabled countries only.
            if (!bSurveySelected && objSurvey.alias >= surveyYear) {
              objSurvey.value = true;
              bSurveySelected = true;
              strSelectedSurvey = objSurvey.name;
            } else {
              objSurvey.value = false;
            }
          });

          //If nothing was selected, select the last survey only if the country is selected.
          if (!bSurveySelected) {
            var objLastSurvey = objCountry.value[objCountry.value.length - 1];
            objLastSurvey.value = true;
            strSelectedSurvey = objLastSurvey.name;
          }

          //Add Select Survey for the country into custom survey.
          var newObj = nameValueLib.createObject(
            objCountry.name,
            '',
            strSelectedSurvey,
            false
          );
          _arrCustomSurveySelections.push(newObj);
        }
      });

      //Set Survey Selection Variable.
      _curSurveySelection = statCompilerDashboard.SURVEY_SELECTION.Custom;

      //Update Dashboard, if the function was not called from within updateDashboard.
      if (typeof onUpdate == 'undefined' || onUpdate == false) {
        statCompilerDashboard.updateDashboard(null, false);
      }
    },

    displayCustomSurveySelector: function (
      arrUnselectedCountrySurveys,
      onUpdate
    ) {
      //Declare Important Variables.
      var arrUnselectedSurveyYears = [];

      //Reset Selected Survey Array.
      _arrCustomSurveySelections = [];
      _arrCustomSurveySelectionsMap = [];
      var indexCount = 0;

      //Go through each country survey, and set unselected surveys to false.
      for (
        var nCountryIndex = 0;
        nCountryIndex < _arrSortedCountriesSurveys.length;
        nCountryIndex++
      ) {
        // If the country has not been deactivated on the right side panel, continue
        if (
          _.indexOf(
            statCompilerDashboard.getCurrUnSelectedCountries(),
            _arrSortedCountriesSurveys[nCountryIndex].name
          ) == -1
        ) {
          //Get all the surveys for the particular country.
          var arrAllSurveys = _arrSortedCountriesSurveys[nCountryIndex].value;

          //Get all the unselected surveys for the particular country.
          arrUnselectedSurveyYears = nameValueLib.getValueEX(
            arrUnselectedCountrySurveys,
            [_arrSortedCountriesSurveys[nCountryIndex].alias]
          );
          if (arrUnselectedSurveyYears == null) {
            arrUnselectedSurveyYears = [];
          }

          //Create a new Object to store the latest selected survey.
          var objLatestSurvey = {};

          //For each survey, determine if it is unselected.
          for (
            var nSurveyIndex = 0;
            nSurveyIndex < arrAllSurveys.length;
            nSurveyIndex++
          ) {
            //Get the particular survey object.
            var objSurvey = arrAllSurveys[nSurveyIndex];

            //If survey is in unselected list, mark it disabled, otherwise enable it.
            if (arrUnselectedSurveyYears.indexOf(objSurvey.alias) != -1) {
              objSurvey.value = false;
            } else {
              objSurvey.value = true;
              //Setup the custom survey for map.
              objLatestSurvey = nameValueLib.createObject(
                _arrSortedCountriesSurveys[nCountryIndex].name,
                objSurvey.alias,
                objSurvey.name
              );
            }

            //Add the latest survey for the country to custom surveys for the Map View.
            _arrCustomSurveySelectionsMap.push(objLatestSurvey);

            indexCount++;
          }
        }
      }

      //Assign the unselected surveys to the custom surveys selection.
      _arrCustomSurveySelections = arrUnselectedCountrySurveys;

      //Set Survey Selection Variable.
      _curSurveySelection = statCompilerDashboard.SURVEY_SELECTION.Custom;

      // Update the Dashboard, second arg is false if the function was not called from within updateDashboard.
      if (typeof onUpdate == 'undefined' || onUpdate == false) {
        statCompilerDashboard.updateDashboard(null, true);
      }
    },
    /**
		 * @fn displayCustomSurveyRange
		 * @brief 	updates the data to only use the year range specified
		 * @details
		 * @param 	min: An integer specifying the min year to use.
		 			max: An integer specifying the max year to use.
		 * @param 	onUpdate: 	True if the process is being called from within updateDashboard. Only happens when you add new data
		 *						to existing data.
		 * @return 	void
		 */
    displayCustomSurveyRange: function (min, max, onUpdate) {
      //Declare Important Variables.
      var strSelectedSurvey = '';

      //Reset Selected Survey Array.
      _arrCustomSurveySelections = [];

      //Go through each country/survey to disable all but the requested survey.
      for (
        var nCountryIndex = 0;
        nCountryIndex < _arrSortedCountriesSurveys.length;
        nCountryIndex++
      ) {
        //Obtain country Object.
        var objCountry = _arrSortedCountriesSurveys[nCountryIndex];

        //For each country, loop through the surveys.
        for (
          var nSurveyIndex = 0;
          nSurveyIndex < objCountry.value.length;
          nSurveyIndex++
        ) {
          //Get Survey Object.
          var objSurvey = objCountry.value[nSurveyIndex];

          //Select the survey if the year is greater than or equal to the min year OR
          //less than or equal to the maxYear.
          if (objSurvey.alias >= min && objSurvey.alias <= max) {
            objSurvey.value = true;
            strSelectedSurvey = objSurvey.name;
          } else {
            objSurvey.value = false;
          }
        } //END for(var nSurveyIndex = 0...

        //Add Select Survey for the country into custom survey.
        var newObj = nameValueLib.createObject(
          objCountry.name,
          '',
          strSelectedSurvey,
          false
        );
        _arrCustomSurveySelections.push(newObj);
      } //END for(var nCountryIndex = 0...

      //Set Survey Selection Variable.
      _curSurveySelection = statCompilerDashboard.SURVEY_SELECTION.Custom;

      //Set Current Survey Year.
      _strCurYearRange['min'] = min;
      _strCurYearRange['max'] = max;

      //Update Dashboard, if the function was not called from within updateDashboard.
      if (typeof onUpdate == 'undefined' || onUpdate == false) {
        statCompilerDashboard.updateDashboard(null, false);
      }
    },
    /**
     * @fn displayRecentSurveys
     * @brief 	updates the data to only used recent surveys.
     * @details
     * @param 	onUpdate: 	True if the process is being called from within updateDashboard. Only happens when you add new data
     *						to existing data.
     * @return 	void
     */
    displayRecentSurveys: function (onUpdate, value) {
      //Get all the selected countries.
      arrSelectedCountries = _getSelectedCountryCodes();

      //Go through each country/survey to disable all but the last survey.
      $.each(_arrSortedCountriesSurveys, function (countryIndex, objCountry) {
        //Make sure the country is selected to begin with.
        var bCountrySelected = nameValueLib.getValue(arrSelectedCountries, [
          objCountry.alias,
        ]);
        if (bCountrySelected) {
          //Obtain the index of the last survey for that country.
          var nMostRecentSurveyIndex =
            objCountry.value.length > 1
              ? objCountry.value.length - value
              : objCountry.value.length - 1;

          //Select the last survey in the list.
          objCountry.value[nMostRecentSurveyIndex].value = true;
          if (objCountry.value.length > 1 && value > 1) {
            objCountry.value[nMostRecentSurveyIndex + 1].value = true;
          }
          //Disable all the other surveys.
          for (var nIndex = 0; nIndex < nMostRecentSurveyIndex; nIndex++) {
            objCountry.value[nIndex].value = false;
          }
        }
      });

      //Set Survey Selection Variable.
      _curSurveySelection = statCompilerDashboard.SURVEY_SELECTION.Recent;

      //Update Dashboard, if the function was not called from within updateDashboard.
      if (typeof onUpdate == 'undefined' || onUpdate == false) {
        statCompilerDashboard.updateDashboard(null, true);
      }
    },
    /**
     * @fn displayAllSurveys
     * @brief 	updates the data to use all surveys.
     * @details
     * @param 	onUpdate: 	True if the process is being called from within updateDashboard. Only happens when you add new data
     *						to existing data.
     * @return 	void
     */
    displayAllSurveys: function (onUpdate, displayType) {
      if (displayType) {
        _curDisplayType = displayType;
      }
      //Declare Important Variables.
      var arrSelectedCountries = [];

      //Get all the selected countries.
      arrSelectedCountries = _getSelectedCountryCodes();

      //Go through each country/survey to display all surveys
      $.each(_arrSortedCountriesSurveys, function (countryIndex, objCountry) {
        //If a country is selected, then enable all surveys.
        var bCountrySelected = nameValueLib.getValue(arrSelectedCountries, [
          objCountry.alias,
        ]);
        if (bCountrySelected) {
          $.each(objCountry.value, function (surveyIndex, objSurvey) {
            objSurvey.value = true;
          });
        }
      });

      //Set Current Survey Year to min max survey range
      _strCurYearRange['min'] = _objSurveyRange.min;
      _strCurYearRange['max'] = _objSurveyRange.max;

      //Set Survey Selection Variable.
      _curSurveySelection = statCompilerDashboard.SURVEY_SELECTION.All;

      //Update Dashboard, if the function was not called from within updateDashboard.
      if (typeof onUpdate == 'undefined' || onUpdate == false) {
        statCompilerDashboard.updateDashboard(null, true);
      }
    },
    /**
     * @fn getBookmark
     * @brief 	Obtains a bookmark for the current App state.
     * @details
     * @return 	void
     */
    getBookmark: function () {
      return _getBookmark();
    },
    getSelectedIndicatorDropdown: function () {
      return _selectedIndicatorDropdown;
    },
    setSelectedIndicatorDropdown: function (data) {
      _selectedIndicatorDropdown = data;
    },
    pushSelectedIndicatorDropdown: function (data) {
      if (_.indexOf(_selectedIndicatorDropdown, data) === -1) {
        _selectedIndicatorDropdown.push(data);
      }
    },
    pullSelectedIndicatorDropdown: function (data) {
      _selectedIndicatorDropdown = _.pull(_selectedIndicatorDropdown, data);
    },
    mergeSelectedIndidcatorDropdown: function (arr2) {
      _selectedIndicatorDropdown = _selectedIndicatorDropdown.concat(arr2);
    },
    resetSelectedIndicatorDropdown: function () {
      _selectedIndicatorDropdown = [];
    },
    getSortedCountriesSurvey: function () {
      return _arrSortedCountriesSurveys.slice(0);
    },

    /**
     * @fn getSurveyRange
     * @brief Obtains an object that specifies the minimum and the maximum year between all surveys
     * @details
     * @return 	Object {min: , max: }
     */
    getSurveyRange: function () {
      return _objSurveyRange;
    },

    toTitleCase: function (name) {
      return _toTitleCase(name);
    },

    getArrMapData: function () {
      return _arrNationalMapData;
    },

    getSelectedIndicator: function () {
      return _strSelectedIndicator;
    },

    getSelectedIndicatorCode: function () {
      return _strSelectedIndicatorCode;
    },

    getArrSortedIndicators: function () {
      return _arrSortedIndicators;
    },
    /**
     * @fn getIndicatorMetaData
     * @brief 	Obtains the meta data for the current indicator.
     * @details
     * @return 	An object containing the meta data.
     */
    getIndicatorMetaData: function () {
      //Get the correct meta data from the Meta Data Array.

      var objMetaData = nameValueLib.getValueEX(arrIndicatorMetaData, [
        _strInfoIndicatorId,
      ]);

      //Return the Meta Data Object.
      return objMetaData;
    },
    /**
     * @fn exportChartAsPDF
     * @brief 	Exports the chart as a PDF document.
     * @details Calls the highcharts functionality to export the chart.
     */
    exportChartAsPDF: function () {
      console.warn('This function, "exportChartAsPDF", has been removed');
    },
    /**
     * @fn exportChartAsJPG
     * @brief 	Exports the chart as a JPG Image.
     * @details Calls the highcharts functionality to export the chart.
     */
    exportChartAsJPG: function () {
      //Obtain the chart from highcharts.
      var chart = $(_highChartsElement).highcharts();

      if (typeof chart != 'undefined') {
        chart.exportChart(
          {
            type: 'image/jpeg',
            filename: _strSelectedIndicator,
            sourceWidth: 2000,
            sourceHeight: chart.chartHeight + 100,
            scale: 2,
          },
          {
            chart: {
              style: {
                fontFamily: 'Arial, Helvetica, sans-serif', // default font
                fontSize: '12px',
              },
            },
          }
        );
      }
    },
    /**
     * @fn printChart
     * @brief 	Prints the chart to a local printer.
     * @details Calls the highcharts functionality to print the chart.
     */
    printChart: function () {
      //Obtain the chart from highcharts.
      var chart = $(_highChartsElement).highcharts();
      chart.exporting = { printWidth: chart.chartWidth };

      if (typeof chart != 'undefined') {
        // $(_highChartsElement).css("transform", "rotate(90deg)")
        // setTimeout(function(){
        chart.print();
        //},500)

        //$(_highChartsElement).css("transform", "rotate(0deg)")
      }
    },
    /**
     * @fn exportDataAsCSV
     * @brief 	Saves the table data as CSV.
     * @details Saves the charts in a format.
     */
    exportDataAsTableCSV: function () {
      //Declare Important Variables.
      var strInitialJSON = '';
      var strFinalJSON = '';

      //Convert data to JSON.
      var options = { exptype: 'jsonstring', root: 'data' };
      var strInitialJSON = $(_gridElement).jqGrid('jqGridExport', options);

      // sanitizeAndParseJQgridJSONforExcelExport is found in helpers.js
      var objJSON = sanitizeAndParseJQgridJSONforExcelExport(strInitialJSON);

      // remove hidden columns
      var col_names = _arrColNames.filter(function (i) {
        return i != 'CharLabelID';
      });
      var col_model_names = _arrColModelNames.filter(function (i) {
        return i != 'CharLabelID';
      });
      // remove 'CI low' andn 'CI high' if empty

      //Export Data to Excel as Table.
      excelExport.exportToExcelAsTable(
        _arrGroupHeadersLevel1,
        _arrGroupHeadersLevel2,
        _arrGroupHeadersLevel3,
        col_names,
        col_model_names,
        objJSON.data.data,
        _arrGroupHeadersLevel1[0].startColumnName
      );
    },

    /**
     * @fn printChartAsPDF
     * @brief 	Saves the chart as PDF.
     * @details Saves the charts in a format.
     */

    exportPreview: function (exportType) {
      _strExportType = exportType;

      var citation =
        'ICF, 2015. The DHS Program STATcompiler. Funded by USAID. http://www.statcompiler.com. ' +
        _arrMonthNames[_date.getMonth()] +
        ' ' +
        _date.getDate() +
        ' ' +
        _date.getFullYear();

      var chart = $(_highChartsElement).highcharts();

      $('#svg-container').removeClass('hidden');
      //$("#canvas").removeClass("hidden")

      $('#charts svg');

      var tempSvg = $('#charts svg').parent().html();
      var chartSvgElement = $('#charts svg');
      var chartHeight = chartSvgElement.attr('height');
      var chartWidth = chartSvgElement.attr('width');

      var viewbox = '0 0 ' + chartHeight * 1 + ' ' + chartWidth * 1;
      var indicatorMetaData = nameValueLib.getValueEX(arrIndicatorMetaData, [
        _strSelectedIndicatorCode,
      ]);

      var arrAllByVariable = byVariableState.get(_strSelectedIndicatorCode, []);
      if (arrAllByVariable.current) {
        var selectedByVariable = arrAllByVariable.current;
      } else {
        var selectedByVariable = '';
      }

      // 		 If there isn't one, add an empty string instead. This way the layout height will remain consistent.
      if (indicatorMetaData) {
        var definition = indicatorMetaData.Definition.split('');
        var defString = '<tspan>';
        var cutString = false;
        for (var i = 0; i < definition.length; i++) {
          if (i != definition.length - 1) {
            if (i % 120 === 0 && i != 0) {
              cutString = true;
            }

            if (cutString) {
              if (definition[i] === ' ') {
                defString +=
                  definition[i] +
                  "</tspan><tspan x='" +
                  chartWidth / 2 +
                  "' dy='20'>";
                cutString = false;
              } else {
                defString += definition[i];
              }
            } else {
              defString += definition[i];
            }
          } else {
            defString += definition[i] + '</tspan>';
          }
        }

        // add byvariable selected here
        defString +=
          '<tspan x=' +
          chartWidth / 2 +
          " dy='20'>" +
          selectedByVariable +
          '</tspan>';

        $('#svgInnerContainer').html(tempSvg);
        $('#svgInnerContainer .highcharts-tooltip').remove();
        $('#svgInnerContainer svg > g').attr('transform', 'translate(0, 50)');

        if ($('#svgInnerContainer svg .highcharts-legend').length > 0) {
          $('#svgInnerContainer svg .highcharts-legend').after(
            "<g class='citation' transform=translate(" +
              (parseInt(chartWidth) - 280) +
              ',' +
              (parseInt(chartHeight) + 55) +
              ") zIndex='40'><text style='font-size:8px' x='0' y='0' text-anchor='middle'>" +
              citation +
              '</text>></g>'
          );
        } else {
          $('#svgInnerContainer svg .highcharts-axis-labels').after(
            "<g class='citation' transform=translate(" +
              (parseInt(chartWidth) - 280) +
              ',' +
              (parseInt(chartHeight) + 55) +
              ") zIndex='40' ><text style='font-size:8px' x='0' y='0' text-anchor='middle'>" +
              citation +
              '</text>></g>'
          );
        }

        chartSvgElement.attr('height');

        if (exportType === 'PNG') {
          $('#titleDescriptionPreview').addClass('hidden');
          $('#svgInnerContainer svg > rect').after(
            "<g class='description' zIndex='40' ><text style='font-size: 12px;' x='" +
              chartWidth / 2 +
              "' y='50' text-anchor='middle'>" +
              defString +
              '</text></g>'
          );
          $('#svgInnerContainer svg > rect').after(
            "<g class='title' zIndex='40' ><text style='font-family:GillSansRegular, sans-serif; font-size: 20px' x='" +
              chartWidth / 2 +
              "' y='30' text-anchor='middle'>" +
              _strSelectedIndicator +
              '</text></g>'
          );
        } else {
          $('#titleDescriptionPreview').removeClass('hidden');
          $('#titlePDFChart').html(indicatorMetaData.Indicator);
          $('#descriptionPDFChart').html(
            indicatorMetaData.Definition.split('')
          );
          $('#descriptionPDFChart').append('<br>' + selectedByVariable);
        }

        var isFirefox =
          navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        var html = $('#svgInnerContainer').html();
        $('#svgInnerContainer').html(html);

        var multiplyer = isFirefox ? 1 : 3;

        $('#svgInnerContainer svg').attr('viewBox', viewbox);
        $('#svgInnerContainer svg').attr('preserveAspectRatio', 'meet');
        $('#svgInnerContainer svg').attr('width', chartWidth * multiplyer);
        $('#svgInnerContainer svg').attr(
          'height',
          chartHeight * multiplyer + 200
        );
        $('#svgInnerContainer svg').attr(
          'transform',
          'translate(0, 0) scale(' + 1 + ' ' + 1 + ')'
        );
        $('#svgInnerContainer svg .highcharts-legend text').css(
          'fontFamily',
          "'GillSansRegular', sans-serif !important"
        );
        $('#svgInnerContainer svg .highcharts-tooltip').css('display', 'none');

        var transform = $('#svgInnerContainer svg .highcharts-legend').attr(
          'transform'
        );
        var rectWidth = $('#svgInnerContainer svg > rect').attr('width');
        var rectHeight =
          parseInt($('#svgInnerContainer svg > rect').attr('height')) + 60;
        $('#svgInnerContainer').css('width', rectWidth);
        $('#titleDescriptionPreview').css('width', rectWidth);
        $('#titleDescriptionPreview').css(
          'margin',
          '0 0 0 -' + parseInt(rectWidth) / 2 + 'px'
        );
        $('#svgInnerContainer').css('height', rectHeight + 'px');

        var dataLabelFontSize = parseInt(
          $($('#svgInnerContainer svg .highcharts-data-labels text tspan')[0])
            .css('fontSize')
            .split('px')[0]
        );
        setTimeout(function () {
          $('#titleFontSize').labeledslider('value', 20);

          var xaxisLablesFontSize = parseInt(
            $($('#svgInnerContainer svg .highcharts-axis-labels text')[0])
              .css('fontSize')
              .split('px')[0]
          );

          $('#xAxisLabelFontSize').labeledslider('value', xaxisLablesFontSize);
          var legendLablesFontSize = 0;

          if ($('#svgInnerContainer svg .highcharts-legend').length > 0) {
            legendLablesFontSize = parseInt(
              $($('#svgInnerContainer svg .highcharts-legend text')[0])
                .css('fontSize')
                .split('px')[0]
            );
            $('#legendFontSize').labeledslider('value', legendLablesFontSize);

            var xTransform =
              rectWidth / 2 -
              $(
                '#svgInnerContainer svg .highcharts-legend'
              )[0].getBoundingClientRect().width /
                2;
            xTransform = xTransform < 0 ? 0 : xTransform;

            $('#svgInnerContainer svg .highcharts-legend').attr(
              'transform',
              'translate(' +
                xTransform +
                ',' +
                (rectHeight - 45) +
                ') scale(1 1)'
            );
          }

          $('#svgInnerContainer svg > rect').attr('height', rectHeight);
          var dash = parseInt(chartWidth) + parseInt(rectHeight) * 2;
          $('#svgInnerContainer svg > rect').attr(
            'stroke-dasharray',
            '0,' + chartWidth + ',' + dash
          );
          chartHeight = parseInt(chartHeight) + 50;
          $('#labelFontSize').labeledslider(
            'value',
            Math.round(dataLabelFontSize)
          );
          $('#svgInnerContainer .highcharts-data-labels text').attr(
            'x',
            -dataLabelFontSize + 20
          );
          $(
            '#svgInnerContainer .highcharts-xaxis-labels text tspan:not(first-child)'
          ).attr('dy', xaxisLablesFontSize);
        }, 500);
      }
    },

    exportChartFromSVG: function () {
      var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
      var multiplyer = isFirefox ? 1 : 3;
      $('#svgInnerContainer svg').attr(
        'transform',
        'translate(0, 0) scale(' + multiplyer + ' ' + multiplyer + ')'
      );
      var svgC = $('#svgInnerContainer');
      var svg = $('#svgInnerContainer svg').parent().html();
      var svgItem = $('#svgInnerContainer svg');
      var sAgent = window.navigator.userAgent;

      canvg('canvas', svg);

      canvas = document.getElementById('canvas');

      context = canvas.getContext('2d');

      context.scale(1, 1);

      img_PNG = canvas.toDataURL();

      if (_strExportType === 'PNG') {
        canvas.toBlob(function (blob) {
          if (sAgent.indexOf('MSIE') === -1) {
            saveAs(blob, _strSelectedIndicator + '.png');
          } else {
            window.navigator.msSaveOrOpenBlob(
              blob,
              _strSelectedIndicator + '.png'
            );
          }
        });
      } else {
        var indicatorMetatData = nameValueLib.getValueEX(arrIndicatorMetaData, [
          _strSelectedIndicatorCode,
        ]);

        $('.chart').html(img_PNG);
        var doc = new PDFDocument();
        var stream = doc.pipe(blobStream());

        var headerSize =
          $('#titleFontSize').data().uiLabeledslider.options.value;
        doc
          .fontSize(headerSize)
          .text(_strSelectedIndicator, { align: 'center' });
        doc
          .fontSize(12)
          .text(indicatorMetatData.Definition, { align: 'center' });
        doc.image(img_PNG, 30, headerSize * 9, { fit: [540, 420] });
        // end and display the document in the iframe to the right
        doc.end();

        stream.on('finish', function () {
          // download file instead. As of 20171108 Chrome data URLs of this length do not work. --SB
          saveAs(
            stream.toBlob('application/pdf'),
            _strSelectedIndicator + '.pdf'
          );
          /*

					var fileRead = new FileReader();
				 	fileRead.onload = function(e) {

						window.open(e.currentTarget.result)
					}
				 	fileRead.readAsDataURL(stream.toBlob('application/pdf'));
*/
        });
      }

      $('#svg-container').addClass('hidden');
    },
    startTour: function () {
      var currLang = Config.getLanguage();

      introjs = introJs();
      introjs._options.skipLabel = Config.getUniversalString('introClose');
      introjs._options.nextLabel = Config.getUniversalString('introNext');
      introjs._options.prevLabel = Config.getUniversalString('introPrev');

      introjs
        .setOptions({
          showBullets: 'false',
          showStepNumbers: 'false',
          overlayOpacity: 0,
          hidePrev: true,
          hideNext: true,
          exitOnEsc: false,
          // "doneLabel": Config.getUniversalString("iUnderstand"),
          // showSkipButton: true,
          steps: [
            {
              element: document.querySelector('#countriesButton'),
              intro: Config.getGuidedHelpString('mainPageTour1'),
              tooltipClass: 'languageIntroJSFr',
            },
          ],
        })
        .start();

      // Adding a checkbox
      var introHide = Config.getUniversalString('introHide');

      if ($('#exit').length == 0) {
        $('.introjs-tooltip').append('<div id="exit" class="exit">x</div>');
      }

      $('#exit').click(function () {
        introJs().exit();
      });

      $('#countriesButton').click(function () {
        introJs().exit();
      });
    },
    setGuidedHelpCookies: function () {
      _currDisplay = statCompilerDashboard.getCurrentDisplayType();
      switch (_currDisplay) {
        case 'Grid':
          localStorage.setItem('startedTour_grid', true);
          localStorage.setItem('startedGuidedHelp', true);
          break;
        case 'Map':
          localStorage.setItem('startedTour_map', true);
          localStorage.setItem('startedGuidedHelp', true);
          break;
        case 'Line':
          localStorage.setItem('startedTour_line', true);
          localStorage.setItem('startedGuidedHelp', true);
          break;
        case 'Column':
          localStorage.setItem('startedTour_col', true);
          localStorage.setItem('startedGuidedHelp', true);
          break;
      }
      statCompilerDashboard.startTourGrid();
      localStorage.setItem('startedGuidedHelp', false);
    },
    startTourGrid: function () {
      _currDisplay = statCompilerDashboard.getCurrentDisplayType();
      if (
        _currDisplay == 'Column' &&
        localStorage.getItem('startedGuidedHelp') === 'true' &&
        localStorage.getItem('startedTour_col') === 'true'
      ) {
        statCompilerDashboard.startTourCol();
        localStorage.setItem('startedTour_col', false);
      } else if (
        _currDisplay == 'Line' &&
        localStorage.getItem('startedGuidedHelp') === 'true' &&
        localStorage.getItem('startedTour_line') === 'true'
      ) {
        statCompilerDashboard.startTourLine();
        localStorage.setItem('startedTour_line', false);
      } else if (
        _currDisplay == 'Map' &&
        localStorage.getItem('startedGuidedHelp') === 'true' &&
        localStorage.getItem('startedTour_map') === 'true'
      ) {
        statCompilerDashboard.startTourMap();
        localStorage.setItem('startedTour_map', false);
      } else if (
        localStorage.getItem('startedGuidedHelp') === 'true' &&
        localStorage.getItem('startedTour_grid') === 'true'
      ) {
        localStorage.setItem('startedTour_grid', false);
        var currLang = Config.getLanguage();
        introjsInd = introJs();
        introjsInd._options.skipLabel = Config.getUniversalString('introClose');
        introjsInd._options.nextLabel = Config.getUniversalString('introNext');
        introjsInd._options.prevLabel = Config.getUniversalString('introPrev');
        $('.introjs-overlay').remove();

        introjsInd
          .setOptions({
            showBullets: 'false',
            showStepNumbers: 'false',
            overlayOpacity: 0,
            exitOnEsc: false,
            hideNext: true,
            doneLabel: Config.getUniversalString('iUnderstand'),
            showSkipButton: true,
            steps: [
              {
                element: document.querySelector('.indicatorsPanelHeader'),
                intro: Config.getGuidedHelpString('gridTour1'),
                position: 'left',
                tooltipClass: 'introJSindex',
              },
              {
                element: document.querySelector('.countriesPanel'),
                intro: Config.getGuidedHelpString('gridTour10'),
                position: 'left',
                tooltipClass: 'introJSindex',
              },
              {
                element: document.querySelector('.toolbarActualContainer'),
                intro: Config.getGuidedHelpString('gridTour2'),
                position: 'right',
                tooltipClass: 'introJSindexLarge',
              },
              {
                element: document.querySelector(
                  '.jsTreeContainer.mapDisplayHidden'
                ),
                intro: Config.getGuidedHelpString('gridTour3'),
                position: 'left',
                tooltipClass: 'introJSindexCenter',
              },
              {
                element: document.querySelector('.pseudoButton.iconInfo'),
                intro: Config.getGuidedHelpString('gridTour4'),
                position: 'left',
                tooltipClass: 'introJSindexCenter',
              },
              {
                element: document.querySelector('.resultsDiv'),
                // element: document.querySelector(".ui-jqgrid-htable"),
                intro: Config.getGuidedHelpString('gridTour5'),
                position: 'bottom',
                tooltipClass: 'introJSindexLargeNoDiv',
              },
              {
                element: document.querySelector('#pivotMenu'),
                intro: Config.getGuidedHelpString('gridTour6'),
                position: 'left',
                tooltipClass: 'introJSindexLargeNoDiv',
              },
              {
                element: document.querySelector('.menuButton.iconExport'),
                intro: Config.getGuidedHelpString('gridTour7'),
                position: 'left',
                tooltipClass: 'introJSindexCenter',
              },
              {
                element: document.querySelector('.actionButton'),
                intro: Config.getGuidedHelpString('gridTour8'),
                position: 'left',
                tooltipClass: 'introJSindexCenter',
              },
              {
                element: document.querySelector('.iconBarChart'),
                intro: Config.getGuidedHelpString('gridTour9'),
                position: 'bottom',
                tooltipClass: 'introJSindexMap',
              },
            ],
          })
          .start();

        var introHide = Config.getUniversalString('introHide');

        if ($('#exit').length == 0) {
          $('.introjs-tooltip').append('<div id="exit" class="exit">x</div>');
        }

        $('#exit').click(function () {
          introJs().exit();
        });
        // }
      }
    },
    startTourCol: function () {
      var currLang = Config.getLanguage();
      _currDisplay = statCompilerDashboard.getCurrentDisplayType();

      if (_currDisplay == 'Column') {
        introjsCol = introJs();
        introjsCol._options.skipLabel = Config.getUniversalString('introClose');
        introjsCol._options.nextLabel = Config.getUniversalString('introNext');
        introjsCol._options.prevLabel = Config.getUniversalString('introPrev');
        $('.introjs-overlay').remove();
        introjsCol
          .setOptions({
            showBullets: 'false',
            showStepNumbers: 'false',
            overlayOpacity: 0,
            exitOnEsc: false,
            // "exitOnOverlayClick": "true",
            // "exitOnEsc": "false",
            doneLabel: Config.getUniversalString('iUnderstand'),
            steps: [
              {
                element: document.querySelector('#drawer'), // highcharts-background
                intro: Config.getGuidedHelpString('colTour1'),
                position: 'left',
                tooltipClass: 'introJSindex',
              },
              {
                element: document.querySelector('#optionsMenu'),
                intro: Config.getGuidedHelpString('colTour2'),
                position: 'left',
                tooltipClass: 'introJSindex',
              },
              {
                element: document.querySelector('#exportButton'),
                intro: Config.getGuidedHelpString('colTour3'),
                position: 'left',
                tooltipClass: 'introJSindex',
              },
              {
                element: document.querySelector('.actionButton'),
                intro: Config.getGuidedHelpString('colTour4'),
                position: 'left',
                tooltipClass: 'introJSindex',
              },
              {
                element: document.querySelector('.highcharts-backgrounds'), // highcharts-background
                intro: Config.getGuidedHelpString('colTour5'),
                position: 'bottom',
                tooltipClass: 'introJSindexMapCenter',
              },
              {
                element: document.querySelector('.iconLineChart'),
                intro: Config.getGuidedHelpString('colTour6'),
                position: 'bottom',
                tooltipClass: 'introJSindexMap',
              },
            ],
          })
          .start();

        var introHide = Config.getUniversalString('introHide');
        var introjstooltip = $('.introjs-tooltip');
        if ($('#exit').length == 0) {
          introjstooltip.append('<div id="exit" class="exit">x</div>');
        }

        $('#exit').click(function () {
          introJs().exit();
        });
        // }
      }
    },
    startTourLine: function () {
      var currLang = Config.getLanguage();
      _currDisplay = statCompilerDashboard.getCurrentDisplayType();

      if (_currDisplay == 'Line') {
        introjsCol = introJs();
        introjsCol._options.skipLabel = Config.getUniversalString('introClose');
        introjsCol._options.nextLabel = Config.getUniversalString('introNext');
        introjsCol._options.prevLabel = Config.getUniversalString('introPrev');
        $('.introjs-overlay').remove();
        introjsCol
          .setOptions({
            showBullets: 'false',
            showStepNumbers: 'false',
            overlayOpacity: 0,
            exitOnEsc: false,
            // "exitOnOverlayClick": "true",
            // "exitOnEsc": "false",
            doneLabel: Config.getUniversalString('iUnderstand'),
            steps: [
              {
                element: document.querySelector('#drawer'), // highcharts-background
                intro: Config.getGuidedHelpString('lineTour1'),
                position: 'left',
                tooltipClass: 'introJSindex',
              },
              {
                element: document.querySelector('#optionsMenu'),
                intro: Config.getGuidedHelpString('lineTour2'),
                position: 'left',
                tooltipClass: 'introJSindex',
              },
              {
                element: document.querySelector('#exportButton'),
                intro: Config.getGuidedHelpString('lineTour3'),
                position: 'left',
                tooltipClass: 'introJSindex',
              },
              {
                element: document.querySelector('.actionButton'),
                intro: Config.getGuidedHelpString('lineTour4'),
                position: 'left',
                tooltipClass: 'introJSindex',
              },
              {
                element: document.querySelector('.highcharts-backgrounds'), // highcharts-background
                intro: Config.getGuidedHelpString('lineTour5'),
                position: 'bottom',
                tooltipClass: 'introJSindexMapCenter',
              },
              {
                element: document.querySelector('.iconMap'),
                intro: Config.getGuidedHelpString('lineTour6'),
                position: 'bottom',
                tooltipClass: 'introJSindexMap',
              },
            ],
          })
          .start();

        var introHide = Config.getUniversalString('introHide');
        var introjstooltip = $('.introjs-tooltip');
        if ($('#exit').length == 0) {
          introjstooltip.append('<div id="exit" class="exit">x</div>');
        }

        $('#exit').click(function () {
          introJs().exit();
        });
        // }
      }
    },
    startTourMap: function () {
      var currLang = Config.getLanguage();
      _currDisplay = statCompilerDashboard.getCurrentDisplayType();
      var doneTour =
        localStorage.getItem('neverAgainMap_' + currLang) === 'true';
      if (doneTour) {
        return;
      }
      if (_currDisplay == 'Map') {
        introjsCol = introJs();
        introjsCol._options.skipLabel = Config.getUniversalString('introClose');
        introjsCol._options.nextLabel = Config.getUniversalString('introNext');
        introjsCol._options.prevLabel = Config.getUniversalString('introPrev');
        $('.introjs-overlay').remove();
        introjsCol
          .setOptions({
            showBullets: 'false',
            showStepNumbers: 'false',
            overlayOpacity: 0,
            exitOnEsc: false,
            hideNext: true,
            doneLabel: Config.getUniversalString('iUnderstand'),
            showSkipButton: true,
            steps: [
              {
                element: document.querySelector('.indicatorsSelectWrapper'), // highcharts-background
                intro: Config.getGuidedHelpString('mapTour1'),
                position: 'left',
                tooltipClass: 'introJSindex',
              },
              {
                element: document.querySelector('#mapDiv_zoom_slider'),
                intro: Config.getGuidedHelpString('mapTour2'),
                position: 'right',
                tooltipClass: 'introJSindexMap',
              },
              {
                element: document.querySelector('#subNational'),
                intro: Config.getGuidedHelpString('mapTour3'),
                position: 'bottom-right-aligned',
                tooltipClass: 'introJSindex',
              },
              {
                element: document.querySelector('#breaksContaienr'),
                intro: Config.getGuidedHelpString('mapTour4'),
                position: 'left',
                tooltipClass: 'introJSindex',
              },
              {
                element: document.querySelector('#selectContainer'),
                intro: Config.getGuidedHelpString('mapTour5'),
                position: 'left',
                tooltipClass: 'introJSindex',
              },
              {
                element: document.querySelector('#optionsMenu'),
                intro: Config.getGuidedHelpString('mapTour6'),
                position: 'left',
                tooltipClass: 'introJSindex',
              },
              {
                element: document.querySelector('#exportButton'),
                intro: Config.getGuidedHelpString('mapTour7'),
                position: 'left',
                tooltipClass: 'introJSindex',
              },
              {
                element: document.querySelector('#shareButton'),
                intro: Config.getGuidedHelpString('mapTour8'),
                position: 'left',
                tooltipClass: 'introJSindex',
              },
              {
                element: document.querySelector('#exportsMenuss'),
                intro: Config.getGuidedHelpString('mapTour9'),
                position: 'left',
                tooltipClass: 'introJSindexLargeNoDiv',
              },
            ],
          })
          .start();

        // Adding a checkbox
        var currLang = Config.getLanguage();
        var introHide = Config.getUniversalString('introHide');

        // Close button top right
        if ($('#exit').length == 0) {
          $('.introjs-tooltip').append('<div id="exit" class="exit">x</div>');
        }

        $('#exit').click(function () {
          introJs().exit();
          localStorage.setItem('startedTour_map', false);
        });
      }
    },
    /**
     * @fn exportDataAsCSV
     * @brief 	Saves the data in a database format.
     * @details Saves the data in excel format.
     */

    printMap: function () {
      var indicatorMetatData = nameValueLib.getValueEX(arrIndicatorMetaData, [
        _strSelectedIndicatorCode,
      ]);
      window.loadMapBundle().then(function (mod) {
        var map = mod.default;
        map.printMap(indicatorMetatData);
      });
    },

    exportMap: function () {
      window.loadMapBundle().then(function (mod) {
        var map = mod.default;
        var indicatorMetatData = nameValueLib.getValueEX(arrIndicatorMetaData, [
          _strSelectedIndicatorCode,
        ]);
        map.exportMap(indicatorMetatData, _arrSortedIndicators);
      });
    },
    /**
     * @fn exportDataAsCSV
     * @brief 	Saves the data in a database format.
     * @details Saves the data in excel format.
     */
    exportDataAsDatabaseCSV: function () {
      //Export to Excel in Database format.
      //_arrSortedConfidenceIntervals
      excelExport.exportToExcelAsDatabase(
        _arrSortedCountriesSurveys,
        _arrSortedIndicators,
        _arrSortedByVariableLabels,
        _arrSortedCharLabels,
        _arrValues,
        _arrUnSelectedCountries,
        _arrSortedConfidenceIntervals,
        _arrSortedDenominators
      );
    },
    updateDenominatorBoolenas: function (
      bDisplayWeightedDenominators,
      bDisplayUnweightedDenominators,
      bDisplayTotals,
      bDisplaySpecailIndicators,
      bDisplaySpecailIndicatorsClicked
    ) {
      if (bDisplayWeightedDenominators != undefined) {
        _bDisplayWeightedDenominators = bDisplayWeightedDenominators;
      }

      if (bDisplayUnweightedDenominators != undefined) {
        _bDisplayUnweightedDenominators = bDisplayUnweightedDenominators;
      }

      if (bDisplayTotals != undefined) {
        _bDisplayTotals = bDisplayTotals;
      }
      if (bDisplaySpecailIndicators != undefined) {
        _bDisplaySpecialIndicators = bDisplaySpecailIndicators;
      }

      _bDisplaySpecialIndicatorsClicked = bDisplaySpecailIndicatorsClicked;
    },
    shouldLoadDenominators: function () {
      if (
        _bDisplayWeightedDenominators ||
        _bDisplayUnweightedDenominators ||
        _bDisplayTotals ||
        _bDisplaySpecialIndicators
      ) {
        return true;
      } else {
        return false;
      }
    },
    test: function () {
      eval();
      console.log('Sorted Indicators', _arrSortedIndicators);
      console.log('Sorted Countries', _arrSortedCountriesSurveys);
      console.log('Sorted Values', _arrValues);
      console.log('Sorted Char Labels', _arrSortedCharLabels);
      console.log('Selected Indicator', _strSelectedIndicator);
      console.log('ByVariable', _arrSortedByVariableLabels);
      return;
    },
    testMapLegend: function () {
      //Declare Important Variables.
      var nClasses = 3;
      var nBreakType = mapLegend.BREAK_TYPE.Quantile;
      var nPrecision = nameValueLib.getValue(_arrPrecision, [
        _strSelectedIndicator,
      ]);
      var result;
      //result = mapLegend.calculateBreaks(_arrNationalMapValues, nClasses, nBreakType, nPrecision);
      var gs = new geostats();
      gs.setSerie(_arrSubnationalMapValues);
      gs.setPrecision(1);

      return;
    },
    curMapLevelRank: function (levelRank) {
      _nCurMapLevelRank = levelRank;
    },
    curBreakType: function (breakType) {
      _strCurBreakType = breakType;
    },
    customBreaks: function (customBreaks) {
      _arrCustomBreaks = customBreaks;
    },
    createTotalRegistry: function () {
      _createTotalRegistry();
    },
    getDisplayInit: function () {
      return gridIntroInit;
    },
    openError: function () {
      /*****************************************************************
		function:   openError
		Desc.:      Function to open error dialog if for customPopup.
		return:     void
		*****************************************************************/
      $('#mobileExportsMenu').removeClass('open');
      $('#exportsMenu').removeClass('open');
      $('#optionsMenu').removeClass('open');
      $('#mobileOptionsMenu').removeClass('open');

      addParametersPopup(
        '#errorPopup',
        'error',
        false,
        Config.getUniversalString('Error')
      );
      $('#errorPopup').dialog('open');
    },
  };
})();
